// Auto-generated from home.html. Verbatim redesign import. Do NOT edit.
export const STYLES = `

/* ============================================================
   T-REX NETWORK · DESIGN TOKENS (subset, from tokens.css v2.0)
   ============================================================ */
:root{
  --bone:#FAF8F4; --aubergine:#15102A;
  --champ:#A88B4A; --champ-light:#E8D9B8; --lava:#FF7A33;
  --on-surface-muted:#4F4538; --error:#C2281D;
  --box-fill:#FEFCF8; --box-border:#D8D0C2;

  --champ-glow:#F4E5C2; --champ-rim:#5C4824;
  --champ-night-glow:#FBEFD0;

  --hero-purple-rgb:76,55,120;
  --hero-bronze-rgb:168,107,61;
  --hero-striae-rgb:255,255,255;

  --gradient-champ-day:radial-gradient(ellipse at 30% 30%,var(--champ-glow) 0%,var(--champ) 45%,var(--champ-rim) 100%);
  --gradient-champ-night:radial-gradient(ellipse at 30% 30%,var(--champ-night-glow) 0%,var(--champ-light) 50%,var(--champ) 100%);

  --gradient-hero-purple:radial-gradient(ellipse 70% 60% at 0% 0%,rgba(var(--hero-purple-rgb),0.30),transparent 70%);
  --gradient-hero-bronze:radial-gradient(ellipse 80% 60% at 100% 100%,rgba(var(--hero-bronze-rgb),0.22),transparent 70%);
  --gradient-hero-striae:repeating-linear-gradient(135deg,rgba(var(--hero-striae-rgb),0.014) 0,rgba(var(--hero-striae-rgb),0.014) 1px,transparent 1px,transparent 80px);

  --font-display:'Source Serif 4','Iowan Old Style',Georgia,serif;
  --font-mono:'JetBrains Mono','SF Mono',Menlo,monospace;
  --font-body:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;

  --track-eyebrow:0.10em; --track-mono-caps:0.20em; --track-mono:0.04em; --track-display:-0.025em;

  --container-max:1280px;
  --gutter:clamp(20px,5vw,64px);

  --r:4px; --r-card:8px;

  --ease-out:cubic-bezier(0.22,1,0.36,1);
  --dur-fast:120ms; --dur-base:240ms; --dur-slow:480ms;
}

*{margin:0;padding:0;box-sizing:border-box}
html{scroll-behavior:smooth}
body{font-family:var(--font-body);background:var(--aubergine);color:var(--bone);-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;overflow-x:hidden}

/* ============================================================
   HERO , aubergine + radial bleed (Recipe 05)
   ============================================================ */
.hero{
  position:relative;
  min-height:100svh;
  background-color:var(--aubergine);
  background-image:var(--gradient-hero-striae),var(--gradient-hero-purple),var(--gradient-hero-bronze);
  display:flex;
  flex-direction:column;
  isolation:isolate;
  overflow:hidden;
}
/* hero background animation canvas (sits above the corner glows, below content + grain) */
.hero-bg-canvas{position:absolute;inset:0;width:100%;height:100%;z-index:-1;pointer-events:none}

/* slow living drift on the two corner lights , keeps the ground "alive" without violating the corner rule */
.hero::before,.hero::after{
  content:"";position:absolute;z-index:-1;pointer-events:none;border-radius:50%;
  filter:blur(40px);will-change:transform,opacity;
}
.hero::before{
  width:70vw;height:60vh;top:-10%;left:-12%;
  background:radial-gradient(ellipse at center,rgba(var(--hero-purple-rgb),0.22),transparent 70%);
  animation:drift-purple 22s var(--ease-out) infinite alternate;
}
.hero::after{
  width:80vw;height:60vh;bottom:-12%;right:-12%;
  background:radial-gradient(ellipse at center,rgba(var(--hero-bronze-rgb),0.18),transparent 70%);
  animation:drift-bronze 26s var(--ease-out) infinite alternate;
}
@keyframes drift-purple{from{transform:translate(0,0) scale(1)}to{transform:translate(4%,3%) scale(1.08)}}
@keyframes drift-bronze{from{transform:translate(0,0) scale(1)}to{transform:translate(-3%,-4%) scale(1.1)}}

/* fine grain overlay for material/engraved-paper read */
.hero .grain{
  position:absolute;inset:0;z-index:-1;pointer-events:none;opacity:0.5;mix-blend-mode:overlay;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.035'/%3E%3C/svg%3E");
}

/* ---- top bar ---- */
.topbar{
  position:relative;z-index:3;
  max-width:var(--container-max);width:100%;margin:0 auto;
  padding:clamp(20px,3vw,32px) var(--gutter);
  display:flex;align-items:center;justify-content:space-between;gap:24px;
}
.brand{display:inline-flex;align-items:center;line-height:0}
.wordmark-svg{height:26px;width:auto;display:block}
.brand .wordmark-svg path,.brand .wordmark-svg g{fill:var(--bone)}
.nav{display:flex;align-items:center;gap:clamp(20px,2.4vw,38px)}
.nav a{
  font-family:var(--font-mono);font-size:11px;font-weight:500;letter-spacing:var(--track-eyebrow);
  text-transform:uppercase;color:rgba(250,248,244,0.72);text-decoration:none;
  transition:color var(--dur-fast) var(--ease-out);
}
.nav a:hover{color:var(--bone)}
.nav .nav-link{position:relative}
@media(max-width:860px){.nav .nav-link{display:none}}

/* ---- hero body ---- */
.hero-inner{
  position:relative;z-index:2;
  flex:1;display:flex;align-items:center;
  max-width:var(--container-max);width:100%;margin:0 auto;
  padding:clamp(40px,6vh,96px) var(--gutter) clamp(56px,8vh,112px);
}
.hero-content{max-width:1100px}

.eyebrow{
  font-family:var(--font-mono);font-size:11px;font-weight:500;
  letter-spacing:var(--track-mono-caps);text-transform:uppercase;
  color:var(--champ-light);
  display:inline-flex;align-items:center;gap:12px;
  margin-bottom:clamp(22px,3vh,34px);
}
.eyebrow .dot{
  width:5px;height:5px;border-radius:50%;background:var(--champ-light);
  box-shadow:0 0 0 0 rgba(232,217,184,0.5);
  animation:pulse 3s var(--ease-out) infinite;
}
@keyframes pulse{0%{box-shadow:0 0 0 0 rgba(232,217,184,0.45)}70%{box-shadow:0 0 0 9px rgba(232,217,184,0)}100%{box-shadow:0 0 0 0 rgba(232,217,184,0)}}

h1.headline{
  font-family:var(--font-display);font-weight:400;
  font-size:clamp(38px,5.6vw,76px);
  line-height:1.12;letter-spacing:var(--track-display);
  color:var(--bone);
  margin-bottom:clamp(26px,3.4vh,40px);
  max-width:none;
}
/* Reactive line-splitting for the hero headline:
   - Wide viewports (>= 900px): 2 lines
       Line 1 = "Building the next iteration"
       Line 2 = "of capital markets."
   - Narrow viewports (< 900px): 3 lines
       Line 1 = "Building the"
       Line 2 = "next iteration of"
       Line 3 = "capital markets."
   Nothing is hardcoded to a pixel width , the layout is driven purely by
   which spans are inline vs block at each breakpoint. */
.headline .hd{display:inline}
/* narrow default: hd-1 and hd-4 break to their own lines,
   hd-2 + hd-3 stay inline together in the middle */
.headline .hd-1,.headline .hd-4{display:block}
@media(min-width:900px){
  /* wide: reset so hd-1 flows inline with hd-2, and force a line-break
     BEFORE hd-3 so hd-3 + hd-4 read together on the second line */
  .headline .hd-1,.headline .hd-4{display:inline}
  .headline .hd-3::before{content:"\\A";white-space:pre}
}

/* on narrow viewports, step the headline down so the three-line layout
   stays balanced without overflowing the container */
@media(max-width:760px){ h1.headline{font-size:clamp(32px,8.4vw,52px)} }
@media(max-width:480px){ h1.headline{font-size:clamp(24px,8.6vw,36px)} }

/* mobile hero: centre-aligned, headline stacks per the reactive .hd rules
   above (line-1 "Building the" / line-2 "next iteration of" / line-3
   "capital markets."). */
@media(max-width:760px){
  .hero-content{max-width:none;text-align:center;display:flex;flex-direction:column;align-items:center}
  .eyebrow{justify-content:center}
  .subline{margin-left:auto;margin-right:auto;text-align:center}
  .cta-row{justify-content:center;width:100%}
}

/* cycling word , Stellar-style vertical swap.
   Box is taller than the glyph line (padding top/bottom) so italic
   ascenders/descenders of the previous word never bleed through. */
.cycle{
  position:relative;display:inline-block;
  vertical-align:bottom;
  height:1.16em;
  overflow:hidden;
  transition:width 420ms var(--ease-out);
}
.cycle .track{
  display:block;position:relative;height:100%;width:100%;
}
.cycle .w{
  position:absolute;left:0;bottom:0;
  white-space:nowrap;
  padding:0 0.04em;                  /* tiny side room for italic overhang */
  line-height:1.16em;
  font-style:italic;color:var(--champ-light);
  opacity:0;transform:translateY(0.24em);
  transition:opacity 360ms var(--ease-out),transform 360ms var(--ease-out);
  pointer-events:none;
}
.cycle .w.is-in{opacity:1;transform:none}
.cycle .w.is-out{opacity:0;transform:translateY(-0.24em)}
.cycle .measure{
  position:absolute;visibility:hidden;height:0;overflow:hidden;
  white-space:nowrap;font-style:italic;padding:0 0.04em;
  font-family:var(--font-display);font-weight:400;
}

.subline{
  font-family:var(--font-body);font-weight:400;
  font-size:clamp(17px,1.7vw,21px);line-height:1.5;
  color:rgba(250,248,244,0.80);
  max-width:46ch;
  margin-bottom:clamp(34px,4.4vh,52px);
}
.subline .em{color:var(--bone);font-weight:500}

/* ---- CTAs ---- */
.cta-row{display:flex;flex-wrap:wrap;gap:14px;align-items:center}
.btn{
  font-family:var(--font-mono);font-size:13px;font-weight:500;
  letter-spacing:var(--track-mono);text-decoration:none;
  border-radius:var(--r);padding:15px 26px;
  display:inline-flex;align-items:center;gap:10px;
  cursor:pointer;border:none;position:relative;
  transition:filter var(--dur-fast) var(--ease-out),transform var(--dur-fast) var(--ease-out);
}
.btn:active{transform:translateY(0.5px)}

/* primary , champagne night Mistral radial */
.btn-primary{
  background-image:var(--gradient-champ-night);
  color:var(--aubergine);
  box-shadow:inset 0 1px 0 rgba(255,255,255,0.45),inset 0 -1px 0 rgba(92,72,36,0.55),0 0 24px rgba(232,217,184,0.20);
  transition:background-image var(--dur-base) var(--ease-out),box-shadow var(--dur-base) var(--ease-out),transform var(--dur-fast) var(--ease-out);
}
.btn-primary:hover{
  background-image:radial-gradient(ellipse at 30% 30%,#FFF7E4 0%,#F4E5C2 50%,var(--champ-light) 100%);
  box-shadow:inset 0 1px 0 rgba(255,255,255,0.7),inset 0 -1px 0 rgba(92,72,36,0.5),0 0 36px rgba(244,229,194,0.45);
  transform:translateY(-1px);
}
.btn-primary:active{transform:translateY(0.5px)}

/* secondary , hairline ghost */
.btn-ghost{
  background:rgba(250,248,244,0.02);
  color:var(--bone);
  border:1px solid rgba(250,248,244,0.22);
  box-shadow:inset 0 1px 0 rgba(255,255,255,0.04);
}
.btn-ghost:hover{border-color:rgba(232,217,184,0.55);background:rgba(250,248,244,0.05)}

/* hero accent word (champagne, no italic per mature type direction) */
.headline .accent-word{color:var(--champ-light)}

/* hero proof numbers (above the fold) */
.hero-proof{display:flex;flex-wrap:wrap;gap:clamp(28px,5vw,64px);margin-top:clamp(40px,6vh,64px)}
.hp-item{display:flex;flex-direction:column;gap:6px}
.hp-num{font-family:var(--font-mono);font-size:clamp(22px,2.6vw,30px);font-weight:500;color:var(--bone);letter-spacing:-0.01em}
.hp-label{font-family:var(--font-body);font-size:13px;color:rgba(250,248,244,0.6)}
@media(max-width:640px){.hero-proof{justify-content:center;text-align:center}.hp-item{align-items:center}}

/* scroll hint */
.scroll-hint{
  position:absolute;left:50%;bottom:24px;transform:translateX(-50%);z-index:2;
  font-family:var(--font-mono);font-size:10px;letter-spacing:var(--track-mono-caps);
  text-transform:uppercase;color:rgba(250,248,244,0.4);
  display:flex;flex-direction:column;align-items:center;gap:8px;
}
.scroll-hint .line{width:1px;height:34px;background:linear-gradient(to bottom,rgba(232,217,184,0.6),transparent);animation:scrolldrop 2.2s var(--ease-out) infinite}
@keyframes scrolldrop{0%{transform:scaleY(0);transform-origin:top}40%{transform:scaleY(1);transform-origin:top}60%{transform:scaleY(1);transform-origin:bottom}100%{transform:scaleY(0);transform-origin:bottom}}
@media(max-width:860px){.scroll-hint{display:none}}

/* ============================================================
   STATS , proof of success, bone ground (day register)
   ============================================================ */
.proof{
  background:var(--bone);color:var(--aubergine);
  position:relative;z-index:1;
  padding:clamp(84px,10vh,128px) 0;
  overflow:hidden;
}
.proof-inner{max-width:var(--container-max);margin:0 auto;padding:0 var(--gutter)}
.proof-head{max-width:none}
.proof-kicker{
  font-family:var(--font-mono);font-size:11px;font-weight:500;
  letter-spacing:var(--track-mono-caps);text-transform:uppercase;
  color:var(--champ);margin-bottom:20px;display:inline-block;
}
.proof-head h2{
  font-family:var(--font-display);font-weight:400;
  font-size:clamp(28px,3vw,40px);line-height:1.1;letter-spacing:-0.02em;
  color:var(--aubergine);margin-bottom:18px;
}
@media(min-width:900px){.proof-head h2{white-space:nowrap}}
.proof-head p{
  font-family:var(--font-body);font-size:clamp(15px,1.6vw,18px);line-height:1.6;
  color:var(--on-surface-muted);max-width:60ch;
}
/* partner marquees */
.marquee{margin-top:clamp(48px,7vh,88px);position:relative;overflow:hidden;padding:clamp(14px,1.6vh,20px) 0;
  -webkit-mask-image:linear-gradient(90deg,transparent,#000 8%,#000 92%,transparent);
  mask-image:linear-gradient(90deg,transparent,#000 8%,#000 92%,transparent);}
.marquee + .marquee{margin-top:clamp(28px,3.5vh,48px)}
.marquee-track{display:inline-flex;align-items:center;white-space:nowrap;will-change:transform;animation:mq-scroll 60s linear infinite}
.marquee-rev .marquee-track{animation-direction:reverse;animation-duration:68s}
.marquee:hover .marquee-track{animation-play-state:paused}
.mq-logo{height:clamp(26px,3vw,34px);width:auto;max-width:150px;object-fit:contain;
  margin:0 clamp(30px,4vw,56px);flex:0 0 auto;
  opacity:1;filter:none;transition:opacity .3s,filter .3s}
.mq-logo:hover{opacity:1;filter:brightness(1.05) saturate(1.05)}
@keyframes mq-scroll{from{transform:translateX(0)}to{transform:translateX(-50%)}}
@media(prefers-reduced-motion:reduce){.marquee-track{animation:none}}

/* ============================================================
   ENTRANCE , gentle one-time hero fade-in only.
   Everything is visible by default. The only animation is a soft
   fade on the hero, which plays once on load. No content is ever
   hidden waiting on scroll or JS, so the page always paints correctly.
   ============================================================ */
@keyframes rise{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
.hero .reveal{animation:rise var(--dur-slow) var(--ease-out) both}
.hero .d1{animation-delay:.05s}.hero .d2{animation-delay:.14s}.hero .d3{animation-delay:.24s}.hero .d4{animation-delay:.34s}.hero .d5{animation-delay:.44s}

/* ============================================================
   PILLARS , "One stack. Four pillars." (bone / day register)
   Stripe-style: four cards across, each with a dedicated looping
   animation stage that intensifies on hover.
   ============================================================ */
.pillars{background:var(--bone);color:var(--aubergine);position:relative;z-index:1}
.pillars-inner{
  max-width:var(--container-max);margin:0 auto;
  padding:clamp(84px,10vh,128px) var(--gutter);
}
.pillars-head{max-width:760px;margin-bottom:clamp(40px,5.5vh,72px)}
.pillars-kicker{
  font-family:var(--font-mono);font-size:11px;font-weight:500;
  letter-spacing:var(--track-mono-caps);text-transform:uppercase;
  color:var(--champ);display:inline-flex;align-items:center;gap:12px;
  margin-bottom:clamp(20px,3vh,30px);
}
.pillars-kicker .seal{width:6px;height:6px;background:var(--champ);transform:rotate(45deg)}
.pillars-head h2{
  font-family:var(--font-display);font-weight:400;
  font-size:clamp(34px,4.6vw,58px);line-height:1.06;
  letter-spacing:var(--track-display);color:var(--aubergine);
  margin-bottom:clamp(18px,2.6vh,26px);
}
.pillars-head h2 .accent{color:var(--champ)}
.pillars-head p{
  font-family:var(--font-body);font-size:clamp(16px,1.5vw,19px);
  line-height:1.55;color:var(--on-surface-muted);max-width:60ch;
}

.pillar-grid{
  display:grid;grid-template-columns:repeat(2,1fr);
  gap:clamp(14px,1.4vw,20px);
}
@media(max-width:560px){
  .pillar-grid{grid-template-columns:1fr}
}
.pillars-foot{margin-top:32px;display:flex;justify-content:center}

.pillar{
  position:relative;
  background:var(--box-fill);
  border:1px solid var(--box-border);
  border-radius:var(--r-card);
  display:flex;flex-direction:column;
  overflow:hidden;
  min-height:clamp(220px,26vh,300px);
  transition:border-color var(--dur-base) var(--ease-out),transform var(--dur-base) var(--ease-out),box-shadow var(--dur-base) var(--ease-out);
  will-change:transform;
}
.pillar:hover{
  border-color:rgba(168,139,74,0.55);
  transform:translateY(-6px);
  box-shadow:0 18px 40px -22px rgba(21,16,42,0.35);
}

/* ---- the single morphing particle stage (removed) ---- */
.stack-stage{
  position:relative;
  width:100%;
  height:clamp(320px,42vh,460px);
  margin-top:clamp(28px,3.6vh,44px);
  border-radius:var(--r-card);
  overflow:hidden;
  background:
    radial-gradient(ellipse 70% 80% at 50% 50%,rgba(255,122,51,0.10),transparent 72%),
    linear-gradient(180deg,#FBF8F2 0%,#F4EEE3 100%);
  border:1px solid var(--box-border);
}
.stack-stage canvas{position:absolute;inset:0;width:100%;height:100%;display:block}

/* card image above body */
.pillar-media{
  position:relative;
  z-index:2;
  padding:clamp(22px,2.2vw,36px) clamp(22px,2.2vw,36px) 0;
  display:flex;
  justify-content:flex-start;
  align-items:center;
}
.pillar-media::before{
  content:"";
  position:absolute;
  left:clamp(20px,2vw,44px);
  top:clamp(20px,1.6vw,32px);
  width:clamp(153px,17vw,238px);
  height:clamp(153px,17vw,238px);
  border-radius:50%;
  background:radial-gradient(circle at 50% 50%,
    rgba(232,217,184,0.55) 0%,
    rgba(232,217,184,0.32) 38%,
    rgba(232,217,184,0.0) 68%);
  filter:blur(2px);
  opacity:0;
  transform:scale(0.85);
  transition:opacity var(--dur-base) var(--ease-out),
             transform var(--dur-base) var(--ease-out);
  pointer-events:none;
  z-index:0;
}
.pillar:hover .pillar-media::before,
.pillar.active .pillar-media::before{
  opacity:1;
  transform:scale(1);
}
.pillar-media img{
  position:relative;
  z-index:1;
  width:clamp(153px,17vw,238px);
  height:clamp(153px,17vw,238px);
  object-fit:contain;
  filter:drop-shadow(0 14px 28px rgba(21,16,42,0.20));
  transition:transform var(--dur-base) var(--ease-out),
             filter var(--dur-base) var(--ease-out);
  will-change:transform;
}
.pillar:hover .pillar-media img{
  transform:translateY(-6px) scale(1.05);
  filter:drop-shadow(0 20px 32px rgba(168,139,74,0.35));
}
/* ERC-3643 coin reads visually larger than the other icons — nudge it down
   ~10% so all four cards feel balanced. */
.pillar[data-shape="0"] .pillar-media img,
.pillar[data-shape="0"] .pillar-media::before{
  width:clamp(138px,15.3vw,214px);
  height:clamp(138px,15.3vw,214px);
}

/* Brass divider between the pillar grid and the closing CTA */
.pillars-divider{
  display:flex;
  align-items:center;
  justify-content:center;
  gap:clamp(14px,1.4vw,22px);
  margin:clamp(28px,3vw,44px) auto clamp(20px,2vw,28px);
  max-width:min(560px,64%);
  opacity:0.85;
}
.pillars-divider .pd-rule{
  flex:1;
  height:1px;
  background:linear-gradient(90deg,
    rgba(168,139,74,0) 0%,
    rgba(168,139,74,0.55) 50%,
    rgba(168,139,74,0) 100%);
}
.pillars-divider .pd-mark{
  width:9px;
  height:9px;
  transform:rotate(45deg);
  background:linear-gradient(135deg,#e8d9b8 0%,#c9a34a 60%,#8a6a2f 100%);
  border-radius:2px;
  box-shadow:0 2px 6px rgba(21,16,42,0.18),
             inset 0 1px 0 rgba(255,255,255,0.35);
  flex:0 0 auto;
}

/* Mobile-only downsize for pillar images and divider (source order matters:
   this must come AFTER the base .pillar-media rules to override them). */
@media(max-width:560px){
  .pillar-media img,
  .pillar-media::before{
    width:clamp(102px,27vw,136px);
    height:clamp(102px,27vw,136px);
  }
  .pillars-divider{
    max-width:80%;
    margin:clamp(20px,4vw,28px) auto clamp(16px,3vw,20px);
  }
}

/* card text body */
.pillar-body{padding:clamp(14px,1.2vw,20px) clamp(20px,1.6vw,26px) clamp(20px,1.6vw,26px);display:flex;flex-direction:column;flex:1}
.pillar-kicker{
  font-family:var(--font-mono);font-size:10.5px;font-weight:500;
  letter-spacing:var(--track-mono-caps);text-transform:uppercase;color:var(--champ);
  margin-bottom:12px;display:inline-flex;align-items:center;gap:8px;
}
.pillar-kicker .tick{
  width:5px;height:5px;background:var(--champ);transform:rotate(45deg);flex:0 0 auto;
  transition:transform var(--dur-base) var(--ease-out),box-shadow var(--dur-base) var(--ease-out);
}
.pillar-kicker.lava{color:var(--lava)}.pillar-kicker.lava .tick{background:var(--lava)}
.pillar h3{
  font-family:var(--font-display);font-weight:500;
  font-size:clamp(19px,1.5vw,22px);line-height:1.15;letter-spacing:-0.01em;
  color:var(--aubergine);margin-bottom:8px;
}
.pillar .subtitle{
  font-family:var(--font-body);font-weight:500;font-size:13.5px;line-height:1.4;
  color:var(--aubergine);opacity:0.85;margin-bottom:14px;
}
.pillar .body{
  font-family:var(--font-body);font-size:13.5px;line-height:1.5;font-weight:400;
  color:var(--on-surface-muted);margin-bottom:20px;
}
.pillar .pillar-cta{
  margin-top:auto;
  font-family:var(--font-mono);font-size:11.5px;font-weight:500;letter-spacing:var(--track-mono);
  color:var(--aubergine);text-decoration:none;
  display:inline-flex;align-items:center;gap:7px;
  width:fit-content;padding-bottom:3px;position:relative;
  transition:color var(--dur-fast) var(--ease-out);
}
.pillar .pillar-cta::after{
  content:"";position:absolute;left:0;bottom:0;height:1px;width:100%;
  background:var(--champ);transform:scaleX(0);transform-origin:left;
  transition:transform var(--dur-base) var(--ease-out);
}
.pillar:hover .pillar-cta::after,.pillar.active .pillar-cta::after{transform:scaleX(1)}
.pillar .pillar-cta .chev{transition:transform var(--dur-base) var(--ease-out)}
.pillar:hover .pillar-cta .chev{transform:translateX(4px)}
.pillar .pillar-cta.lava::after{background:var(--lava)}
.pillar:hover .pillar-cta.lava{color:var(--lava)}

/* Soft diagonal warm gradient across each card — champagne top-left,
   cream through the middle, peach bottom-right. Matches the user-supplied
   reference. Uses the ::after layer so we don't disturb border/hover. */
.pillar > .pillar-body{position:relative;z-index:1}
.pillar::after{
  content:"";position:absolute;inset:0;
  background:linear-gradient(135deg,
    #e6d6b8 0%,
    #f5ecd8 22%,
    #faf5ea 48%,
    #fbeadb 74%,
    #fbcda8 100%);
  opacity:1;pointer-events:none;z-index:0;
  transition:opacity var(--dur-base) var(--ease-out);
}
.pillar:hover::after,.pillar.active::after{opacity:1}
/* pillar-4 (Ledger) leans hotter — more peach in the corner */
.pillar[data-shape="3"]::after{
  background:linear-gradient(135deg,
    #ecdcbe 0%,
    #f6ecd6 20%,
    #fbe9d5 55%,
    #fcc6a0 100%);
}

/* the cards act as selectors that drive the graphic above.
   the active card is brought forward; the rest recede (Stripe-style). */
.pillar{cursor:pointer}
.pillar{opacity:0.62;transition:opacity var(--dur-base) var(--ease-out),
        border-color var(--dur-base) var(--ease-out),
        transform var(--dur-base) var(--ease-out),
        box-shadow var(--dur-base) var(--ease-out);}
.pillar.active{
  opacity:1;
  border-color:rgba(168,139,74,0.55);
  box-shadow:0 18px 40px -24px rgba(21,16,42,0.32);
}
.pillar:hover{opacity:1}
.pillar.active .pillar-kicker .tick{box-shadow:0 0 0 3px rgba(168,139,74,0.18)}
.pillar.active .pillar-kicker.lava .tick{box-shadow:0 0 0 3px rgba(255,122,51,0.18)}

/* active progress hairline along the top of the active card */
.pillar::before{
  content:"";position:absolute;left:0;top:0;height:2px;width:100%;
  background:var(--champ);transform:scaleX(0);transform-origin:left;
}
.pillar[data-shape="3"]::before{background:var(--lava)}
.pillar.active::before{animation:pillar-progress 1500ms var(--ease-out) forwards}
@keyframes pillar-progress{from{transform:scaleX(0)}to{transform:scaleX(1)}}

/* pillars card entrance , own keyframe (transform only) so it does NOT
   override the hero's \`rise\` keyframe, which also animates opacity */
@keyframes pillar-rise{to{transform:translateY(0)}}

@media(prefers-reduced-motion:reduce){
  *{animation:none!important;transition:none!important}
  .reveal,.stat,.pillar{opacity:1;transform:none}
  .cycle .track{transition:none}
  .pillar{opacity:1}
}
/* ============================================================
   HOW IT WORKS , steps left, sticky cumulative-build card right
   (bone / day register)
   ============================================================ */
.hiw{background:var(--bone);color:var(--aubergine);position:relative;z-index:1}
.hiw-inner{
  max-width:var(--container-max);margin:0 auto;
  padding:clamp(84px,10vh,128px) var(--gutter);
}
.hiw-head{max-width:820px;margin-bottom:clamp(40px,5.5vh,72px)}
.hiw-kicker{
  font-family:var(--font-mono);font-size:11px;font-weight:500;
  letter-spacing:var(--track-mono-caps);text-transform:uppercase;
  color:var(--champ);display:inline-flex;align-items:center;gap:12px;
  margin-bottom:clamp(20px,3vh,30px);
}
.hiw-kicker .seal{width:6px;height:6px;background:var(--champ);transform:rotate(45deg)}
.hiw-head h2{
  font-family:var(--font-display);font-weight:400;
  font-size:clamp(30px,4.2vw,52px);line-height:1.08;
  letter-spacing:var(--track-display);color:var(--aubergine);max-width:18ch;
}
.hiw-head h2 .accent{color:var(--champ)}
.hiw-lead{margin-top:20px;font-family:var(--font-body);font-size:clamp(15px,1.6vw,18px);line-height:1.65;color:var(--on-surface-muted);max-width:66ch}

.hiw-grid{
  display:grid;grid-template-columns:1fr 1.05fr;
  gap:clamp(40px,5vw,88px);align-items:start;
}
@media(max-width:920px){.hiw-grid{grid-template-columns:1fr;gap:clamp(32px,5vh,48px)}}

/* ---- left: the three steps ---- */
.steps{display:flex;flex-direction:column;gap:clamp(16px,2.4vh,28px)}
.step{
  position:relative;
  border-left:2px solid var(--box-border);
  padding:clamp(18px,2.4vh,26px) 0 clamp(18px,2.4vh,26px) clamp(22px,2.4vw,34px);
  cursor:pointer;opacity:0.5;
  transition:opacity var(--dur-base) var(--ease-out),border-color var(--dur-base) var(--ease-out);
}
.step::before{
  content:"";position:absolute;left:-2px;top:0;bottom:0;width:2px;
  background:var(--champ);transform:scaleY(0);transform-origin:top;
  transition:transform var(--dur-base) var(--ease-out);
}
.step.active{opacity:1}
.step.active::before{transform:scaleY(1)}
.step[data-step="2"].active::before{background:var(--champ)}
.step-kicker{
  font-family:var(--font-mono);font-size:11px;font-weight:500;
  letter-spacing:var(--track-mono-caps);text-transform:uppercase;color:var(--champ);
  display:inline-flex;align-items:center;gap:10px;margin-bottom:12px;
}
.step[data-step="2"] .step-kicker{color:var(--champ)}
.step-kicker .num{
  font-family:var(--font-mono);font-weight:700;font-size:11px;
  color:var(--aubergine);opacity:0.45;
}
.step.active .step-kicker .num{opacity:1;color:inherit}
.step h3{
  font-family:var(--font-display);font-weight:500;
  font-size:clamp(20px,2vw,27px);line-height:1.15;letter-spacing:-0.01em;
  color:var(--aubergine);margin-bottom:10px;
}
.step p{
  font-family:var(--font-body);font-size:14.5px;line-height:1.55;font-weight:400;
  color:var(--on-surface-muted);margin-bottom:18px;max-width:46ch;
}
.step .step-cta{
  font-family:var(--font-mono);font-size:11.5px;font-weight:500;letter-spacing:var(--track-mono);
  color:var(--aubergine);text-decoration:none;
  display:inline-flex;align-items:center;gap:7px;width:fit-content;
  padding-bottom:3px;position:relative;
}
.step .step-cta::after{
  content:"";position:absolute;left:0;bottom:0;height:1px;width:100%;
  background:var(--champ);transform:scaleX(0);transform-origin:left;
  transition:transform var(--dur-base) var(--ease-out);
}
.step[data-step="2"] .step-cta::after{background:var(--champ)}
.step.active .step-cta::after,.step:hover .step-cta::after{transform:scaleX(1)}
.step .step-cta .chev{transition:transform var(--dur-base) var(--ease-out)}
.step.active .step-cta .chev,.step:hover .step-cta .chev{transform:translateX(4px)}

/* ---- right: the sticky cumulative build card ---- */
.hiw-visual{position:sticky;top:clamp(80px,12vh,120px)}
@media(max-width:920px){.hiw-visual{position:relative;top:0}}
.asset-card{
  position:relative;
  background:var(--box-fill);
  border:1px solid var(--box-border);
  border-radius:var(--r-card);
  padding:clamp(20px,2vw,28px);
  overflow:hidden;
  box-shadow:0 20px 50px -30px rgba(21,16,42,0.30);
}
/* subtle animated accent lines layer behind the content */
.asset-card .accent-lines{position:absolute;inset:0;pointer-events:none;opacity:0.5}
.asset-card .accent-lines line{
  stroke:var(--champ);stroke-width:1;opacity:0.18;
  stroke-dasharray:4 8;animation:hiw-flow 6s linear infinite;
}
@keyframes hiw-flow{to{stroke-dashoffset:-120}}

/* card header */
.ac-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:18px;position:relative}
.ac-id{display:flex;align-items:center;gap:12px}
.ac-glyph{
  width:38px;height:38px;border-radius:8px;flex:0 0 auto;
  background-image:var(--gradient-champ-day);
  display:flex;align-items:center;justify-content:center;
  font-family:var(--font-mono);font-weight:700;font-size:13px;color:var(--bone);
  box-shadow:inset 0 1px 0 rgba(255,255,255,0.4),inset 0 -1px 0 rgba(92,72,36,0.5);
}
.ac-name{font-family:var(--font-display);font-weight:600;font-size:16px;color:var(--aubergine);line-height:1.1}
.ac-sub{font-family:var(--font-mono);font-size:10px;letter-spacing:0.08em;color:var(--on-surface-muted);text-transform:uppercase;margin-top:3px}
.ac-badge{
  font-family:var(--font-mono);font-size:9.5px;font-weight:500;letter-spacing:0.12em;text-transform:uppercase;
  color:var(--champ);border:1px solid rgba(168,139,74,0.4);border-radius:4px;padding:4px 8px;white-space:nowrap;
}

/* generic reveal-able card rows: hidden until their layer is on */
.ac-layer{
  max-height:0;opacity:0;overflow:hidden;
  transform:translateY(8px);
  transition:max-height var(--dur-slow) var(--ease-out),
             opacity var(--dur-base) var(--ease-out),
             transform var(--dur-base) var(--ease-out),
             margin var(--dur-base) var(--ease-out);
}
.ac-layer.on{max-height:520px;opacity:1;transform:translateY(0);padding-bottom:6px}

/* rows / chips */
.ac-rows{display:flex;flex-direction:column;gap:8px}
.ac-row{
  display:flex;align-items:center;justify-content:space-between;
  background:var(--bone);border:1px solid var(--box-border);border-radius:6px;
  padding:10px 12px;
}
.ac-row .lbl{font-family:var(--font-mono);font-size:10.5px;letter-spacing:0.06em;color:var(--on-surface-muted);text-transform:uppercase}
.ac-row .val{font-family:var(--font-mono);font-size:11.5px;font-weight:500;color:var(--aubergine);display:inline-flex;align-items:center;gap:7px}
.ac-row .ok{width:6px;height:6px;border-radius:50%;background:var(--champ)}
.ac-section-label{
  font-family:var(--font-mono);font-size:9.5px;letter-spacing:0.16em;text-transform:uppercase;
  color:var(--on-surface-muted);margin:16px 0 10px;display:flex;align-items:center;gap:8px;
}
.ac-section-label::after{content:"";flex:1;height:1px;background:var(--box-border)}

/* identifiers grid (step 2) */
.ac-ids{display:grid;grid-template-columns:repeat(3,1fr);gap:8px}
.ac-idcell{background:var(--bone);border:1px solid var(--box-border);border-radius:6px;padding:10px}
.ac-idcell .k{font-family:var(--font-mono);font-size:9px;letter-spacing:0.1em;color:var(--on-surface-muted);text-transform:uppercase}
.ac-idcell .v{font-family:var(--font-mono);font-size:12px;font-weight:500;color:var(--aubergine);margin-top:5px}
.ac-sync{display:flex;align-items:center;gap:8px;margin-top:14px;margin-bottom:18px;font-family:var(--font-mono);font-size:10.5px;color:var(--on-surface-muted)}
.ac-sync .pulse{width:7px;height:7px;border-radius:50%;background:var(--champ);box-shadow:0 0 0 0 rgba(168,139,74,0.5);animation:hiw-pulse 2.4s var(--ease-out) infinite}
@keyframes hiw-pulse{0%{box-shadow:0 0 0 0 rgba(168,139,74,0.5)}70%{box-shadow:0 0 0 8px rgba(168,139,74,0)}100%{box-shadow:0 0 0 0 rgba(168,139,74,0)}}
.ac-ops{display:flex;gap:6px;margin-top:10px;flex-wrap:wrap}
.ac-op{font-family:var(--font-mono);font-size:10px;letter-spacing:0.06em;text-transform:uppercase;color:var(--champ);border:1px solid rgba(168,139,74,0.35);border-radius:4px;padding:4px 9px}

/* app connectors (step 3) */
.ac-apps{display:grid;grid-template-columns:repeat(3,1fr);gap:8px}
.ac-app{
  background:var(--bone);border:1px solid var(--box-border);border-radius:6px;
  padding:11px 8px;text-align:center;
  display:flex;flex-direction:column;align-items:center;gap:7px;
  opacity:0;transform:translateY(6px);
  transition:opacity var(--dur-base) var(--ease-out),transform var(--dur-base) var(--ease-out),border-color var(--dur-base) var(--ease-out);
}
.ac-layer.on .ac-app{opacity:1;transform:translateY(0)}
.ac-layer.on .ac-app:nth-child(1){transition-delay:.04s}
.ac-layer.on .ac-app:nth-child(2){transition-delay:.10s}
.ac-layer.on .ac-app:nth-child(3){transition-delay:.16s}
.ac-layer.on .ac-app:nth-child(4){transition-delay:.22s}
.ac-layer.on .ac-app:nth-child(5){transition-delay:.28s}
.ac-layer.on .ac-app:nth-child(6){transition-delay:.34s}
.ac-app .ic{width:24px;height:24px;display:flex;align-items:center;justify-content:center}
.ac-app .ic svg{width:22px;height:22px;display:block}
.ac-app .ic svg *{stroke:var(--lava);fill:none;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round}
.ac-app .ic svg .fill{fill:var(--lava);stroke:none}
.ac-app .nm{font-family:var(--font-mono);font-size:9px;letter-spacing:0.05em;text-transform:uppercase;color:var(--on-surface-muted);line-height:1.2}

/* progress dots above the card */
.ac-progress{display:flex;gap:6px;margin-bottom:16px;align-items:center}
.ac-progress .pd{width:24px;height:3px;border-radius:2px;background:var(--box-border);overflow:hidden;position:relative}
.ac-progress .pd::after{content:"";position:absolute;inset:0;background:var(--champ);transform:scaleX(0);transform-origin:left;transition:transform var(--dur-base) var(--ease-out)}
.ac-progress .pd.done::after,.ac-progress .pd.cur::after{transform:scaleX(1)}
.ac-progress .pd:nth-child(3).cur::after{background:var(--champ)}
.ac-progress .step-name{margin-left:10px;font-family:var(--font-mono);font-size:10px;letter-spacing:0.12em;text-transform:uppercase;color:var(--on-surface-muted)}

/* section reveal */

@media(prefers-reduced-motion:reduce){
  .asset-card .accent-lines line,.ac-sync .pulse{animation:none}
  .hiw .reveal,.hiw .hiw-visual{opacity:1;transform:none}
}

/* ============================================================
   WHO IT'S FOR , expanding panels, hero/aubergine register
   Institutions open by default; others collapse to a spine.
   ============================================================ */
.whofor{
  position:relative;z-index:1;
  background-color:var(--aubergine);
  background-image:var(--gradient-hero-striae),var(--gradient-hero-purple),var(--gradient-hero-bronze);
  color:var(--bone);overflow:hidden;
}
.whofor-inner{
  max-width:var(--container-max);margin:0 auto;
  padding:clamp(84px,10vh,128px) var(--gutter);
}
.whofor-head{max-width:880px;margin-bottom:clamp(36px,5vh,64px)}
.whofor-kicker{
  font-family:var(--font-mono);font-size:11px;font-weight:500;
  letter-spacing:var(--track-mono-caps);text-transform:uppercase;
  color:var(--champ-light);display:inline-flex;align-items:center;gap:12px;
  margin-bottom:clamp(20px,3vh,28px);
}
.whofor-kicker .seal{width:6px;height:6px;background:var(--champ-light);transform:rotate(45deg)}
.whofor-head h2{
  font-family:var(--font-display);font-weight:400;
  font-size:clamp(30px,4.2vw,54px);line-height:1.08;
  letter-spacing:var(--track-display);color:var(--bone);max-width:20ch;
}
.whofor-head h2 .accent{color:var(--champ-light)}
.whofor-sub{margin-top:18px;font-family:var(--font-body);font-size:clamp(15px,1.6vw,18px);line-height:1.6;color:rgba(250,248,244,0.72);max-width:60ch}

/* the expanding panel row , CSS Grid so column widths interpolate smoothly.
   grid-template-columns transitions cleanly (no per-item pixel-rounding shake
   that flex grow/basis produces). the active column takes the large fraction. */
.panels{
  display:grid;
  grid-template-columns:1fr 1fr 1fr;     /* fallback / equal before JS */
  gap:clamp(12px,1.4vw,18px);
  min-height:clamp(340px,52vh,460px);
  transition:grid-template-columns 600ms var(--ease-out);
}
/* which column is wide depends on the active child */
.panels:has(.panel:nth-child(1).active){grid-template-columns:6fr 2fr 2fr}
.panels:has(.panel:nth-child(2).active){grid-template-columns:2fr 6fr 2fr}
.panels:has(.panel:nth-child(3).active){grid-template-columns:2fr 2fr 6fr}

@media(max-width:820px){
  .panels{display:flex;flex-direction:column;min-height:0;gap:14px;transition:none}
  .panel,.panel.active{flex:none;flex-basis:auto}
  /* stacked = no accordion: show every panel's full content */
  .panel-spine{display:none}
  .panel-content,.panel:not(.active) .panel-content{position:static;display:flex;opacity:1;transform:none;visibility:visible;pointer-events:auto;width:auto;max-width:none}
  .panel .motif{opacity:1;transform:none;width:46%;max-width:180px}
}

.panel{
  position:relative;
  min-width:0;            /* allow the grid column to size the panel */
  border:1px solid rgba(250,248,244,0.12);
  border-radius:var(--r-card);
  background:rgba(250,248,244,0.02);
  overflow:hidden;cursor:pointer;
  transition:background 380ms var(--ease-out),
             border-color 380ms var(--ease-out);
}
.panel.active{
  background:rgba(250,248,244,0.045);border-color:rgba(232,217,184,0.42);
}

/* the architectural motif drawn behind each panel , small, soft, corner-set */
.panel .motif{
  position:absolute;right:0;bottom:0;
  width:54%;max-width:240px;aspect-ratio:1/1;
  pointer-events:none;
  opacity:0;transform:scale(0.94);
  transform-origin:bottom right;
  transition:opacity 640ms var(--ease-out),transform 640ms var(--ease-out);
  /* feather the top-left edge so the motif never crowds the text */
  -webkit-mask-image:radial-gradient(120% 120% at 100% 100%, #000 38%, transparent 82%);
  mask-image:radial-gradient(120% 120% at 100% 100%, #000 38%, transparent 82%);
}
.panel.active .motif{opacity:1;transform:scale(1)}
.panel .motif svg{position:absolute;inset:0;width:100%;height:100%;display:block}
.panel .motif svg *{stroke:var(--champ-light);fill:none;stroke-width:1;vector-effect:non-scaling-stroke}
.panel .motif svg .dim{opacity:0.12}
.panel .motif svg .mid{opacity:0.24}
.panel .motif svg :not(.dim):not(.mid){opacity:0.34}

/* panel inner layout */
.panel-inner{
  position:relative;z-index:2;height:100%;
  padding:clamp(22px,2vw,32px);
  display:flex;flex-direction:column;
}
.panel-num{
  font-family:var(--font-mono);font-weight:700;font-size:12px;
  letter-spacing:var(--track-mono-caps);color:var(--champ-light);
  margin-bottom:14px;
}
/* collapsed label , the vertical spine */
.panel-spine{
  font-family:var(--font-display);font-weight:500;
  font-size:clamp(26px,2.3vw,34px);letter-spacing:-0.01em;color:var(--bone);
  white-space:nowrap;
  writing-mode:vertical-rl;transform:rotate(180deg);
  margin-top:6px;opacity:0.92;
  transition:opacity var(--dur-base) var(--ease-out);
}
@media(max-width:820px){.panel-spine{writing-mode:horizontal-tb;transform:none}}
.panel.active .panel-spine{display:none}

/* expanded content , hidden until active */
.panel-content{
  /* absolutely positioned inside the padded inner box so it never pushes the
     spine and never reflows; fixed width keeps the text shape constant. */
  position:absolute;
  left:clamp(22px,2vw,32px);right:clamp(22px,2vw,32px);
  top:clamp(22px,2vw,32px);bottom:clamp(22px,2vw,32px);
  display:flex;flex-direction:column;
  /* fixed width so the text NEVER reflows/squishes while the panel is narrow.
     the collapsed panel's overflow:hidden simply clips it; as the panel widens
     the same laid-out text is revealed, so there's no left-aligned flash. */
  width:clamp(220px,24vw,300px);right:auto;
  opacity:0;transform:translateY(8px);
  visibility:hidden;
  transition:opacity 360ms var(--ease-out) 200ms,
             transform 360ms var(--ease-out) 200ms,
             visibility 0ms linear 200ms;
  pointer-events:none;
}
.panel.active .panel-content{
  opacity:1;transform:translateY(0);visibility:visible;pointer-events:auto;
  transition:opacity 420ms var(--ease-out) 200ms,
             transform 420ms var(--ease-out) 200ms,
             visibility 0ms linear 0ms;
}

.panel-eyebrow{
  font-family:var(--font-mono);font-size:10.5px;font-weight:500;
  letter-spacing:var(--track-mono-caps);text-transform:uppercase;color:var(--champ-light);
  margin-bottom:14px;
}
.panel-content h3{
  font-family:var(--font-display);font-weight:500;
  font-size:clamp(24px,2.4vw,34px);line-height:1.1;letter-spacing:-0.015em;
  color:var(--bone);margin-bottom:16px;
}
.panel-content p{
  font-family:var(--font-body);font-size:15px;line-height:1.6;
  color:rgba(250,248,244,0.78);margin-bottom:auto;
}
.panel-cta{
  margin-top:28px;align-self:flex-start;
  font-family:var(--font-mono);font-size:12px;font-weight:500;letter-spacing:var(--track-mono);
  color:var(--aubergine);text-decoration:none;
  display:inline-flex;align-items:center;gap:9px;
  padding:12px 22px;border-radius:var(--r);
  background-image:var(--gradient-champ-night);
  box-shadow:inset 0 1px 0 rgba(255,255,255,0.45),inset 0 -1px 0 rgba(92,72,36,0.5),0 0 22px rgba(232,217,184,0.18);
  transition:filter var(--dur-fast) var(--ease-out),transform var(--dur-fast) var(--ease-out);
}
.panel-cta:hover{filter:brightness(1.05);transform:translateY(-1px)}
.panel-cta .chev{transition:transform var(--dur-base) var(--ease-out)}
.panel-cta:hover .chev{transform:translateX(3px)}

/* number badge stays visible in both states, top-left */
/* section reveal */

@media(prefers-reduced-motion:reduce){
  .whofor .reveal,.whofor .panels .panel{opacity:1;transform:none}
  .panel{transition:none}
}

/* ============================================================
   MOBILE PASS , phones & small tablets
   Cards/panels stack vertically; heavy or hover-only motion is
   simplified or hidden; spacing and type scale down.
   ============================================================ */
@media(max-width:760px){
  /* tighten section padding everywhere */
  .proof-inner,.pillars-inner,.hiw-inner,.whofor-inner{padding-left:var(--gutter);padding-right:var(--gutter)}

  /* ---------- HERO ---------- */
  .hero-inner{padding-top:clamp(28px,8vh,56px);padding-bottom:clamp(40px,8vh,72px)}
  .cta-row{gap:10px}
  .cta-row .btn{flex:1 1 auto;justify-content:center;min-width:48%}
  /* the slow drifting corner-light blurs are GPU-heavy on phones , calm them */
  .hero::before,.hero::after{animation:none;filter:blur(28px)}
  .hero .grain{opacity:0.35}

  /* ---------- PROOF OF SUCCESS ---------- */
  /* already handled by existing 900/520 rules; just ensure comfortable rhythm */
  .stat .figure{font-size:clamp(38px,11vw,56px)}

  /* ---------- WHAT T-REX BUILDS ---------- */
  /* cards already stack at 560px; hide the morphing graphic entirely on phones */
  .stack-stage{display:none}

  /* ---------- HOW IT WORKS ---------- */
  .hiw-visual{position:relative;top:0}          /* unstick the card */
  .ac-ids{grid-template-columns:repeat(3,1fr)}
  .ac-apps{grid-template-columns:repeat(3,1fr)}
  .step p{max-width:none}

  /* ---------- WHO IT'S FOR ---------- */
  /* drop the accordion: every panel shows its full content as a stacked card */
  .panels{display:flex;flex-direction:column;min-height:0;gap:14px;grid-template-columns:none;transition:none}
  .panel,.panel.active{flex:none;flex-basis:auto;background:rgba(250,248,244,0.03);border-color:rgba(250,248,244,0.14)}
  .panel.active{border-color:rgba(232,217,184,0.30)}
  .panel-spine{display:none}                    /* no vertical spine on mobile */
  .panel-content{position:static !important;display:flex !important;opacity:1 !important;transform:none !important;visibility:visible !important;pointer-events:auto;width:auto;max-width:none}
  .panel:not(.active) .panel-content{display:flex}
  .panel .motif{width:42%;max-width:150px;opacity:1;transform:none}
  .panel-inner{min-height:0}
}

@media(max-width:480px){
  /* single-column everything, smaller identifiers grid */
  .ac-ids{grid-template-columns:1fr 1fr}
  .ac-apps{grid-template-columns:1fr 1fr}
  .cta-row .btn{min-width:100%}
  .whofor-head h2,.hiw-head h2,.pillars-head h2{max-width:none}
  .pillar-grid{grid-template-columns:1fr}
}

/* touch devices: the canvas in 'What T-REX builds' is hover-driven.
   ensure tapping a card still switches the graphic (handled in JS via click). */
@media(hover:none){
  .pillar{opacity:1}        /* don't dim cards when hover isn't available */
}

/* ============================================================
   THE APEX COMMITMENT , "the monument". The giant counting numeral
   is the centrepiece; everything else defers to it. bone / day register.
   ============================================================ */
.apex{background:var(--bone);color:var(--aubergine);position:relative;z-index:1;overflow:hidden}
.apex-inner{
  max-width:1180px;margin:0 auto;
  padding:clamp(84px,10vh,128px) var(--gutter);
  text-align:center;
  display:flex;flex-direction:column;align-items:center;
}

/* small deferential kicker above the number */
.apex-kicker{
  font-family:var(--font-mono);font-size:11px;font-weight:500;
  letter-spacing:var(--track-mono-caps);text-transform:uppercase;color:var(--champ);
  display:inline-flex;align-items:center;gap:12px;
  margin-bottom:clamp(28px,5vh,56px);
}
.apex-kicker .seal{width:6px;height:6px;background:var(--champ);transform:rotate(45deg)}

/* THE NUMBER , the monument */
.apex-figure{position:relative;display:flex;flex-direction:column;align-items:center}
.apex-title{font-family:var(--font-display);font-weight:400;font-size:clamp(22px,2.6vw,34px);line-height:1.15;letter-spacing:-0.02em;color:var(--aubergine);text-align:center;margin-bottom:clamp(20px,3vh,32px)}
.apex-number{
  font-family:var(--font-display);font-weight:500;
  font-size:clamp(44px,12vw,200px);line-height:0.92;letter-spacing:-0.035em;
  color:var(--aubergine);
  font-variant-numeric:tabular-nums;font-feature-settings:"tnum" 1;
  white-space:nowrap;
  display:inline-flex;align-items:baseline;justify-content:center;
}
.apex-number .cur{color:var(--champ);font-style:italic;margin-right:0.03em}

/* soft champagne glow behind the number */
.apex-figure::before{
  content:"";position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);
  width:min(110%,1100px);height:clamp(200px,40vh,460px);
  background:radial-gradient(ellipse 55% 60% at 50% 50%,rgba(168,139,74,0.12),transparent 72%);
  pointer-events:none;z-index:-1;
}

/* deferential supporting copy + CTA beneath the monument */
.apex-support{
  margin-top:clamp(40px,6vh,72px);
  display:flex;flex-direction:column;align-items:center;gap:clamp(20px,3vh,30px);
  max-width:60ch;
}
.apex-support p{
  font-family:var(--font-body);font-size:clamp(15px,1.45vw,18px);line-height:1.6;
  color:var(--on-surface-muted);
}
.apex-support p strong{color:var(--aubergine);font-weight:600}
.apex-cta{
  font-family:var(--font-mono);font-size:13px;font-weight:500;letter-spacing:var(--track-mono);
  color:var(--aubergine);text-decoration:none;
  display:inline-flex;align-items:center;gap:10px;
  padding:15px 26px;border-radius:var(--r);
  /* Same paint stack as .btn-primary — the "Read our technical documentation"
     button used as reference by the user. */
  background-image:var(--gradient-champ-night);
  box-shadow:inset 0 1px 0 rgba(255,255,255,0.45),inset 0 -1px 0 rgba(92,72,36,0.55),0 0 24px rgba(232,217,184,0.20);
  transition:filter var(--dur-fast) var(--ease-out),transform var(--dur-fast) var(--ease-out),box-shadow var(--dur-base) var(--ease-out);
}
.apex-cta:hover{
  filter:brightness(1.06);
  transform:translateY(-1px);
  box-shadow:inset 0 1px 0 rgba(255,255,255,0.5),inset 0 -1px 0 rgba(92,72,36,0.6),0 0 36px rgba(232,217,184,0.32);
}


@media(max-width:480px){
  .apex-number{font-size:clamp(30px,11vw,52px)}
}


/* ============================================================
   CLOSING CTA , centred, aubergine hero register.
   ============================================================ */
.closer{
  position:relative;z-index:1;
  background-color:#15102A;
  background-image:none;
  color:var(--bone);overflow:hidden;
}
.closer-inner{
  max-width:1000px;margin:0 auto;
  padding:clamp(84px,10vh,128px) var(--gutter);
  text-align:center;
  display:flex;flex-direction:column;align-items:center;
}
.closer h2{
  font-family:var(--font-display);font-weight:400;
  font-size:clamp(30px,4.6vw,60px);line-height:1.08;letter-spacing:var(--track-display);
  color:var(--bone);max-width:none;
  margin:0 0 clamp(36px,5vh,56px);
}
.closer h2 .accent{color:var(--champ-light)}
.closer .cta-row{justify-content:center}
@media(max-width:600px){
  .closer h2{font-size:clamp(26px,7.4vw,40px)}
}





/* ===== T-REX global chrome (scoped, self-contained) ===== */
.tgn,.tgf{--tgc-aub:#15102A;--tgc-aub2:#1A1531;--tgc-aub3:#221A42;--tgc-bone:#FAF8F4;
  --tgc-champ:#A88B4A;--tgc-champL:#E8D9B8;--tgc-lava:#FF7A33;
  font-family:'Inter',system-ui,-apple-system,Segoe UI,Roboto,sans-serif;box-sizing:border-box;}
.tgn *,.tgf *{box-sizing:border-box;}
.tgn{position:sticky;top:0;z-index:1000;background:rgba(21,16,42,0.90);
  -webkit-backdrop-filter:saturate(140%) blur(14px);backdrop-filter:saturate(140%) blur(14px);
  border-bottom:1px solid rgba(232,217,184,0.12);}
.tgn-bar{max-width:1240px;margin:0 auto;height:60px;padding:0 clamp(18px,4vw,40px);
  display:flex;align-items:center;justify-content:space-between;gap:24px;}
.tgn-brand{display:inline-flex;align-items:center;line-height:0;flex:0 0 auto;}
.tgn-wordmark{height:24px;width:auto;display:block;}
.tgn-links{display:flex;align-items:center;gap:clamp(6px,1.4vw,18px);}
.tgn-item{position:relative;display:flex;align-items:center;height:60px;}
.tgn-link{display:inline-flex;align-items:center;gap:5px;color:rgba(250,248,244,0.74);
  text-decoration:none;font-size:14px;font-weight:500;letter-spacing:.01em;padding:6px 4px;
  transition:color .18s ease;}
.tgn-link:hover,.tgn-item:hover .tgn-link{color:var(--tgc-bone);}
.tgn-link.tgn-active{color:var(--tgc-bone);}
.tgn-caret{font-size:9px;opacity:.7;transition:transform .2s ease;}
.tgn-item:hover .tgn-caret{transform:translateY(1px);}
.tgn-ext{font-size:11px;opacity:.7;}
.tgn-menu{position:absolute;top:58px;left:-14px;min-width:280px;padding:8px;
  background:var(--tgc-aub2);border:1px solid rgba(232,217,184,0.14);border-radius:12px;
  box-shadow:0 24px 60px -20px rgba(0,0,0,0.7);opacity:0;visibility:hidden;transform:translateY(6px);
  transition:opacity .18s ease,transform .18s ease,visibility .18s;}
.tgn-has-menu:hover .tgn-menu{opacity:1;visibility:visible;transform:translateY(0);}
.tgn-menu a{display:flex;flex-direction:column;gap:2px;padding:10px 12px;border-radius:8px;
  text-decoration:none;transition:background .15s ease;}
.tgn-menu a span{color:var(--tgc-bone);font-size:14px;font-weight:600;}
.tgn-menu a small{color:rgba(250,248,244,0.55);font-size:12px;font-weight:400;}
.tgn-menu a:hover{background:var(--tgc-aub3);}
.tgn-actions{display:flex;align-items:center;gap:12px;flex:0 0 auto;}
.tgn-cta{display:inline-flex;align-items:center;text-decoration:none;font-size:13.5px;font-weight:600;
  color:var(--tgc-aub);padding:9px 18px;border-radius:9px;white-space:nowrap;
  background:linear-gradient(180deg,#F4E9CF 0%,var(--tgc-champL) 100%);
  box-shadow:0 1px 0 rgba(255,255,255,0.4) inset,0 6px 18px -8px rgba(232,217,184,0.5);
  transition:transform .16s ease,box-shadow .16s ease;}
.tgn-cta:hover{transform:translateY(-1px);box-shadow:0 10px 24px -10px rgba(232,217,184,0.7);}
.tgn-burger{display:none;flex-direction:column;justify-content:center;gap:4px;width:40px;height:38px;
  background:transparent;border:1px solid rgba(232,217,184,0.22);border-radius:9px;cursor:pointer;padding:0 9px;}
.tgn-burger span{display:block;height:2px;width:100%;background:var(--tgc-bone);border-radius:2px;transition:transform .2s ease,opacity .2s ease;}
.tgn.tgn-open .tgn-burger span:nth-child(1){transform:translateY(6px) rotate(45deg);}
.tgn.tgn-open .tgn-burger span:nth-child(2){opacity:0;}
.tgn.tgn-open .tgn-burger span:nth-child(3){transform:translateY(-6px) rotate(-45deg);}
.tgn-panel{display:none;flex-direction:column;padding:10px clamp(18px,4vw,40px) 22px;
  background:var(--tgc-aub);border-top:1px solid rgba(232,217,184,0.1);gap:2px;}
.tgn.tgn-open .tgn-panel{display:flex;}
.tgn-acc{border-bottom:1px solid rgba(232,217,184,0.08);}
.tgn-acc summary{list-style:none;cursor:pointer;color:var(--tgc-bone);font-size:15px;font-weight:600;
  padding:14px 2px;display:flex;justify-content:space-between;align-items:center;}
.tgn-acc summary::-webkit-details-marker{display:none;}
.tgn-acc summary::after{content:"+";color:var(--tgc-champL);font-size:18px;}
.tgn-acc[open] summary::after{content:"\\2212";}
.tgn-acc a{display:block;color:rgba(250,248,244,0.7);text-decoration:none;font-size:14px;padding:9px 2px 9px 14px;}
.tgn-acc a:hover{color:var(--tgc-bone);}
.tgn-plink{display:block;color:var(--tgc-bone);text-decoration:none;font-size:15px;font-weight:600;
  padding:14px 2px;border-bottom:1px solid rgba(232,217,184,0.08);}
.tgn-pcta{display:block;text-align:center;margin-top:16px;text-decoration:none;font-size:14.5px;font-weight:600;
  color:var(--tgc-aub);padding:13px 18px;border-radius:10px;
  background:linear-gradient(180deg,#F4E9CF 0%,var(--tgc-champL) 100%);}
@media(max-width:900px){
  .tgn-links{display:none;}
  .tgn-burger{display:flex;}
  .tgn-cta{display:none;}
}
.tgf{background:var(--tgc-aub);color:rgba(250,248,244,0.72);border-top:1px solid rgba(232,217,184,0.1);}
.tgf-inner{max-width:1240px;margin:0 auto;padding:64px clamp(18px,4vw,40px) 40px;}
.tgf-wordmark{height:26px;width:auto;display:block;margin-bottom:18px;}
.tgf-tag{font-size:15px;line-height:1.5;color:rgba(250,248,244,0.7);max-width:320px;margin:0 0 20px;}
.tgf-cta{display:inline-block;color:var(--tgc-champL);text-decoration:none;font-size:14px;font-weight:600;}
.tgf-cta:hover{color:var(--tgc-bone);}
.tgf-cols{display:grid;grid-template-columns:repeat(4,1fr);gap:28px;}
.tgf-col h4{color:var(--tgc-bone);font-size:12px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;margin:0 0 14px;}
.tgf-col a{display:block;color:rgba(250,248,244,0.6);text-decoration:none;font-size:14px;padding:6px 0;transition:color .15s ease;}
.tgf-col a:hover{color:var(--tgc-bone);}
.tgf-top{display:grid;grid-template-columns:1.3fr 2fr;gap:48px;}
.tgf-base{display:flex;justify-content:space-between;align-items:flex-start;gap:24px;flex-wrap:wrap;
  margin-top:48px;padding-top:24px;border-top:1px solid rgba(232,217,184,0.1);}
.tgf-base p{margin:0;font-size:12.5px;color:rgba(250,248,244,0.5);}
.tgf-legal{max-width:560px;text-align:right;}
@media(max-width:820px){
  .tgf-top{grid-template-columns:1fr;gap:36px;}
  .tgf-cols{grid-template-columns:repeat(2,1fr);}
  .tgf-base{flex-direction:column;}
  .tgf-legal{text-align:left;}
}



/* unify section headings + section rhythm (design consistency) */
.proof-head h2,.pillars-head h2,.hiw-head h2,.whofor-head h2,.closer h2{
  font-size:clamp(30px,4vw,48px)!important;line-height:1.14!important;letter-spacing:-0.015em;max-width:min(100%,760px)!important}
.proof,.pillars-inner,.hiw-inner,.whofor-inner,.apex-inner,.closer-inner{
  padding-top:clamp(52px,6.5vh,80px)!important;padding-bottom:clamp(52px,6.5vh,80px)!important}
.proof-head h2 .accent{color:var(--champ)}
.apex-title .accent{color:var(--champ)}



/* uniform section gap on every page (fixed px, no vh/rem drift) */
.section,.surface-day,.surface-night,
.proof,.pillars-inner,.hiw-inner,.whofor-inner,.apex-inner,.closer-inner,
.missing-layer .ml-inner,.market .market-inner{
  padding-top:80px!important;padding-bottom:80px!important}
@media(max-width:768px){
.section,.surface-day,.surface-night,
.proof,.pillars-inner,.hiw-inner,.whofor-inner,.apex-inner,.closer-inner,
.missing-layer .ml-inner,.market .market-inner{
  padding-top:52px!important;padding-bottom:52px!important}}

/* ============================================================
   MISSING LAYER , centred aubergine narrative block.
   Background mirrors the Learn page hero (.ix-hero-night):
   champagne top-left glow + orange bottom-right glow on aubergine.
   Padding is intentionally more generous than default section padding
   so the block breathes as a standalone editorial pause.
   ============================================================ */
.missing-layer{
  position:relative;z-index:1;overflow:hidden;
  background-color:var(--bone);
  background-image:linear-gradient(180deg,
    rgba(255,122,51,0) 0%,
    rgba(255,122,51,0) 10%,
    rgba(255,122,51,0.10) 100%);
  color:var(--aubergine);
}
.missing-layer .ml-inner{
  position:relative;z-index:1;
  max-width:var(--container-max);margin:0 auto;
  padding:0 var(--gutter);
  display:flex;flex-direction:column;align-items:stretch;
}
.missing-layer .ml-headline{
  font-family:var(--font-display);font-weight:400;
  font-size:clamp(30px,4vw,48px);line-height:1.14;letter-spacing:-0.015em;
  color:var(--aubergine);max-width:22ch;margin:0 auto;
}
.missing-layer .ml-em{
  font-style:italic;color:var(--champ);font-weight:400;
}
.missing-layer .ml-sub{
  font-family:var(--font-body);font-size:clamp(15px,1.5vw,17px);
  line-height:1.6;color:rgba(21,16,42,0.68);
  max-width:62ch;margin:0 auto;
}
/* ---- Missing Layer , full-width statement card (Option 1) ---- */
.missing-layer .ml-card{
  width:100%;
  padding:clamp(44px,6vw,80px) clamp(28px,5vw,72px);
  border-radius:24px;text-align:center;
  display:flex;flex-direction:column;align-items:center;gap:clamp(20px,3vh,32px);
  border:1px solid rgba(168,139,74,0.34);
  background:
    radial-gradient(ellipse 82% 90% at 50% 12%,rgba(255,122,51,0.12),transparent 66%),
    linear-gradient(180deg,#FEFCF8 0%,#FAF3E9 100%);
  box-shadow:0 24px 64px -34px rgba(21,16,42,0.30);
}
@media(max-width:600px){
  .missing-layer .ml-headline{font-size:clamp(26px,7.4vw,40px)}
  .missing-layer .ml-card{padding:clamp(32px,7vw,52px) clamp(22px,5vw,36px);border-radius:18px}
}

/* ============================================================
   WHY IT MATTERS , bone ground, animated orbital flywheel.
   Direct port of the artifact HTML (why-it-matters-section.html)
   so this section reads as an editorial "why" beat: three labelled
   nodes orbit a champagne-orange core, with a comet tracing the path.
   ============================================================ */
.market{position:relative;z-index:1;background-color:var(--bone);background-image:linear-gradient(180deg,rgba(255,122,51,0.10) 0%,rgba(255,122,51,0) 75%);color:var(--aubergine)}
.market .market-inner{
  max-width:var(--container-max);margin:0 auto;
  padding-left:var(--gutter);padding-right:var(--gutter);
}
.market .nsec-head{max-width:820px;margin:0 auto clamp(32px,4.5vh,56px);text-align:center}
.market .nsec-head h2{
  font-family:var(--font-display);font-weight:400;
  font-size:clamp(30px,4vw,48px);line-height:1.14;letter-spacing:-0.015em;
  max-width:min(100%,760px);margin-left:auto;margin-right:auto;color:var(--aubergine);
}
.market .nsec-head h2 .accent{font-style:normal;color:var(--champ)}
.market .nsec-pull{
  margin:clamp(14px,2.2vh,24px) auto 0;max-width:760px;text-align:center;
  font-family:var(--font-display);font-size:clamp(19px,2vw,26px);
  line-height:1.3;color:var(--aubergine);
}
.market .nsec-pull em{font-style:italic;color:var(--champ)}

.flywheel{
  position:relative;width:100%;max-width:960px;
  margin:clamp(20px,3.5vh,40px) auto 0;
  aspect-ratio:1.92 / 1;min-height:340px;
}
.flywheel canvas{position:absolute;inset:0;width:100%;height:100%;display:block}
.fw-label{
  position:absolute;left:0;top:0;
  font-family:var(--font-body);font-size:clamp(12.5px,1.1vw,15px);
  font-weight:500;color:var(--aubergine);white-space:nowrap;
  pointer-events:none;text-shadow:0 1px 3px rgba(250,248,244,0.9);
}
@media(max-width:719px){
  .fw-label{white-space:normal;max-width:130px;text-align:center;line-height:1.25}
}
@media(max-width:600px){
  .flywheel{aspect-ratio:1 / 1;min-height:380px}
  .fw-label{font-size:11.5px;max-width:118px}
}




/* ============================================================
   THE STACK , annotated exploded plate (replaces pillar cards)
   ============================================================ */
.stackx{background:var(--bone);color:var(--aubergine);position:relative;z-index:1}
.stackx-inner{max-width:var(--container-max);margin:0 auto;padding:clamp(84px,10vh,128px) var(--gutter)}
.stackx-head{max-width:760px;margin-bottom:clamp(36px,5vh,60px)}
.stackx-head h2{
  font-family:var(--font-display);font-weight:400;
  font-size:clamp(34px,4.6vw,58px);line-height:1.06;
  letter-spacing:var(--track-display);color:var(--aubergine);
  margin-bottom:clamp(18px,2.6vh,26px);
}
.stackx-head h2 .accent{color:var(--champ)}
.stackx-head p{font-family:var(--font-body);font-size:clamp(16px,1.5vw,19px);line-height:1.55;color:var(--on-surface-muted);max-width:60ch}

.stackx-grid{display:grid;grid-template-columns:minmax(0,1.02fr) minmax(0,1fr);gap:clamp(28px,4vw,72px);align-items:center}
@media(max-width:860px){.stackx-grid{grid-template-columns:1fr;gap:28px}}
.stackx-fig{min-width:0}
.sx-svg{width:100%;max-width:640px;height:auto;display:block;margin:0 auto}

/* -- diagram: resting state -- */
.sx-thread{stroke:var(--champ);stroke-width:1.2;stroke-dasharray:3 4;opacity:.7}
.sx-seal{fill:var(--champ)}
.sx-aface{fill:#F4E5C2;stroke:var(--champ);stroke-width:1}
.sx-aside{fill:#E8D9B8;stroke:var(--champ);stroke-width:1}
.sx-atag{font-family:var(--font-mono);font-size:10px;letter-spacing:0.2em;fill:var(--champ-rim)}

.sx-slab{cursor:pointer;outline:none}
.sx-slab .sx-top{fill:var(--box-fill);stroke:var(--box-border);stroke-width:1;
  transition:fill var(--dur-base) var(--ease-out),stroke var(--dur-base) var(--ease-out)}
.sx-slab .sx-side{fill:#EFE9DC;stroke:var(--box-border);stroke-width:1;
  transition:fill var(--dur-base) var(--ease-out),stroke var(--dur-base) var(--ease-out)}
.sx-slab .sx-side.r{fill:#E7DFCE}
.sx-slab .sx-port{fill:#EFE9DC;stroke:var(--box-border);stroke-width:1;
  transition:fill var(--dur-base) var(--ease-out),stroke var(--dur-base) var(--ease-out)}
.sx-lead{stroke:var(--box-border);stroke-width:1;transition:stroke var(--dur-base) var(--ease-out)}
.sx-lnum{font-family:var(--font-mono);font-size:13px;letter-spacing:0.04em;fill:var(--aubergine);opacity:.55;
  transition:opacity var(--dur-base) var(--ease-out)}
.sx-lrole{font-family:var(--font-mono);font-size:9.5px;letter-spacing:0.2em;fill:var(--on-surface-muted);opacity:.5;
  transition:opacity var(--dur-base) var(--ease-out),fill var(--dur-base) var(--ease-out)}

/* -- hover: affordance only, no state change -- */
.sx-slab:hover .sx-top{stroke:rgba(168,139,74,0.55)}
.sx-slab:hover .sx-lnum{opacity:.85}
.sx-slab:hover .sx-lrole{opacity:.75}

/* -- selected: champagne ink binds slab to panel -- */
.sx-slab[aria-selected="true"] .sx-top{fill:#F4E5C2;stroke:var(--champ)}
.sx-slab[aria-selected="true"] .sx-side{fill:#EAD9AE;stroke:var(--champ)}
.sx-slab[aria-selected="true"] .sx-side.r{fill:#DFCC9C}
.sx-slab[aria-selected="true"] .sx-port{fill:var(--champ);stroke:var(--champ-rim)}
.sx-slab[aria-selected="true"] .sx-lead{stroke:var(--champ)}
.sx-slab[aria-selected="true"] .sx-lnum{opacity:1;fill:var(--aubergine)}
.sx-slab[aria-selected="true"] .sx-lrole{opacity:1;fill:var(--champ-rim)}
.sx-slab:focus-visible .sx-top{stroke:var(--lava);stroke-width:2}

/* -- entrance: staggered settle, once, JS-gated (resting state fully visible) -- */
.sx-slab,.sx-asset,.sx-thread,.sx-seal{transition:opacity 300ms var(--ease-out),transform 300ms var(--ease-out)}
.sx-slab:nth-of-type(2){transition-delay:60ms}
.sx-slab:nth-of-type(3){transition-delay:120ms}
.sx-slab:nth-of-type(4){transition-delay:180ms}
.stackx.sx-pre .sx-slab,.stackx.sx-pre .sx-asset{opacity:0;transform:translateY(10px)}
.stackx.sx-pre .sx-thread,.stackx.sx-pre .sx-seal{opacity:0}

/* -- detail panel -- */
.stackx-detail{min-width:0;min-height:clamp(360px,44vh,470px);display:flex;flex-direction:column;justify-content:center}
.sx-panel{max-width:52ch}
.sx-panel.sx-in{animation:sx-fade 200ms var(--ease-out) both}
@keyframes sx-fade{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}
.sx-eyebrow{
  font-family:var(--font-mono);font-size:11px;font-weight:500;
  letter-spacing:var(--track-mono-caps);text-transform:uppercase;
  color:var(--champ-rim);display:inline-flex;align-items:center;gap:10px;margin-bottom:14px;
}
.sx-eyebrow::before{content:"";width:6px;height:6px;background:var(--champ);transform:rotate(45deg)}
.sx-panel h3{
  font-family:var(--font-display);font-weight:400;
  font-size:clamp(24px,2.6vw,34px);line-height:1.1;
  letter-spacing:var(--track-display);color:var(--aubergine);margin-bottom:10px;
}
.sx-sub{font-family:var(--font-body);font-weight:600;font-size:clamp(15px,1.3vw,17px);color:var(--aubergine);margin-bottom:10px}
.sx-body{font-family:var(--font-body);font-size:clamp(14.5px,1.25vw,16.5px);line-height:1.6;color:var(--on-surface-muted);margin-bottom:18px}

/* the mechanism artifact: a register plate, mono, 1px */
.sx-artifact{
  background:var(--box-fill);border:1px solid var(--box-border);border-radius:var(--r);
  padding:4px 0;margin-bottom:20px;
  font-family:var(--font-mono);font-size:12px;letter-spacing:var(--track-mono);
  font-variant-numeric:tabular-nums;
}
.sx-arow{display:flex;justify-content:space-between;gap:16px;padding:7px 14px;color:var(--aubergine)}
.sx-arow span:last-child{text-align:right;color:var(--on-surface-muted)}
.sx-arow.h{border-bottom:1px solid var(--box-border);color:var(--champ-rim);font-size:10.5px;letter-spacing:0.14em;text-transform:uppercase}
.sx-arow.h span:last-child{color:var(--champ-rim)}
.sx-arow.f{border-top:1px solid var(--box-border);color:var(--champ-rim)}
.sx-arow.f span:last-child{color:var(--champ-rim)}
.sx-arow .ok-val{display:inline-flex;align-items:center;gap:7px;justify-content:flex-end}
.sx-arow .okd{width:6px;height:6px;border-radius:50%;background:#2F6B4F;flex:none}

.sx-cta{
  font-family:var(--font-mono);font-size:12.5px;font-weight:500;
  letter-spacing:var(--track-mono);text-transform:uppercase;
  color:var(--lava);text-decoration:none;display:inline-flex;align-items:center;gap:8px;
}
.sx-cta:hover{text-decoration:underline;text-underline-offset:4px}
.sx-cta .chev{transition:transform var(--dur-fast) var(--ease-out)}
.sx-cta:hover .chev{transform:translateX(3px)}

.stackx-foot{margin-top:clamp(36px,5vh,56px);display:flex;justify-content:flex-start}

/* small screens: the artifact plate scales down; scrolls in place as backstop */
.sx-artifact{overflow-x:auto}
@media(max-width:480px){
  .sx-artifact{font-size:11px}
  .sx-arow{padding:6px 10px;gap:10px}
}

@media(prefers-reduced-motion:reduce){
  .stackx .sx-slab,.stackx .sx-asset,.stackx .sx-thread,.stackx .sx-seal,.stackx .sx-panel{opacity:1;transform:none;animation:none;transition:none}
}



/* ============================================================
   HOW IT WORKS , the record that writes itself
   ============================================================ */
.hiwx{background:var(--bone);color:var(--aubergine);position:relative;z-index:1}
.hiwx-inner{max-width:var(--container-max);margin:0 auto;padding:clamp(84px,10vh,128px) var(--gutter)}
.hiwx-head{max-width:800px;margin-bottom:clamp(36px,5vh,60px)}
.hiwx-head h2{
  font-family:var(--font-display);font-weight:400;
  font-size:clamp(34px,4.6vw,58px);line-height:1.06;
  letter-spacing:var(--track-display);color:var(--aubergine);
  margin-bottom:clamp(18px,2.6vh,26px);
}
.hiwx-head h2 .accent{color:var(--champ)}
.hiwx-lead{font-family:var(--font-body);font-size:clamp(16px,1.5vw,19px);line-height:1.55;color:var(--on-surface-muted);max-width:66ch}

.hiwx-grid{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1.06fr);gap:clamp(28px,4vw,72px);align-items:start}
@media(max-width:900px){.hiwx-grid{grid-template-columns:1fr;gap:30px}}

/* -- steps: the tablist -- */
.hiwx-steps{display:flex;flex-direction:column}
.hx-step{
  position:relative;cursor:pointer;outline:none;
  padding:clamp(18px,2.4vh,26px) 0 clamp(18px,2.4vh,26px) 22px;
  border-top:1px solid var(--box-border);
  opacity:.55;transition:opacity var(--dur-base) var(--ease-out);
}
.hx-step:last-of-type{border-bottom:1px solid var(--box-border)}
.hx-step::before{
  content:"";position:absolute;left:0;top:18px;bottom:18px;width:2px;
  background:var(--champ);transform:scaleY(0);transform-origin:top;
  transition:transform var(--dur-base) var(--ease-out);
}
.hx-step:hover{opacity:.85}
.hx-step[aria-selected="true"]{opacity:1}
.hx-step[aria-selected="true"]::before{transform:scaleY(1)}
.hx-step:focus-visible{outline:2px solid var(--lava);outline-offset:3px}
.hx-kicker{
  display:inline-flex;align-items:baseline;gap:10px;
  font-family:var(--font-mono);font-size:11px;font-weight:500;
  letter-spacing:var(--track-mono-caps);text-transform:uppercase;
  color:var(--on-surface-muted);margin-bottom:10px;
}
.hx-kicker .num{color:var(--champ-rim)}
.hx-step h3{
  font-family:var(--font-display);font-weight:400;
  font-size:clamp(19px,1.9vw,25px);line-height:1.2;
  letter-spacing:var(--track-display);color:var(--aubergine);margin-bottom:8px;
}
.hx-step p{font-family:var(--font-body);font-size:clamp(14px,1.2vw,15.5px);line-height:1.6;color:var(--on-surface-muted);max-width:54ch;margin-bottom:12px}
.hx-cta{
  font-family:var(--font-mono);font-size:12px;font-weight:500;
  letter-spacing:var(--track-mono);text-transform:uppercase;
  color:var(--lava);text-decoration:none;display:inline-flex;align-items:center;gap:8px;
}
.hx-cta:hover{text-decoration:underline;text-underline-offset:4px}
.hx-cta .chev{transition:transform var(--dur-fast) var(--ease-out)}
.hx-cta:hover .chev{transform:translateX(3px)}

/* -- the register document -- */
.hx-register{
  background:var(--box-fill);border:1px solid var(--box-border);border-radius:var(--r-card);
  font-family:var(--font-mono);font-variant-numeric:tabular-nums;
  overflow:hidden;
}
.hx-reghead{
  display:flex;justify-content:space-between;align-items:center;gap:14px;flex-wrap:wrap;
  padding:16px 18px;border-bottom:1px solid var(--box-border);
  background:linear-gradient(180deg,rgba(168,139,74,0.07),rgba(168,139,74,0))
}
.hx-id{display:flex;align-items:center;gap:12px;min-width:0}
.hx-glyph{
  width:34px;height:34px;flex:none;display:grid;place-items:center;
  background:var(--aubergine);color:var(--champ-light);
  font-size:12px;letter-spacing:0.08em;border-radius:var(--r);
}
.hx-idtext{display:flex;flex-direction:column;gap:2px;min-width:0}
.hx-name{font-family:var(--font-body);font-weight:600;font-size:14px;color:var(--aubergine)}
.hx-sub{font-size:10.5px;letter-spacing:0.06em;color:var(--on-surface-muted)}
.hx-badge{
  font-size:10px;letter-spacing:0.16em;text-transform:uppercase;
  color:var(--champ-rim);border:1px solid rgba(168,139,74,0.45);
  padding:4px 10px;border-radius:2px;white-space:nowrap;
}

.hx-group{padding:4px 0;border-bottom:1px solid rgba(216,208,194,0.55)}
.hx-ghead{
  display:flex;justify-content:space-between;align-items:center;gap:12px;
  padding:9px 18px 5px;
  font-size:10px;letter-spacing:0.16em;text-transform:uppercase;
  color:var(--on-surface-muted);
  transition:color var(--dur-base) var(--ease-out);
}
.hx-gtag{letter-spacing:0.12em}
.hx-group.now .hx-ghead{color:var(--champ-rim)}
.hx-row{
  position:relative;
  display:grid;grid-template-columns:52px minmax(0,1fr) auto;gap:12px;
  padding:7px 18px;font-size:12px;letter-spacing:var(--track-mono);
}
.hx-row .t{color:var(--on-surface-muted);opacity:.75}
.hx-row .e{color:var(--aubergine)}
.hx-row .v{text-align:right;color:var(--on-surface-muted)}
.hx-group.now .hx-row .e{color:var(--aubergine)}
.hx-group.now .hx-row .v{color:var(--champ-rim)}
.hx-group.written:not(.now) .hx-row{opacity:.78}

/* future steps: named but unwritten , faint dashed entry lines */
.hx-group.pending .hx-row span{opacity:0}
.hx-group.pending .hx-row::after{
  content:"";position:absolute;left:18px;right:18px;top:50%;
  border-top:1px dashed rgba(216,208,194,0.9);
}
.hx-group.pending .hx-ghead{color:rgba(79,69,56,0.45)}

/* new entries ink in, staggered, once per selection */
.hx-group.ink .hx-row{animation:hx-ink 260ms var(--ease-out) both}
.hx-group.ink .hx-row:nth-child(3){animation-delay:70ms}
.hx-group.ink .hx-row:nth-child(4){animation-delay:140ms}
@keyframes hx-ink{from{opacity:0;transform:translateY(5px)}to{opacity:1;transform:none}}
.hx-group.written:not(.now).ink .hx-row{animation:none}

.hx-regfoot{
  display:flex;align-items:center;gap:10px;
  padding:12px 18px;
  font-size:10.5px;letter-spacing:0.14em;text-transform:uppercase;color:var(--champ-rim);
}
.hx-seal{width:7px;height:7px;background:var(--champ);transform:rotate(45deg);flex:none}

/* entrance: settle once, JS-gated; resting state fully visible */
.hx-register{transition:opacity 320ms var(--ease-out),transform 320ms var(--ease-out)}
.hiwx.hx-pre .hx-register{opacity:0;transform:translateY(12px)}

@media(max-width:480px){
  .hx-row{font-size:11px;grid-template-columns:44px minmax(0,1fr) auto;gap:8px;padding:6px 12px}
  .hx-ghead{padding:8px 12px 4px}
  .hx-reghead{padding:12px}
  .hx-register{overflow-x:auto}
}
@media(prefers-reduced-motion:reduce){
  .hiwx .hx-register,.hiwx .hx-step,.hiwx .hx-group .hx-row{opacity:1;transform:none;animation:none;transition:none}
  .hiwx .hx-step{opacity:1}
  .hx-group.pending .hx-row span{opacity:0}
}



/* ---- HOW IT WORKS v2: one scene, three states ---- */
.hx-stage{
  position:relative;
  background:var(--box-fill);border:1px solid var(--box-border);border-radius:var(--r-card);
  padding:clamp(18px,2vw,30px);
  overflow:hidden;
}
.hx-stagebadge{
  position:absolute;top:14px;right:14px;z-index:2;
  font-family:var(--font-mono);font-size:10px;letter-spacing:0.16em;text-transform:uppercase;
  color:var(--champ-rim);border:1px solid rgba(168,139,74,0.45);
  padding:4px 10px;border-radius:2px;background:var(--box-fill);
}
.hxs-svg{width:100%;height:auto;display:block}

/* persistent scene */
.hxs-rail{stroke:var(--champ);stroke-width:1.4}
.hxs-seal{fill:var(--champ)}
.hxs-raillabel{font-family:var(--font-mono);font-size:10px;letter-spacing:0.18em;fill:var(--champ-rim)}
.hxs-anchor{stroke:var(--champ);stroke-width:1.2;stroke-dasharray:3 4;opacity:.75;
  transition:stroke-width var(--dur-base) var(--ease-out),stroke-dasharray var(--dur-base) var(--ease-out),opacity var(--dur-base) var(--ease-out)}
.hx-stage[data-state="3"] .hxs-anchor{stroke-dasharray:none;stroke-width:2;opacity:1}
.hxs-token{fill:#F4E5C2;stroke:var(--champ);stroke-width:1.2}
.hxs-tokentext{font-family:var(--font-mono);font-size:17px;letter-spacing:0.1em;fill:var(--champ-rim);font-weight:500}
.hxs-tokensub{font-family:var(--font-mono);font-size:9.5px;letter-spacing:0.08em;fill:var(--on-surface-muted)}

/* state groups: reader-paced crossfade */
.hxs-state{opacity:0;transform:translateY(6px);pointer-events:none;
  transition:opacity 260ms var(--ease-out),transform 260ms var(--ease-out)}
.hx-stage[data-state="1"] .hxs-state.s1,
.hx-stage[data-state="2"] .hxs-state.s2,
.hx-stage[data-state="3"] .hxs-state.s3{opacity:1;transform:none}

/* scene vocabulary */
.sx-chip{fill:var(--box-fill);stroke:var(--box-border);stroke-width:1}
.sx-chip.wide{fill:#F4E5C2;stroke:var(--champ)}
.hxs-chiptext{font-family:var(--font-mono);font-size:9.5px;letter-spacing:0.1em;fill:var(--aubergine)}
.hxs-lead{stroke:var(--champ);stroke-width:1}
.hxs-arrow{fill:var(--champ)}
.hxs-node{fill:var(--box-fill);stroke:var(--aubergine);stroke-width:1.1}
.hxs-app{fill:var(--box-fill);stroke:var(--aubergine);stroke-width:1.1}
.hxs-nodelabel{font-family:var(--font-mono);font-size:9px;letter-spacing:0.14em;fill:var(--on-surface-muted)}
.hxs-spoke{stroke:rgba(21,16,42,0.4);stroke-width:1;stroke-dasharray:1 3}
.hxs-microlabel{font-family:var(--font-mono);font-size:8.5px;letter-spacing:0.1em;fill:var(--on-surface-muted)}
.hxs-caption{font-family:var(--font-mono);font-size:9px;letter-spacing:0.14em;fill:var(--champ-rim)}
.hxs-tick{stroke:var(--champ);stroke-width:1.4}
.hxs-anchorlabel{font-family:var(--font-mono);font-size:8.5px;letter-spacing:0.12em;fill:var(--champ-rim)}

/* entrance reuses hx-pre gate */
.hx-stage{transition:opacity 320ms var(--ease-out),transform 320ms var(--ease-out)}
.hiwx.hx-pre .hx-stage{opacity:0;transform:translateY(12px)}

@media(prefers-reduced-motion:reduce){
  .hx-stage,.hxs-state{transition:none}
  .hx-stage{opacity:1;transform:none}
}


.hxs-nodemark{font-family:var(--font-mono);font-size:10px;letter-spacing:0.08em;fill:var(--champ-rim)}



/* ============================================================
   HOW IT WORKS v3 , the asset dossier (zoned card)
   ============================================================ */
.hx-dossier{
  background:var(--box-fill);border:1px solid var(--box-border);border-radius:var(--r-card);
  box-shadow:0 24px 60px -32px rgba(21,16,42,0.28);
  overflow:hidden;
  transition:opacity 320ms var(--ease-out),transform 320ms var(--ease-out);
}
.hiwx.hx-pre .hx-dossier{opacity:0;transform:translateY(12px)}
.hxd-chrome{
  display:flex;align-items:center;gap:12px;
  padding:10px 16px;border-bottom:1px solid var(--box-border);
  background:linear-gradient(180deg,#F7F2E7,#F2ECDD);
  font-family:var(--font-mono);
}
.hxd-mark{width:7px;height:7px;background:var(--champ);transform:rotate(45deg);flex:none}
.hxd-file{font-size:10px;letter-spacing:0.14em;color:var(--champ-rim);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.hxd-badge{
  margin-left:auto;flex:none;
  font-size:9.5px;letter-spacing:0.14em;text-transform:uppercase;
  color:var(--champ-rim);border:1px solid rgba(168,139,74,0.45);
  padding:3px 9px;border-radius:2px;background:var(--box-fill);
}

/* zones + golden spine */
.hxd-zones{position:relative;padding-left:26px}
.hxd-zones::before{
  content:"";position:absolute;left:13px;top:18px;bottom:18px;width:0;
  border-left:1.5px dashed rgba(168,139,74,0.55);
}
.hxd-zone{position:relative;padding:14px 18px 16px 6px;cursor:pointer;
  transition:opacity var(--dur-base) var(--ease-out),background var(--dur-base) var(--ease-out)}
.hxd-zone + .hxd-zone{border-top:1px solid rgba(216,208,194,0.6)}
.hxd-zone::before{
  content:"";position:absolute;left:-17px;top:20px;width:8px;height:8px;
  background:var(--box-fill);border:1.5px solid var(--champ);transform:rotate(45deg);
  transition:background var(--dur-base) var(--ease-out);
}
.hxd-zone{opacity:.52}
.hxd-zone:hover{opacity:.8}
.hx-dossier[data-state="1"] .hxd-zone[data-z="1"],
.hx-dossier[data-state="2"] .hxd-zone[data-z="2"],
.hx-dossier[data-state="3"] .hxd-zone[data-z="3"]{
  opacity:1;
  background:linear-gradient(90deg,rgba(168,139,74,0.07),rgba(168,139,74,0) 70%);
}
.hx-dossier[data-state="1"] .hxd-zone[data-z="1"]::before,
.hx-dossier[data-state="2"] .hxd-zone[data-z="2"]::before,
.hx-dossier[data-state="3"] .hxd-zone[data-z="3"]::before{background:var(--champ)}
.hxd-zone:focus-visible{outline:2px solid var(--lava);outline-offset:-2px}

.hxd-zhead{
  display:flex;align-items:baseline;gap:10px;margin-bottom:10px;
  font-family:var(--font-mono);text-transform:uppercase;
}
.hxd-zhead .zn{font-size:10px;letter-spacing:0.1em;color:var(--champ-rim)}
.hxd-zhead .zt{font-size:11px;letter-spacing:0.16em;color:var(--aubergine);font-weight:500}
.hxd-zhead .ztag{margin-left:auto;font-size:9px;letter-spacing:0.14em;color:var(--on-surface-muted)}

.hxd-zbody{display:grid;gap:7px}
.hxd-row{
  display:flex;justify-content:space-between;align-items:center;gap:14px;
  font-family:var(--font-mono);font-size:12px;letter-spacing:var(--track-mono);
}
.hxd-row .lbl{color:var(--on-surface-muted)}
.hxd-row .val{display:inline-flex;align-items:center;gap:8px;color:var(--aubergine);text-align:right}
.hxd-row .val .ok{width:6px;height:6px;border-radius:50%;background:#2F6B4F;flex:none}
.hxd-row .val.chips{gap:6px}
.hxd-row .val.chips em{
  font-style:normal;font-size:10px;letter-spacing:0.1em;
  border:1px solid var(--box-border);padding:2px 8px;border-radius:2px;color:var(--aubergine);
}
.hxd-ops{display:flex;flex-wrap:wrap;gap:6px;margin-top:3px}
.hxd-ops .op{
  font-family:var(--font-mono);font-size:10px;letter-spacing:0.1em;text-transform:uppercase;
  border:1px solid var(--box-border);padding:3px 10px;border-radius:2px;color:var(--on-surface-muted);
}
.hxd-live{
  display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin-top:3px;
  font-family:var(--font-mono);font-size:11px;color:var(--aubergine);
  border-top:1px dashed rgba(216,208,194,0.8);padding-top:9px;
}
.hxd-live .tstamp{color:var(--on-surface-muted);font-size:10px}
.hxd-live .res{display:inline-flex;align-items:center;gap:6px;margin-left:auto;color:var(--champ-rim)}
.hxd-live .res .ok{width:6px;height:6px;border-radius:50%;background:#2F6B4F}

.hxd-sync{
  display:flex;align-items:center;gap:10px;
  font-family:var(--font-mono);font-size:11px;color:var(--aubergine);margin-bottom:4px;
}
.pulsedot{width:7px;height:7px;border-radius:50%;background:var(--champ);flex:none}
.hx-dossier[data-state="3"] .pulsedot{animation:hxd-pulse 1.8s var(--ease-out) infinite}
@keyframes hxd-pulse{0%{box-shadow:0 0 0 0 rgba(168,139,74,0.45)}70%{box-shadow:0 0 0 8px rgba(168,139,74,0)}100%{box-shadow:0 0 0 0 rgba(168,139,74,0)}}
.hxd-apps{display:grid;grid-template-columns:repeat(3,1fr);gap:8px}
.hxd-app{
  display:flex;align-items:center;gap:8px;
  border:1px solid var(--box-border);border-radius:var(--r);padding:8px 10px;background:rgba(250,248,244,0.6);
}
.hxd-app .ic{width:16px;height:16px;flex:none;display:grid;place-items:center}
.hxd-app .ic svg{width:16px;height:16px;stroke:var(--champ-rim);fill:none;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round}
.hxd-app .ic svg .fill{fill:var(--champ-rim);stroke:none}
.hxd-app .nm{font-family:var(--font-mono);font-size:9.5px;letter-spacing:0.08em;text-transform:uppercase;color:var(--aubergine)}
.hxd-foot{
  display:flex;align-items:center;gap:10px;
  padding:11px 18px;border-top:1px solid var(--box-border);
  font-family:var(--font-mono);font-size:10px;letter-spacing:0.14em;text-transform:uppercase;color:var(--champ-rim);
}
.hxd-seal{width:7px;height:7px;background:var(--champ);transform:rotate(45deg);flex:none}

/* active zone rows ink in */
.hxd-zone.ink .hxd-zbody > *{animation:hx-ink 240ms var(--ease-out) both}
.hxd-zone.ink .hxd-zbody > *:nth-child(2){animation-delay:60ms}
.hxd-zone.ink .hxd-zbody > *:nth-child(3){animation-delay:120ms}
.hxd-zone.ink .hxd-zbody > *:nth-child(4){animation-delay:180ms}

@media(max-width:480px){
  .hxd-apps{grid-template-columns:repeat(2,1fr)}
  .hxd-row{font-size:11px}
  .hxd-file{font-size:9px}
}

/* ============================================================
   WHO IT'S FOR v2 , three doors onto the network (dark)
   ============================================================ */
.whofx{
  position:relative;z-index:1;
  background-color:#15102A;
  background-image:none;
  color:var(--bone);overflow:hidden;
}
.whofx-inner{max-width:var(--container-max);margin:0 auto;padding:clamp(84px,10vh,128px) var(--gutter)}
.whofx-head{max-width:760px;margin-bottom:clamp(36px,5vh,60px)}
.whofx-head h2{
  font-family:var(--font-display);font-weight:400;
  font-size:clamp(34px,4.6vw,58px);line-height:1.06;
  letter-spacing:var(--track-display);color:var(--bone);
  margin-bottom:clamp(16px,2.4vh,24px);
}
.whofx-head h2 .accent{color:var(--champ-light)}
.whofx-sub{font-family:var(--font-body);font-size:clamp(16px,1.5vw,19px);line-height:1.6;color:rgba(250,248,244,0.72);max-width:60ch}

.whofx-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:clamp(14px,1.6vw,22px)}
@media(max-width:960px){.whofx-grid{grid-template-columns:1fr;max-width:560px}}

.wx-door{
  display:flex;flex-direction:column;
  background:rgba(250,248,244,0.035);
  border:1px solid rgba(232,217,184,0.18);border-radius:var(--r-card);
  padding:clamp(20px,2.2vw,28px);
  text-decoration:none;color:var(--bone);
  transition:border-color var(--dur-base) var(--ease-out),transform var(--dur-base) var(--ease-out),background var(--dur-base) var(--ease-out);
}
.wx-door:hover{border-color:rgba(232,217,184,0.5);transform:translateY(-5px);background:rgba(250,248,244,0.05)}
.wx-door:focus-visible{outline:2px solid var(--champ-light);outline-offset:3px}
.wx-eyebrow{
  font-family:var(--font-mono);font-size:11px;font-weight:500;
  letter-spacing:var(--track-mono-caps);text-transform:uppercase;
  color:var(--champ-light);display:inline-flex;align-items:center;gap:10px;margin-bottom:6px;
}
.wx-eyebrow::before{content:"";width:6px;height:6px;background:var(--champ);transform:rotate(45deg)}
.wx-aud{font-family:var(--font-mono);font-size:10px;letter-spacing:0.08em;color:rgba(250,248,244,0.5);margin-bottom:16px}
.wx-door h3{
  font-family:var(--font-display);font-weight:400;
  font-size:clamp(21px,1.9vw,26px);line-height:1.15;
  letter-spacing:var(--track-display);color:var(--bone);margin-bottom:8px;
}
.wx-door p{font-family:var(--font-body);font-size:14.5px;line-height:1.55;color:rgba(250,248,244,0.66);margin-bottom:18px}

/* the vignette: their view of T-REX */
.wx-vig{
  margin-top:auto;margin-bottom:18px;
  background:rgba(21,16,42,0.55);
  border:1px solid rgba(232,217,184,0.16);border-radius:var(--r);
  padding:12px 14px;
  font-family:var(--font-mono);font-variant-numeric:tabular-nums;
  transition:border-color var(--dur-base) var(--ease-out);
}
.wx-door:hover .wx-vig{border-color:rgba(232,217,184,0.38)}
.wx-vighead{
  display:flex;align-items:center;gap:8px;
  font-size:9px;letter-spacing:0.16em;color:rgba(250,248,244,0.5);
  padding-bottom:9px;margin-bottom:9px;border-bottom:1px solid rgba(232,217,184,0.12);
}
.wxdot{width:5px;height:5px;background:var(--champ);transform:rotate(45deg);flex:none}
.wx-blot{display:flex;gap:12px;font-size:11px;padding:4px 0;color:var(--bone)}
.wx-blot .a{color:rgba(250,248,244,0.85)}
.wx-blot .b{margin-left:auto;color:rgba(250,248,244,0.6)}
.wx-blot .c{font-size:9px;letter-spacing:0.1em;align-self:center}
.wx-blot .ok-c{color:#8FBF9F}
.wx-blot .live-c{color:var(--champ-light)}
.wx-code{font-size:11px;padding:3px 0;color:rgba(250,248,244,0.85)}
.wx-code .k{color:var(--champ-light)}
.wx-code .s{color:#C9A96A}
.wx-code.out{color:rgba(250,248,244,0.55)}
.wx-code .ret{color:#8FBF9F}
.wx-shelf{display:grid;grid-template-columns:repeat(3,1fr);gap:7px;padding:2px 0}
.wx-tile{
  display:flex;flex-direction:column;align-items:center;gap:6px;
  border:1px solid rgba(232,217,184,0.14);border-radius:var(--r);padding:9px 4px;
}
.wx-tile .ic svg{width:16px;height:16px;stroke:var(--champ-light);fill:none;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round}
.wx-tile .ic svg .fill{fill:var(--champ-light);stroke:none}
.wx-tile .nm{font-size:8.5px;letter-spacing:0.1em;text-transform:uppercase;color:rgba(250,248,244,0.6)}
.wx-chips{display:flex;flex-wrap:wrap;gap:6px;margin-top:9px}
.wx-chips span{
  font-size:9px;letter-spacing:0.12em;text-transform:uppercase;
  border:1px solid rgba(232,217,184,0.22);padding:3px 9px;border-radius:2px;color:rgba(250,248,244,0.7);
}
.wx-chips span.gold{color:var(--champ-light);border-color:rgba(232,217,184,0.4)}
.wx-cta{
  font-family:var(--font-mono);font-size:12px;font-weight:500;
  letter-spacing:var(--track-mono);text-transform:uppercase;
  color:var(--lava);display:inline-flex;align-items:center;gap:8px;
}
.wx-door:hover .wx-cta{text-decoration:underline;text-underline-offset:4px}
.wx-cta .chev{transition:transform var(--dur-fast) var(--ease-out)}
.wx-door:hover .wx-cta .chev{transform:translateX(3px)}

/* entrance: settle once, JS-gated */
.whofx.wx-pre .wx-door{opacity:0;transform:translateY(12px)}
.wx-door{transition:border-color var(--dur-base) var(--ease-out),transform 340ms var(--ease-out),background var(--dur-base) var(--ease-out),opacity 340ms var(--ease-out)}

@media(prefers-reduced-motion:reduce){
  .hx-dossier,.hxd-zone,.wx-door{opacity:1;transform:none;animation:none;transition:none}
  .hxd-zone{opacity:1}
  .pulsedot{animation:none}
}



/* ============================================================
   STAGE COLOUR SYSTEM , champagne / lava / pine bind step to
   zone to door; fact rows replace free text
   ============================================================ */
:root{--pine:#4E7D74}
/* doors pick up the trio */
.wx-door[data-c="1"],.wx-card[data-c="1"]{--doorc:var(--champ-light);--doorc-dim:rgba(232,217,184,0.5)}
.wx-door[data-c="2"],.wx-card[data-c="2"]{--doorc:#FFA06B;--doorc-dim:rgba(255,160,107,0.45)}
.wx-door[data-c="3"],.wx-card[data-c="3"]{--doorc:#8FB8AE;--doorc-dim:rgba(143,184,174,0.45)}
.wx-eyebrow{color:var(--doorc,var(--champ-light))}
.wx-eyebrow::before{background:var(--doorc,var(--champ))}
.wxdot{background:var(--doorc,var(--champ))}
.wx-door:hover{border-color:var(--doorc-dim,rgba(232,217,184,0.5))}
.wx-chips span.gold{color:var(--doorc,var(--champ-light));border-color:var(--doorc-dim,rgba(232,217,184,0.4))}



/* ============================================================
   STACK v2 , layer identity colours + clickability + artifacts
   ============================================================ */
.sx-slab[data-l="1"],.sx-panel[data-l="1"]{--lc:#4E7D74;--lc-ink:#3E655E;--lc-wash:#E2EDE9}
.sx-slab[data-l="2"],.sx-panel[data-l="2"]{--lc:#55488C;--lc-ink:#443A73;--lc-wash:#E6E2F0}
.sx-slab[data-l="3"],.sx-panel[data-l="3"]{--lc:var(--champ);--lc-ink:var(--champ-rim);--lc-wash:#F4E5C2}
.sx-slab[data-l="4"],.sx-panel[data-l="4"]{--lc:#5B77A8;--lc-ink:#445C85;--lc-wash:#E4EAF3}

/* the hint above the diagram — centered above the stack graphic,
   larger and set in aubergine (#15102A) for legibility on the bone
   surface; the pulsing champagne diamond that used to sit before the
   text has been removed on request. */
.sx-hint{
  display:flex;align-items:center;justify-content:flex-start;
  font-family:var(--font-mono);font-size:12.5px;font-weight:500;
  letter-spacing:0.16em;text-transform:uppercase;color:#15102A;
  margin:0 0 18px;max-width:640px;text-align:left;
}
.sx-hintkeys{margin-left:auto;color:var(--on-surface-muted);letter-spacing:0.1em;font-size:9.5px}

/* label chips: look like controls, coloured per layer */
.sx-labelbox{fill:var(--box-fill);stroke:var(--lc);stroke-width:1;opacity:.85;
  transition:fill var(--dur-base) var(--ease-out),opacity var(--dur-base) var(--ease-out)}
.sx-slab .sx-lnum{fill:var(--lc-ink);opacity:.95}
.sx-slab .sx-lrole{fill:var(--lc-ink);opacity:.6}
.sx-slab:hover .sx-labelbox{fill:var(--lc-wash);opacity:1}
.sx-slab:hover .sx-lrole{opacity:.9}
/* Full-perimeter hover highlight — hovering a slab lights up the top
   face, both side faces, the port and the lead line as well as the
   label chip, so the entire cuboid registers as the interactive
   surface, not just the strip next to the label. Mirrors the
   selected state so hover reads as a preview of that state. */
.sx-slab:hover .sx-top{fill:var(--lc-wash);stroke:var(--lc)}
.sx-slab:hover .sx-side{fill:var(--lc-wash);stroke:var(--lc);filter:brightness(0.96)}
.sx-slab:hover .sx-side.r{filter:brightness(0.92)}
.sx-slab:hover .sx-port{fill:var(--lc);stroke:var(--lc-ink)}
.sx-slab:hover .sx-lead{opacity:1}
.sx-slab[aria-selected="true"] .sx-labelbox{fill:var(--lc-wash);opacity:1}
.sx-slab[aria-selected="true"] .sx-lnum{fill:var(--lc-ink);opacity:1}
.sx-slab[aria-selected="true"] .sx-lrole{fill:var(--lc-ink);opacity:1}
.sx-lead{stroke:var(--lc);opacity:.5}

/* slabs tint in their own colour when selected */
.sx-slab[aria-selected="true"] .sx-top{fill:var(--lc-wash);stroke:var(--lc)}
.sx-slab[aria-selected="true"] .sx-side{fill:var(--lc-wash);stroke:var(--lc);filter:brightness(0.96)}
.sx-slab[aria-selected="true"] .sx-side.r{filter:brightness(0.92)}
.sx-slab[aria-selected="true"] .sx-port{fill:var(--lc);stroke:var(--lc-ink)}
.sx-slab[aria-selected="true"] .sx-lead{opacity:1}
.sx-slab:hover .sx-top{stroke:var(--lc)}

/* panel binds to the layer colour */
.sx-panel .sx-eyebrow{color:var(--lc-ink)}
.sx-panel .sx-eyebrow::before{background:var(--lc)}
.sx-panel[data-l] .sx-cta{color:var(--lava)}

/* -- artifacts: mini illustrations -- */
.sx-artifact{padding:12px 14px 13px;display:grid;gap:10px}
.sxa-cap{
  display:flex;align-items:center;gap:8px;
  font-family:var(--font-mono);font-size:9.5px;letter-spacing:0.14em;text-transform:uppercase;
  color:var(--lc-ink,var(--champ-rim));
  border-bottom:1px solid var(--box-border);padding-bottom:9px;
}
.sxa-cap .capdot{width:6px;height:6px;background:var(--lc,var(--champ));transform:rotate(45deg);flex:none}


.sxa-flow{display:flex;align-items:center;gap:8px;flex-wrap:wrap;font-size:11px}
.sxa-party{
  border:1px solid var(--box-border);border-radius:2px;padding:5px 10px;
  font-size:10px;letter-spacing:0.1em;text-transform:uppercase;color:var(--aubergine);background:rgba(250,248,244,0.7);
}
.sxa-arrow{color:var(--lc-ink);font-size:10.5px;letter-spacing:0.04em}
.sxa-token{
  width:34px;height:34px;display:grid;place-items:center;flex:none;
  background:var(--lc-wash);border:1.2px solid var(--lc);border-radius:4px;
  font-size:11px;letter-spacing:0.08em;color:var(--lc-ink);font-weight:500;
}
.sxa-checks{display:flex;gap:8px;flex-wrap:wrap}
.sxa-checks em{
  font-style:normal;display:inline-flex;align-items:center;gap:7px;
  border:1px solid var(--box-border);border-radius:2px;padding:4px 10px;
  font-size:10px;letter-spacing:0.1em;text-transform:uppercase;color:var(--aubergine);
}
.sxa-checks .okd,.sxa-rule .okd{width:6px;height:6px;border-radius:50%;background:#2F6B4F;flex:none;display:inline-block}
.sxa-verdict{
  font-size:10.5px;letter-spacing:0.08em;color:var(--lc-ink);
  border-top:1px dashed var(--box-border);padding-top:9px;
}
.sxa-id{display:flex;align-items:center;gap:12px}
.sxa-avatar{
  width:34px;height:34px;flex:none;border-radius:50%;
  background:var(--lc-wash);border:1.2px solid var(--lc);
  display:grid;place-items:center;
}
.sxa-avatar::after{content:"";width:9px;height:9px;background:var(--lc);transform:rotate(45deg)}
.sxa-idtext{display:flex;flex-direction:column;gap:2px}
.sxa-idtext b{font-size:12px;color:var(--aubergine);font-weight:500}
.sxa-idtext span{font-size:10px;color:var(--on-surface-muted);letter-spacing:0.04em}
.sxa-rule{display:flex;align-items:center;gap:10px;font-size:11.5px}
.sxa-rule span{color:var(--on-surface-muted);min-width:96px}
.sxa-rule b{font-weight:500;color:var(--aubergine);margin-left:auto}
.sxa-goldrow{
  display:flex;align-items:center;gap:12px;
  background:var(--lc-wash);border:1px solid var(--lc);border-radius:2px;padding:8px 12px;
  font-size:11.5px;color:var(--aubergine);
}
.sxa-goldrow b{font-weight:500;margin-left:auto}
.sxa-goldrow em{font-style:normal;font-size:9.5px;letter-spacing:0.12em;color:var(--lc-ink)}
.sxa-chainrow{display:flex;align-items:center;gap:10px;font-size:10.5px;color:var(--on-surface-muted);letter-spacing:0.05em}
.sxa-chains{display:inline-flex;gap:5px}
.sxa-chains i{width:8px;height:8px;border-radius:50%;border:1.2px solid var(--lc);background:var(--lc-wash)}

/* door vignette captions */
.wx-vigcap{
  margin-top:9px;padding-top:8px;border-top:1px dashed rgba(232,217,184,0.15);
  font-size:8.5px;letter-spacing:0.1em;text-transform:uppercase;color:rgba(250,248,244,0.42);
}

@media(prefers-reduced-motion:reduce){.sx-hintmark{animation:none}}



/* stack panels: simple complementary note */
.sx-artifact.sx-note{
  display:flex;align-items:center;gap:14px;padding:14px 16px;
  background:var(--lc-wash,var(--box-fill));border-color:var(--lc,var(--box-border));
}
.sxa-glyph{width:34px;height:34px;flex:none;display:grid;place-items:center}
.sxa-glyph svg{width:32px;height:32px;stroke:var(--lc-ink,var(--champ-rim));fill:none;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round}
.sxa-plain{font-family:var(--font-body);font-size:14px;line-height:1.5;color:var(--aubergine)}

/* door strips: simple complements */
.wx-strip{margin-top:auto;margin-bottom:18px;display:flex;gap:8px}
.wx-si{
  flex:1;display:flex;flex-direction:column;align-items:center;gap:8px;text-align:center;
  border:1px solid rgba(232,217,184,0.16);border-radius:var(--r);padding:12px 6px;
  transition:border-color var(--dur-base) var(--ease-out);
}
.wx-door:hover .wx-si{border-color:rgba(232,217,184,0.32)}
.wx-si .ic svg{width:19px;height:19px;stroke:var(--doorc,var(--champ-light));fill:none;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round}
.wx-si .tl{font-family:var(--font-mono);font-size:8.5px;letter-spacing:0.1em;text-transform:uppercase;color:rgba(250,248,244,0.66);line-height:1.4}



/* ---- asset card: interoperability rail (layer 3) ---- */
.ac-rail{position:relative;display:flex;align-items:center;justify-content:center;gap:clamp(14px,3vw,32px);padding:12px 4px 8px}
/* The champagne dashed rail (and the golden diamond seal at its
   start) have been removed on request; nodes now sit on their own
   without a connecting thread. */
.ac-rail::before{display:none}
.ac-railseal{display:none}
.ac-chain{
  position:relative;z-index:1;width:38px;height:38px;flex:none;border-radius:50%;
  background:var(--aubergine);border:1px solid rgba(21,16,42,0.5);
  display:grid;place-items:center;
  transition:border-color var(--dur-base) var(--ease-out),transform var(--dur-base) var(--ease-out);
}
.ac-layer.on .ac-chain:hover{border-color:rgba(168,139,74,0.6);transform:translateY(-2px)}
.ac-chain img{width:18px;height:18px}
.ac-chain i{position:absolute;right:-1px;bottom:-1px;width:8px;height:8px;border-radius:50%;background:#2F6B4F;border:1.5px solid var(--bone)}
.ac-railcap{font-family:var(--font-mono);font-size:9.5px;letter-spacing:0.08em;color:var(--on-surface-muted);padding:4px 2px 0}
@media(max-width:480px){.ac-chain{width:32px;height:32px}.ac-chain img{width:16px;height:16px}}



/* ---- asset card: what/who/where row forms + layer-2 sub-groups ---- */
.ac-row .lbl i{
  display:block;font-style:normal;text-transform:lowercase;
  font-size:8.5px;letter-spacing:0.12em;color:var(--on-surface-muted);opacity:.6;margin-top:2px;
}
.acr-serial{
  font-family:var(--font-mono);font-size:11px;letter-spacing:0.1em;color:var(--champ-rim);
  border:1px solid rgba(168,139,74,0.45);border-radius:3px;padding:2px 8px;background:var(--box-fill);
}
.acr-mut{color:var(--on-surface-muted);font-weight:400;font-size:10.5px}
.val.acr-stamps{gap:6px}
.val.acr-stamps em{
  font-style:normal;font-family:var(--font-mono);font-size:10px;letter-spacing:0.1em;
  border:1px dashed rgba(168,139,74,0.6);border-radius:3px;padding:2px 8px;color:var(--champ-rim);
}
.ac-sublabel{
  font-family:var(--font-mono);font-size:9px;letter-spacing:0.16em;text-transform:uppercase;
  color:var(--on-surface-muted);opacity:.75;
  margin:12px 0 0;
}
.ac-sublabel + .ac-ops{margin-top:7px}
.ac-sublabel + .ac-apps{margin-top:7px}



/* ---- card refinements: row glyphs, action buttons, tile medallions, typed rail ---- */
.ac-row .lbl{display:inline-flex;align-items:center;gap:8px}
.ric{width:14px;height:14px;flex:none;display:grid;place-items:center}
.ric svg{width:14px;height:14px;stroke:var(--champ-rim);opacity:.85;fill:none;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round}

/* actions read as pressable controls */
.ac-op{
  background:linear-gradient(180deg,rgba(168,139,74,0.16),rgba(168,139,74,0.09));
  border-color:rgba(168,139,74,0.6);color:var(--champ-rim);
  box-shadow:0 1px 0 rgba(92,72,36,0.28);
  transition:transform var(--dur-fast) var(--ease-out),box-shadow var(--dur-fast) var(--ease-out),background var(--dur-fast) var(--ease-out);
}
.ac-op:hover{transform:translateY(-1px);box-shadow:0 2px 3px rgba(92,72,36,0.24);background:linear-gradient(180deg,rgba(168,139,74,0.22),rgba(168,139,74,0.12))}

/* app tiles: icon medallion + descriptor */
.ac-app .ic{
  width:30px;height:30px;border-radius:7px;display:grid;place-items:center;
  background:linear-gradient(180deg,rgba(168,139,74,0.18),rgba(168,139,74,0.08));
  border:1px solid rgba(168,139,74,0.4);
}
.ac-app .ds{
  font-family:var(--font-body);font-size:9.5px;line-height:1.35;color:var(--on-surface-muted);
}
.ac-app:hover{border-color:rgba(168,139,74,0.55)}

/* typed rail nodes with labels; thread passes through coin centres */
.ac-rail{align-items:flex-start;padding:12px 4px 4px}
.ac-rail::before{top:31px;margin-top:0}
.ac-node{position:relative;z-index:1;display:flex;flex-direction:column;align-items:center;gap:6px;flex:none}
.ac-railseal{margin-top:14px}
.ac-ntag{font-family:var(--font-mono);font-size:8px;letter-spacing:0.12em;text-transform:uppercase;color:var(--on-surface-muted)}
.ac-chain svg.mono{width:17px;height:17px;stroke:var(--bone);fill:none;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round}



/* ============================================================
   CARD POLISH ROUND: app-icon tiles, 3D rail, legend dividers,
   crest glyph, pulse fix, mono apex figure, flip doors
   ============================================================ */
/* 1a. app tiles as home-screen icons */
.ac-app .ic{
  width:44px;height:44px;border-radius:12px;display:grid;place-items:center;border:none;
  box-shadow:inset 0 1px 1px rgba(255,255,255,0.35),inset 0 -2px 3px rgba(0,0,0,0.28),0 3px 6px -2px rgba(21,16,42,0.35);
}
.ac-app[data-app="1"] .ic{background:linear-gradient(160deg,#5A4490,#2A2050)}
.ac-app[data-app="2"] .ic{background:linear-gradient(160deg,#C4A55E,#5C4824)}
.ac-app[data-app="3"] .ic{background:linear-gradient(160deg,#5E948A,#31514B)}
.ac-app .ic svg{stroke:var(--bone)}
.ac-app .ic svg .fill{fill:var(--bone);stroke:none}
.ac-app .ds{display:none}

/* 1b. issuance row glyphs ~10% bigger */
.ric{width:16px;height:16px}
.ric svg{width:15.5px;height:15.5px}

/* 2. fund crest glyph */
.ac-glyph{
  background-image:none;background:var(--aubergine);position:relative;
  border:1px solid rgba(168,139,74,0.55);
  box-shadow:inset 0 1px 0 rgba(232,217,184,0.18),0 2px 5px -2px rgba(21,16,42,0.5);
}
.ac-glyph::after{content:"";position:absolute;inset:3px;border:1px solid rgba(232,217,184,0.3);border-radius:5px;pointer-events:none}
.ac-glyph span{font-family:var(--font-display);font-weight:500;font-size:15px;letter-spacing:0.04em;color:var(--champ-light)}

/* 3. rail: dimensional nodes, three distinct forms */
.ac-chain{
  width:42px;height:42px;border:none;
  background:radial-gradient(circle at 32% 26%,#332A5C,#15102A 74%);
  box-shadow:inset 0 1.5px 1px rgba(255,255,255,0.22),inset 0 -2px 3px rgba(0,0,0,0.55),0 5px 9px -4px rgba(21,16,42,0.5);
}
.ac-chain.sq{
  border-radius:11px;
  background:radial-gradient(circle at 32% 26%,#F4E5C2,#A88B4A 80%);
  box-shadow:inset 0 1.5px 1px rgba(255,255,255,0.5),inset 0 -2px 3px rgba(92,72,36,0.45),0 5px 9px -4px rgba(21,16,42,0.4);
}
.ac-chain.sq svg.mono{stroke:var(--aubergine)}
.ac-chain.dia{
  border-radius:11px;transform:rotate(45deg);
  background:radial-gradient(circle at 32% 26%,#6B5EA9,#241B47 80%);
  box-shadow:inset 0 1.5px 1px rgba(255,255,255,0.3),inset 0 -2px 3px rgba(0,0,0,0.5),0 5px 9px -4px rgba(21,16,42,0.5);
}
.ac-chain.dia svg.mono{transform:rotate(-45deg)}
.ac-chain.dia i{right:2px;bottom:2px;transform:rotate(-45deg)}
.ac-rail::before{top:33px}
.ac-railseal{margin-top:16px}
.ac-layer.on .ac-chain:hover{transform:translateY(-2px)}
.ac-layer.on .ac-chain.dia:hover{transform:rotate(45deg) translate(-1.5px,-1.5px)}

/* 4. pulse clip fix */
.ac-sync{padding-left:3px}

/* 5. section labels as legend pills over a full rule */
.ac-section-label{position:relative;display:block;margin:18px 0 12px}
.ac-section-label::after{content:"";position:absolute;left:0;right:0;top:50%;height:1px;background:var(--box-border);flex:none}
.ac-section-label b{
  position:relative;z-index:1;font-weight:500;
  display:inline-flex;align-items:center;gap:7px;
  background:var(--box-fill);border:1px solid var(--box-border);border-radius:3px;
  padding:4px 10px;
}
.ac-section-label b::before{content:"";width:5px;height:5px;background:var(--champ);transform:rotate(45deg);flex:none}

/* 6. step links read as links */
.hiw .step-cta{color:var(--lava)}
.hiw .step-cta:hover{color:var(--lava)}

/* 7. apex figure in the hero stat font */
.apex-number{font-family:var(--font-mono);font-weight:500;letter-spacing:-0.01em}

/* 8. who-for: flip doors */
.wx-flip{position:relative;min-height:clamp(360px,40vh,430px);perspective:1400px;cursor:pointer;outline:none}
.wx-flip:focus-visible{outline:2px solid var(--champ-light);outline-offset:3px;border-radius:var(--r-card)}
.wx-in{position:absolute;inset:0;transform-style:preserve-3d;transition:transform 620ms cubic-bezier(0.3,0.8,0.3,1)}
.wx-flip.flipped .wx-in{transform:rotateY(180deg)}
.wx-face{
  position:absolute;inset:0;backface-visibility:hidden;-webkit-backface-visibility:hidden;
  border:1px solid rgba(232,217,184,0.18);border-radius:var(--r-card);
  padding:clamp(20px,2.2vw,28px);display:flex;flex-direction:column;
  background:rgba(250,248,244,0.035);overflow:hidden;
}
.wx-front::after{
  content:"";position:absolute;inset:auto -30% -45% -30%;height:80%;
  background:radial-gradient(ellipse at 50% 100%,color-mix(in srgb,var(--doorc) 14%,transparent),transparent 70%);
  pointer-events:none;
}
.wx-flip:hover .wx-face{border-color:rgba(232,217,184,0.4)}
.wx-back{transform:rotateY(180deg);background:rgba(250,248,244,0.055)}
.wx-big{
  font-family:var(--font-display);font-style:italic;font-weight:400;
  font-size:clamp(46px,4.6vw,66px);line-height:1;color:var(--doorc,var(--champ-light));
  margin:auto 0;
}
.wx-hint{
  display:inline-flex;align-items:center;gap:8px;margin-top:auto;
  font-family:var(--font-mono);font-size:9.5px;letter-spacing:0.16em;text-transform:uppercase;
  color:rgba(250,248,244,0.45);
}
.wx-hint svg{width:13px;height:13px;stroke:currentColor;fill:none;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round}
.wx-back h3{
  font-family:var(--font-display);font-weight:400;font-size:clamp(20px,1.9vw,25px);
  line-height:1.15;letter-spacing:var(--track-display);color:var(--bone);margin-bottom:10px;
}
.wx-back p{font-family:var(--font-body);font-size:14px;line-height:1.55;color:rgba(250,248,244,0.68);margin-bottom:14px}
.wx-points{list-style:none;padding:0;margin:0 0 18px;display:grid;gap:9px}
.wx-points li{
  display:flex;align-items:baseline;gap:10px;
  font-family:var(--font-body);font-size:13.5px;color:rgba(250,248,244,0.82);
}
.wx-points li::before{content:"";width:5px;height:5px;background:var(--doorc,var(--champ));transform:rotate(45deg);flex:none;align-self:center}
.wx-back .wx-cta{margin-top:auto}
.whofx.wx-pre .wx-flip{opacity:0;transform:translateY(12px)}
.wx-flip{transition:opacity 340ms var(--ease-out),transform 340ms var(--ease-out)}

@media(prefers-reduced-motion:reduce){
  .wx-in{transition:none}
  .wx-flip{opacity:1;transform:none;transition:none}
}



/* ============================================================
   FLAT ROUND: no brushed gradients anywhere
   ============================================================ */
/* app icons: flat solid squircles, no containing cards */
.ac-app{background:none;border:none;padding:4px 0;box-shadow:none}
.ac-app:hover{border:none}
.ac-app .ic{
  width:46px;height:46px;border-radius:12px;box-shadow:none;border:none;
}
.ac-app[data-app="1"] .ic{background:#4C3778}
.ac-app[data-app="2"] .ic{background:#A88B4A}
.ac-app[data-app="3"] .ic{background:#4E7D74}
.ac-app .nm{color:var(--on-surface-muted)}

/* rail nodes: flat, four typed shapes */
.ac-chain{background:var(--aubergine);box-shadow:none;border:none}
.ac-chain.sq{background:var(--champ);box-shadow:none}
.ac-chain.sq svg.mono{stroke:var(--aubergine)}
.ac-chain.dia{background:#6B5EA9;box-shadow:none}
.ac-chain.net{background:#4E7D74;border-radius:50%}
.ac-layer.on .ac-chain:hover{transform:translateY(-2px)}

/* fund crest: flat too */
.ac-glyph{box-shadow:none}

/* stage-coloured legend pills */
.ac-layer[data-layer="1"] .ac-section-label b{border-color:rgba(168,139,74,0.55);color:var(--champ-rim)}
.ac-layer[data-layer="1"] .ac-section-label b::before{background:var(--champ)}
.ac-layer[data-layer="2"] .ac-section-label b{border-color:rgba(91,119,168,0.55);color:#445C85}
.ac-layer[data-layer="2"] .ac-section-label b::before{background:#5B77A8}
.ac-layer[data-layer="3"] .ac-section-label b{border-color:rgba(78,125,116,0.55);color:#3E655E}
.ac-layer[data-layer="3"] .ac-section-label b::before{background:#4E7D74}

/* who-for: flat watermark cards, all content up front */
.wx-card{
  position:relative;display:flex;flex-direction:column;overflow:hidden;
  background:rgba(250,248,244,0.035);
  border:1px solid rgba(232,217,184,0.18);border-radius:var(--r-card);
  padding:clamp(20px,2.2vw,28px);
  text-decoration:none;color:var(--bone);
  transition:border-color var(--dur-base) var(--ease-out),transform var(--dur-base) var(--ease-out),opacity 340ms var(--ease-out);
}
.wx-card:hover{border-color:var(--doorc-dim,rgba(232,217,184,0.5));transform:translateY(-5px)}
.wx-card:focus-visible{outline:2px solid var(--champ-light);outline-offset:3px}
.wx-mark{
  position:absolute;right:-6px;bottom:-34px;pointer-events:none;
  font-family:var(--font-display);font-style:italic;font-weight:400;
  font-size:clamp(96px,9vw,132px);line-height:1;
  color:var(--doorc,var(--champ-light));opacity:0.09;
}
.wx-card .wx-eyebrow{margin-bottom:6px}
.wx-card .wx-aud{margin-bottom:16px}
.wx-card h3{
  font-family:var(--font-display);font-weight:400;font-size:clamp(21px,1.9vw,26px);
  line-height:1.15;letter-spacing:var(--track-display);color:var(--bone);margin-bottom:8px;
}
.wx-card p{font-family:var(--font-body);font-size:14.5px;line-height:1.55;color:rgba(250,248,244,0.66);margin-bottom:16px}
.wx-card .wx-points{margin-bottom:20px}
.wx-card .wx-cta{margin-top:auto;position:relative;z-index:1}
.wx-card:hover .wx-cta{text-decoration:underline;text-underline-offset:4px}
.wx-card:hover .wx-cta .chev{transform:translateX(3px)}
.whofx.wx-pre .wx-card{opacity:0;transform:translateY(12px)}
@media(prefers-reduced-motion:reduce){.wx-card{opacity:1;transform:none;transition:none}}



/* ---- doodle app tiles ---- */
.ac-apps.ddl-row .ac-app{
  background:var(--bone);border:1px solid var(--box-border);border-radius:6px;
  padding:10px 10px 9px;gap:7px;
}
.ac-apps.ddl-row .ac-app:hover{border-color:rgba(168,139,74,0.5)}
.ddl{width:100%;height:auto;display:block}

/* ---- rail: bare 3D objects on the thread ---- */
.ac-obj{width:46px;height:46px;display:block;filter:drop-shadow(0 3px 4px rgba(21,16,42,0.28))}
.ac-rail{padding:10px 4px 4px}
.ac-rail::before{top:33px}
.ac-railseal{margin-top:16px}
.ac-node:hover .ac-obj{transform:translateY(-2px)}
.ac-obj{transition:transform var(--dur-base) var(--ease-out)}



/* ============================================================
   STRAIGHTFORWARD ROUND: flat circles, no brushed gold anywhere
   ============================================================ */
/* rail: plain dark circles, white icons, done */
.ac-obj{display:none}
.ac-chain{background:var(--aubergine);box-shadow:none;border:none;border-radius:50%;width:40px;height:40px}
.ac-chain svg.mono{width:18px;height:18px;stroke:var(--bone)}
.ac-rail::before{top:30px}
.ac-railseal{margin-top:13px}

/* action chips: flat too */
.ac-op{background:rgba(168,139,74,0.12);box-shadow:none}
.ac-op:hover{background:rgba(168,139,74,0.2);box-shadow:none;transform:none}

/* stack: right-front slab edge matches the slab; thread reads through */
.sx-slab .sx-side.r{fill:#EFE9DC;filter:none}
.sx-slab[aria-selected="true"] .sx-side.r{filter:none}
.sx-thread{opacity:.85}

/* fund crest + stat serial: keep flat */
.acr-serial{background:var(--bone)}

/* ---- whofor triptych ---- */
.whofx-trip{display:grid;grid-template-columns:repeat(3,1fr);gap:0;border-top:1px solid rgba(232,217,184,0.16);border-bottom:1px solid rgba(232,217,184,0.16)}
@media(max-width:900px){.whofx-trip{grid-template-columns:1fr}}
.wx-panel{
  position:relative;display:flex;flex-direction:column;align-items:flex-start;
  padding:clamp(28px,3vw,44px) clamp(22px,2.4vw,36px);
  transition:opacity 340ms var(--ease-out),transform 340ms var(--ease-out),background var(--dur-base) var(--ease-out);
}
.wx-panel + .wx-panel{border-left:1px solid rgba(232,217,184,0.16)}
@media(max-width:900px){.wx-panel + .wx-panel{border-left:none;border-top:1px solid rgba(232,217,184,0.16)}}
.wx-panel:hover{background:rgba(250,248,244,0.03)}
.wx-scene{width:100%;max-width:280px;margin:0 auto 22px}
.wx-scene svg{width:100%;height:auto;display:block}
.wx-scene g{transition:opacity var(--dur-base) var(--ease-out);opacity:.85}
.wx-panel:hover .wx-scene g{opacity:1}
.wx-panel .wx-eyebrow{margin-bottom:10px}
.wx-panel h3{
  font-family:var(--font-display);font-weight:400;font-size:clamp(22px,2vw,27px);
  line-height:1.12;letter-spacing:var(--track-display);color:var(--bone);margin-bottom:8px;
}
.wx-line{font-family:var(--font-body);font-size:14px;line-height:1.55;color:rgba(250,248,244,0.62);margin-bottom:22px;max-width:34ch}
.wx-btn{
  display:inline-flex;align-items:center;gap:8px;
  font-family:var(--font-mono);font-size:11.5px;font-weight:500;
  letter-spacing:var(--track-mono);text-transform:uppercase;
  color:var(--champ-light);text-decoration:none;
  border:1px solid rgba(232,217,184,0.4);border-radius:var(--r);
  padding:10px 18px;margin-top:auto;
  transition:background var(--dur-base) var(--ease-out),color var(--dur-base) var(--ease-out),border-color var(--dur-base) var(--ease-out);
}
.wx-btn::after{content:"\\2192";transition:transform var(--dur-fast) var(--ease-out)}
.wx-btn:hover{background:var(--champ);border-color:var(--champ);color:#15102A}
.wx-btn:hover::after{transform:translateX(3px)}
.wx-btn:focus-visible{outline:2px solid var(--champ-light);outline-offset:3px}
.whofx.wx-pre .wx-panel{opacity:0;transform:translateY(12px)}
.whofx.wx-pre .wx-panel:nth-child(2){transition-delay:60ms}
.whofx.wx-pre .wx-panel:nth-child(3){transition-delay:120ms}

/* ---- apex: certificate framing ---- */
.apex-eyebrow{
  display:inline-flex;align-items:center;gap:10px;
  font-family:var(--font-mono);font-size:11px;font-weight:500;
  letter-spacing:var(--track-mono-caps);text-transform:uppercase;color:var(--champ-rim);
  margin-bottom:14px;
}
.apex-eyebrow::before,.apex-eyebrow::after{content:"";width:6px;height:6px;background:var(--champ);transform:rotate(45deg)}
.apex-figure{flex-direction:row;justify-content:center;align-items:center;gap:clamp(14px,2.5vw,30px)}
.apex-ln{flex:0 1 clamp(40px,8vw,130px);height:1px;background:linear-gradient(90deg,rgba(168,139,74,0),rgba(168,139,74,0.6))}
.apex-ln:last-of-type{background:linear-gradient(90deg,rgba(168,139,74,0.6),rgba(168,139,74,0))}
@media(max-width:640px){.apex-ln{display:none}}
@media(prefers-reduced-motion:reduce){.wx-panel{opacity:1;transform:none;transition:none}}



/* right-front face follows its layer colour when selected (kills the stuck gold edge) */
.sx-slab[aria-selected="true"] .sx-side.r{fill:var(--lc-wash);filter:brightness(0.93)}



/* apex: mono figure sized to fit; CTA becomes a text link (fewer gold buttons) */
.apex-number{font-size:clamp(34px,8.2vw,132px)}
.apex-cta{
  background-image:none;background:none;box-shadow:none;padding:0;border-radius:0;
  color:var(--lava);font-size:12.5px;text-transform:uppercase;
}
.apex-cta:hover{filter:none;transform:none;text-decoration:underline;text-underline-offset:4px;box-shadow:none}



/* ============================================================
   TIDY ROUND: rail legibility, doc link, triptych plates +
   hover micro-animations, bone->purple blends
   ============================================================ */
/* rail: bigger, clearer */
.ac-chain{width:46px;height:46px}
.ac-chain svg.mono{width:23px;height:23px}
.ac-rail::before{top:33px}
.ac-railseal{margin-top:16px}
.ac-ntag{color:var(--aubergine);font-size:8.5px;opacity:.85}
.ac-apps.ddl-row .nm{color:var(--aubergine)}

/* docs text link replaces the gold button */
.sx-doclink{
  font-family:var(--font-mono);font-size:12.5px;font-weight:500;
  letter-spacing:var(--track-mono);text-transform:uppercase;
  color:var(--lava);text-decoration:none;display:inline-flex;align-items:center;gap:8px;
}
.sx-doclink:hover{text-decoration:underline;text-underline-offset:4px}
.sx-doclink .chev{transition:transform var(--dur-fast) var(--ease-out)}
.sx-doclink:hover .chev{transform:translateX(3px)}

/* triptych: soft plates instead of hairlines */
.whofx-trip{border-top:none;border-bottom:none;gap:clamp(14px,1.6vw,22px)}
.whofx-trip .wx-panel{
  border:1px solid rgba(232,217,184,0.15);border-radius:var(--r-card);
  background:rgba(250,248,244,0.028);
}
.whofx-trip .wx-panel + .wx-panel{border-left:1px solid rgba(232,217,184,0.15);border-top:1px solid rgba(232,217,184,0.15)}
.whofx-trip .wx-panel:hover{background:rgba(250,248,244,0.05);border-color:rgba(232,217,184,0.32)}
.wx-btn{background:rgba(232,217,184,0.07);padding:11px 20px;border-radius:5px}

/* scene micro-animations, hover only, once per hover */
.sc-draw{stroke-dasharray:1;stroke-dashoffset:0}
.sc-tok{transform-box:fill-box;transform-origin:center}
@keyframes wx-draw{from{stroke-dashoffset:1}to{stroke-dashoffset:0}}
@keyframes wx-rise{0%{transform:translate(0,0)}55%{transform:translate(3px,-4px)}100%{transform:translate(0,0)}}
.wx-panel:hover .sc-draw{animation:wx-draw 700ms var(--ease-out) both}
.wx-panel:hover .sc-draw.d2{animation-delay:250ms}
.wx-panel:hover .sc-draw.d3{animation-delay:450ms}
.wx-panel:hover .sc-tok{animation:wx-rise 900ms var(--ease-out) both}
.wx-panel:hover .sc-tok.t2{animation-delay:120ms}
.wx-panel:hover .sc-tok.t3{animation-delay:240ms}





/* rail names in lava; app names in the display italic */
.ac-ntag{color:var(--lava);opacity:1}
.ac-apps.ddl-row .nm{
  font-family:var(--font-display);font-style:italic;font-weight:500;
  font-size:13.5px;letter-spacing:0;text-transform:none;color:var(--aubergine);
}

/* layer notes: editorial pull-line, not an infobox */
.sx-artifact.sx-note{
  background:none;border:none;border-left:2px solid var(--lc,var(--champ));
  border-radius:0;padding:3px 0 3px 16px;display:block;overflow:visible;
}
.sx-note .sxa-plain{
  font-family:var(--font-display);font-style:italic;font-weight:400;
  font-size:16px;line-height:1.5;color:var(--aubergine);
}

/* docs link centered under the diagram */
.stackx-fig .stackx-foot{margin-top:22px;display:flex;justify-content:flex-start}

/* triptych buttons: lava, not gold */
.wx-btn{
  color:var(--lava);border-color:rgba(255,122,51,0.45);background:rgba(255,122,51,0.06);
}
.wx-btn:hover{background:var(--lava);border-color:var(--lava);color:#15102A}






/* rail labels: purple, bold; seal centred on the thread */
.ac-ntag{color:#4C3778;font-weight:800;font-size:9px}
.ac-railseal{margin-top:18px}

/* section labels: bold text + trailing rule, no pill card */
.ac-section-label{position:static;display:flex;align-items:center;gap:8px;margin:18px 0 12px}
.ac-section-label::after{content:"";position:static;flex:1;height:1px;background:var(--box-border)}
.ac-section-label b{
  background:none;border:none;padding:0;border-radius:0;
  font-weight:700;display:inline-flex;align-items:center;gap:7px;
}



/* triptych buttons: quiet ghost buttons, lava reserved for links */
.wx-btn{
  color:rgba(250,248,244,0.88);border-color:rgba(250,248,244,0.28);background:rgba(250,248,244,0.05);
}
.wx-btn:hover{background:rgba(250,248,244,0.12);border-color:var(--champ-light);color:var(--champ-light)}



/* divider diamonds clear the card edge; sync line loses its pulse */
.ac-section-label{padding-left:3px}
.ac-sync{padding-left:3px}

/* badge turns softly green while the asset is in service */
.ac-badge.svc{color:#2F6B4F;border-color:rgba(47,107,79,0.45);background:rgba(47,107,79,0.06)}



/* ============================================================
   closer continues the audience field; the break becomes a seal
   ============================================================ */
.closer{background-image:
  linear-gradient(180deg,rgba(255,122,51,0.14) 0%,rgba(255,122,51,0) 45%),
  var(--gradient-hero-striae)}
.closer-orn{
  position:absolute;top:0;left:0;right:0;z-index:1;
  display:flex;align-items:center;justify-content:center;gap:14px;
  pointer-events:none;
}
.closer-orn span{width:clamp(70px,17vw,210px);height:1px;flex:none}
.closer-orn span:first-child{background:linear-gradient(90deg,rgba(232,217,184,0),rgba(232,217,184,0.4))}
.closer-orn span:last-child{background:linear-gradient(90deg,rgba(232,217,184,0.4),rgba(232,217,184,0))}
.closer-orn i{width:7px;height:7px;background:var(--champ);transform:rotate(45deg);flex:none}

/* ---- apex gravitas: certificate frame, scale, letterpress ---- */
.apex-orn{
  display:flex;align-items:center;justify-content:center;gap:14px;
  margin:0 auto clamp(26px,3.6vh,40px);
}
.apex-orn.low{margin:clamp(30px,4.2vh,48px) auto 0}
.apex-orn span{width:clamp(70px,16vw,200px);height:1px;flex:none}
.apex-orn span:first-child{background:linear-gradient(90deg,rgba(168,139,74,0),rgba(168,139,74,0.55))}
.apex-orn span:last-child{background:linear-gradient(90deg,rgba(168,139,74,0.55),rgba(168,139,74,0))}
.apex-orn i{width:7px;height:7px;background:var(--champ);transform:rotate(45deg);flex:none}
.apex-number{font-size:clamp(36px,9vw,150px);text-shadow:0 1px 0 rgba(255,255,255,0.55)}



/* apex sits equidistant between the section above and the dark block below */
.apex-inner{padding-top:clamp(56px,6.5vh,88px);padding-bottom:clamp(96px,12vh,150px)}



/* ============================================================
   IN THEIR WORDS , quote plates hung from the golden thread
   ============================================================ */
.voices{background:var(--bone);color:var(--aubergine);position:relative;z-index:1;overflow:hidden}
.voices-inner{max-width:var(--container-max);margin:0 auto;padding:clamp(72px,9vh,112px) var(--gutter) clamp(40px,5vh,64px)}
.voices-head{display:flex;flex-direction:column;align-items:center;gap:8px;margin-bottom:clamp(30px,4vh,48px);text-align:center}
.voices-eyebrow{
  display:inline-flex;align-items:center;gap:10px;
  font-family:var(--font-mono);font-size:11px;font-weight:500;
  letter-spacing:var(--track-mono-caps);text-transform:uppercase;color:var(--champ-rim);
}
.voices-eyebrow::before,.voices-eyebrow::after{content:"";width:6px;height:6px;background:var(--champ);transform:rotate(45deg)}
.voices-note{font-family:var(--font-mono);font-size:10px;letter-spacing:0.08em;color:var(--on-surface-muted)}

.voices-row{position:relative;display:grid;grid-template-columns:repeat(4,1fr);gap:clamp(14px,1.8vw,26px);align-items:start}
.voices-thread{position:absolute;left:0;right:0;top:0;border-top:1.5px dashed rgba(168,139,74,0.6);pointer-events:none}
@media(max-width:1100px){.voices-row{grid-template-columns:repeat(2,1fr)}}
@media(max-width:620px){.voices-row{grid-template-columns:1fr}.vq{--drop:0px !important}}

.vq{margin:0;display:flex;flex-direction:column;align-items:stretch;--drop:0px}
.vq-hang{
  position:relative;align-self:center;width:0;height:calc(var(--drop) + 28px);
  border-left:1.5px dashed rgba(168,139,74,0.6);
}
.vq-hang i{position:absolute;top:-4px;left:-4.75px;width:8px;height:8px;background:var(--champ);transform:rotate(45deg)}
.vq-hang::after{content:"";position:absolute;bottom:-3px;left:-3.25px;width:5px;height:5px;border-radius:50%;background:var(--champ)}

.vq-plate{
  position:relative;
  background:var(--box-fill);border:1px solid var(--box-border);border-radius:8px;
  padding:26px 22px 18px;
  box-shadow:0 18px 36px -28px rgba(21,16,42,0.35);
  display:flex;flex-direction:column;gap:16px;
  transition:border-color var(--dur-base) var(--ease-out),transform var(--dur-base) var(--ease-out);
}
.vq:hover .vq-plate{border-color:rgba(168,139,74,0.55);transform:translateY(-3px)}
.vq-mark{
  position:absolute;top:8px;left:16px;
  font-family:var(--font-display);font-size:52px;line-height:1;color:var(--champ);opacity:.55;
}
.vq-plate blockquote{
  margin:0;padding:14px 0 0;
  font-family:var(--font-display);font-style:italic;font-weight:400;
  font-size:15.5px;line-height:1.5;color:var(--aubergine);
}
.vq-plate figcaption{
  display:grid;grid-template-columns:auto 1fr;grid-template-rows:auto auto;column-gap:10px;row-gap:8px;align-items:center;
  border-top:1px solid var(--box-border);padding-top:14px;
}
.vq-med{
  width:32px;height:32px;border-radius:50%;overflow:hidden;flex:none;grid-row:1;
  background:var(--aubergine);color:var(--champ-light);
  display:grid;place-items:center;font-family:var(--font-mono);font-size:10px;letter-spacing:0.08em;
}
.vq-med img{width:100%;height:100%;object-fit:cover;display:block}
.vq-who{display:flex;flex-direction:column;gap:2px;grid-row:1}
.vq-who b{font-family:var(--font-display);font-weight:600;font-size:13.5px;color:var(--aubergine);line-height:1.15}
.vq-who span{font-family:var(--font-mono);font-size:9.5px;letter-spacing:0.06em;color:var(--on-surface-muted)}
.vq-src{grid-column:1 / -1;font-family:var(--font-mono);font-size:9px;letter-spacing:0.1em;text-transform:uppercase;color:var(--champ-rim)}

/* the plates sway, barely, as if hung */
@keyframes vq-sway{from{transform:translateY(0)}to{transform:translateY(4px)}}
.vq{animation:vq-sway 6.5s ease-in-out infinite alternate}
.vq:nth-child(3){animation-delay:-2.2s}
.vq:nth-child(4){animation-delay:-3.9s}
.vq:nth-child(5){animation-delay:-1.1s}
@media(prefers-reduced-motion:reduce){.vq{animation:none}}



/* ============================================================
   IN THEIR WORDS v2 , brand windows (flat colour blocks,
   knocked-out wordmarks, sans quotes, demoted attribution)
   ============================================================ */
.vx-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:clamp(12px,1.4vw,18px)}
@media(max-width:1100px){.vx-grid{grid-template-columns:repeat(2,1fr)}}
@media(max-width:640px){.vx-grid{grid-template-columns:1fr}}
.vx{
  display:flex;flex-direction:column;gap:22px;
  background:var(--vxbg);color:var(--vxfg);
  border-radius:16px;padding:clamp(22px,2.2vw,30px);
  min-height:300px;
  transition:transform var(--dur-base) var(--ease-out),box-shadow var(--dur-base) var(--ease-out);
}
.vx:hover{transform:translateY(-4px);box-shadow:0 22px 40px -28px rgba(21,16,42,0.45)}
.vx[data-brand="blackrock"]{grid-column:span 2;--vxbg:#000000;--vxfg:#FFFFFF;--vxmute:rgba(255,255,255,0.62)}
.vx[data-brand="franklin"]{--vxbg:#0E2F55;--vxfg:#FFFFFF;--vxmute:rgba(255,255,255,0.62)}
.vx[data-brand="binance"]{--vxbg:#F0B90B;--vxfg:#1E2026;--vxmute:rgba(30,32,38,0.66)}
@media(max-width:1100px){.vx[data-brand="blackrock"]{grid-column:span 2}}
@media(max-width:640px){.vx[data-brand="blackrock"]{grid-column:auto}}

.vx-brand{display:flex;align-items:center;justify-content:space-between}
.vx-wordmark{
  font-family:var(--font-body);font-weight:800;font-size:clamp(20px,1.8vw,26px);
  letter-spacing:-0.025em;line-height:1;color:var(--vxfg);
}
.vx[data-brand="binance"] .vx-wordmark{text-transform:uppercase;letter-spacing:0.02em}

.vx-quotes{display:flex;flex-direction:column;gap:22px;flex:1}
.vx-quotes.two{display:grid;grid-template-columns:1fr 1fr;gap:clamp(18px,2vw,30px)}
@media(max-width:640px){.vx-quotes.two{grid-template-columns:1fr}}
.vx-q{margin:0;display:flex;flex-direction:column;gap:18px;height:100%}
.vx-q p{
  margin:0;flex:1;
  font-family:var(--font-body);font-weight:450;font-size:clamp(16px,1.25vw,19px);
  line-height:1.3;letter-spacing:-0.012em;color:var(--vxfg);max-width:none;
}
.vx-q footer{display:flex;flex-direction:column;gap:3px;padding-top:14px;border-top:1px solid color-mix(in srgb,var(--vxfg) 18%,transparent)}
.vx-q footer b{font-family:var(--font-body);font-weight:600;font-size:13.5px;color:var(--vxfg)}
.vx-q footer span{font-family:var(--font-body);font-size:12.5px;color:var(--vxmute)}
.vx-q footer em{font-style:normal;font-family:var(--font-mono);font-size:9.5px;letter-spacing:0.1em;text-transform:uppercase;color:var(--vxmute);margin-top:4px}



/* ============================================================
   INDUSTRY VOICES , full-bleed sliding strip, a divider that
   feels larger than the page. Site-native plates, brand-coded.
   ============================================================ */
.voices.vc{padding:clamp(48px,6vh,76px) 0 clamp(28px,3.5vh,44px);overflow:hidden}
.vc-band{
  position:relative;display:flex;gap:18px;width:100%;
  -webkit-mask-image:linear-gradient(90deg,transparent 0,#000 7%,#000 93%,transparent 100%);
  mask-image:linear-gradient(90deg,transparent 0,#000 7%,#000 93%,transparent 100%);
  padding:18px 0;
}
.vc-track{display:flex;align-items:center;gap:18px;flex:none;animation:vc-slide 110s linear infinite;will-change:transform}
.vc-band:hover .vc-track{animation-play-state:paused}
@keyframes vc-slide{from{transform:translateX(0)}to{transform:translateX(calc(-100% - 18px))}}

.vc-card{
  --bc:var(--champ);
  margin:0;flex:none;display:flex;flex-direction:column;gap:18px;
  background:var(--box-fill);border:1px solid var(--box-border);border-radius:10px;
  padding:22px 24px 20px 26px;position:relative;
  box-shadow:0 16px 34px -30px rgba(21,16,42,0.35);
  transition:transform var(--dur-base) var(--ease-out),border-color var(--dur-base) var(--ease-out);
}
.vc-card::before{content:"";position:absolute;left:0;top:18px;bottom:18px;width:3px;border-radius:3px;background:var(--bc)}
.vc-card:hover{transform:translateY(-4px);border-color:rgba(168,139,74,0.5)}
.vc-card.s{width:340px}
.vc-card.m{width:420px}
.vc-card.l{width:520px}
.vc-card[data-brand="blackrock"]{--bc:#000000}
.vc-card[data-brand="franklin"]{--bc:#0E2F55}
.vc-card[data-brand="binance"]{--bc:#F0B90B}
.vc-card[data-brand="jpmorgan"]{--bc:#7A5C2E}

.vc-top{display:flex;align-items:center;min-height:22px}
.vc-logo{height:18px;width:auto;display:block}
.vc-logo.bn{height:22px}
.vc-logo.jp{height:17px}
.vc-logo-text{font-family:var(--font-body);font-weight:800;font-size:15px;letter-spacing:-0.02em;color:#0E2F55}

.vc-quote{
  margin:0;
  font-family:var(--font-display);font-weight:400;
  font-size:19px;line-height:1.38;letter-spacing:-0.005em;color:var(--aubergine);
}
.vc-card.big .vc-quote{font-size:24px;line-height:1.25;letter-spacing:-0.012em}

.vc-meta{display:grid;grid-template-columns:auto 1fr;grid-template-rows:auto auto;column-gap:12px;row-gap:6px;align-items:center;border-top:1px solid var(--box-border);padding-top:14px}
.vc-face{
  grid-row:1 / span 2;width:44px;height:44px;border-radius:50%;object-fit:cover;display:block;
  box-shadow:0 0 0 2px var(--bone),0 0 0 3.5px var(--bc);
}
.vc-face.mono{
  display:grid;place-items:center;background:var(--aubergine);color:var(--champ-light);
  font-family:var(--font-mono);font-size:12px;letter-spacing:0.08em;
}
.vc-who{display:flex;flex-direction:column;gap:2px}
.vc-who b{font-family:var(--font-body);font-weight:600;font-size:13.5px;color:var(--aubergine);line-height:1.15}
.vc-who span{font-family:var(--font-body);font-size:12px;color:var(--on-surface-muted)}
.vc-src{grid-column:2;font-family:var(--font-mono);font-size:9px;letter-spacing:0.1em;text-transform:uppercase;color:var(--champ-rim)}

.vc-foot{
  max-width:var(--container-max);margin:18px auto 0;padding:0 var(--gutter);
  display:flex;justify-content:flex-end;gap:18px;
  font-family:var(--font-mono);font-size:9.5px;letter-spacing:0.12em;text-transform:uppercase;color:var(--on-surface-muted);
}
.vc-foot span + span::before{content:"\\00B7";margin-right:18px;color:var(--champ)}

@media(max-width:640px){
  .vc-card.s,.vc-card.m,.vc-card.l{width:300px}
  .vc-quote{font-size:17px}.vc-card.big .vc-quote{font-size:20px}
}
@media(prefers-reduced-motion:reduce){
  .vc-track{animation:none}
  .vc-band{overflow-x:auto;mask-image:none;-webkit-mask-image:none}
  .vc-track[aria-hidden="true"]{display:none}
}



/* ============================================================
   INDUSTRY VOICES v4 , manual arrow carousel, large bespoke
   plates with a brand-hued radial glow (hero-style), no bars
   ============================================================ */
.voices.vc{padding:clamp(56px,7vh,88px) 0}
.vc-stage{position:relative;display:flex;align-items:center;gap:14px;max-width:var(--container-max);margin:0 auto;padding:0 var(--gutter)}
.vc-viewport{flex:1;min-width:0;overflow:hidden;padding:18px 0}
.vc-track{display:flex;align-items:stretch;gap:22px;animation:none;transition:transform 560ms cubic-bezier(0.3,0.8,0.3,1);will-change:transform}
.vc-band{display:none}

.vc-arrow{
  flex:none;width:46px;height:46px;border-radius:50%;
  background:var(--box-fill);border:1px solid var(--box-border);color:var(--aubergine);
  display:grid;place-items:center;cursor:pointer;
  transition:border-color var(--dur-base) var(--ease-out),background var(--dur-base) var(--ease-out),opacity var(--dur-base) var(--ease-out),transform var(--dur-fast) var(--ease-out);
}
.vc-arrow svg{width:20px;height:20px;stroke:currentColor;fill:none;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}
.vc-arrow:hover{border-color:var(--champ);background:#F4E5C2;transform:translateY(-1px)}
.vc-arrow:focus-visible{outline:2px solid var(--lava);outline-offset:3px}
.vc-arrow[disabled]{opacity:.3;cursor:default;transform:none}
.vc-arrow[disabled]:hover{border-color:var(--box-border);background:var(--box-fill)}
@media(max-width:700px){.vc-stage{gap:8px;padding:0 10px}.vc-arrow{width:38px;height:38px}}

.vc-card{
  --bc:var(--champ);--bc-rgb:168,139,74;
  width:clamp(320px,44vw,600px);min-height:340px;
  padding:30px 32px 26px;border-radius:14px;
  background-color:var(--box-fill);
  background-image:
    radial-gradient(ellipse 70% 60% at 0% 0%,rgba(var(--bc-rgb),0.16),transparent 68%),
    radial-gradient(ellipse 70% 55% at 100% 100%,rgba(var(--bc-rgb),0.09),transparent 70%);
  box-shadow:0 20px 44px -34px rgba(21,16,42,0.4);
  gap:22px;
}
.vc-card::before{display:none}
.vc-card.s,.vc-card.m,.vc-card.l{width:clamp(320px,44vw,600px)}
.vc-card[data-brand="blackrock"]{--bc:#000000;--bc-rgb:0,0,0}
.vc-card[data-brand="franklin"]{--bc:#0E2F55;--bc-rgb:14,47,85}
.vc-card[data-brand="binance"]{--bc:#F0B90B;--bc-rgb:240,185,11}
.vc-card[data-brand="jpmorgan"]{--bc:#7A5C2E;--bc-rgb:122,92,46}
.vc-card:hover{transform:none;border-color:rgba(168,139,74,0.5)}

.vc-top{min-height:26px}
.vc-logo{height:22px}
.vc-logo.bn{height:26px}
.vc-logo.jp{height:20px}
.vc-logo-text{font-size:18px}

.vc-quote{font-size:clamp(19px,1.7vw,24px);line-height:1.34;flex:1}
.vc-card.big .vc-quote{font-size:clamp(22px,2.1vw,30px);line-height:1.22}

.vc-meta{grid-template-rows:auto;row-gap:0;border-top:1px solid var(--box-border);padding-top:16px}
.vc-face{width:52px;height:52px;grid-row:1}
.vc-face.mono{font-size:13px}
.vc-who b{font-size:15px}
.vc-who span{font-size:13px}
.vc-src{display:none}
.vc-foot{display:none}

@media(prefers-reduced-motion:reduce){.vc-track{transition:none}}



/* ---- voices v5: full-bleed viewport, arrows below, varied plates, single-corner hue ---- */
.vc-stage{display:block;padding:0;max-width:none}
.vc-viewport{
  width:100%;overflow:hidden;
  padding:18px 0 18px max(var(--gutter),calc((100vw - var(--container-max)) / 2 + var(--gutter)));
}
.vc-track{align-items:flex-start}
.vc-nav{
  max-width:var(--container-max);margin:14px auto 0;padding:0 var(--gutter);
  display:flex;justify-content:flex-end;gap:28px;
}
.vc-arrow{
  width:auto;height:auto;border-radius:0;background:none;border:none;padding:6px 2px;
  color:var(--aubergine);
}
.vc-arrow svg{width:34px;height:26px;stroke-width:1.5}
.vc-arrow:hover{background:none;border:none;transform:translateX(0);color:var(--lava)}
.vc-arrow.prev:hover{transform:translateX(-3px)}
.vc-arrow.next:hover{transform:translateX(3px)}
.vc-arrow[disabled]{opacity:.25}
.vc-arrow[disabled]:hover{background:none;border:none;color:var(--aubergine);transform:none}

/* hue: one corner only, bottom right */
.vc-card{
  background-image:radial-gradient(ellipse 75% 65% at 100% 100%,rgba(var(--bc-rgb),0.2),transparent 68%);
}

/* three distinct plate forms */
.vc-card.l{width:clamp(340px,46vw,660px);min-height:360px}
.vc-card.l .vc-quote{font-size:clamp(22px,2.1vw,30px);line-height:1.22;letter-spacing:-0.012em}
.vc-card.m{width:clamp(320px,36vw,500px);min-height:360px}
.vc-card.m .vc-quote{font-size:clamp(18px,1.5vw,21px);line-height:1.38}
.vc-card.s{width:clamp(300px,28vw,400px);min-height:360px;padding-top:26px}
.vc-card.s .vc-meta{order:-1;border-top:none;border-bottom:1px solid var(--box-border);padding:0 0 16px}
.vc-card.s .vc-face{width:64px;height:64px}
.vc-card.s .vc-top{order:3;margin-top:auto;justify-content:flex-end}
.vc-card.s .vc-quote{font-size:clamp(17px,1.35vw,19px);line-height:1.4;flex:0 0 auto}
.vc-card.s .vc-logo{height:18px;opacity:.85}
.vc-card.s .vc-logo-text{font-size:15px}



/* ---- voices v6: institutional set, new brand hues + logo sizing ---- */
.vc-card[data-brand="sec"]{--bc:#1B3A6B;--bc-rgb:27,58,107}
.vc-card[data-brand="fed"]{--bc:#2F5D3A;--bc-rgb:47,93,58}
.vc-card[data-brand="bis"]{--bc:#0B3C5D;--bc-rgb:11,60,93}
.vc-card[data-brand="dtcc"]{--bc:#0077C8;--bc-rgb:0,119,200}
.vc-card[data-brand="bny"]{--bc:#0F4C5C;--bc-rgb:15,76,92}
.vc-card[data-brand="nasdaq"]{--bc:#0092CF;--bc-rgb:0,146,207}
.vc-logo.seal{height:34px}
.vc-logo.wide{height:20px}
.vc-logo.bis{height:24px}
.vc-logo-text.bny{color:#0F4C5C;letter-spacing:0.04em}
.vc-card.s .vc-logo.seal{height:30px}



/* ============================================================
   THE RECORD OF OPINION , register-entry carousel on the thread
   ============================================================ */
.voices.vr{
  position:relative;padding:clamp(64px,8vh,104px) 0 clamp(40px,5vh,60px);overflow:hidden;
  background-color:var(--bone);
  background-image:
    radial-gradient(ellipse 60% 50% at 50% 30%,rgba(168,139,74,0.09),transparent 70%),
    repeating-linear-gradient(135deg,rgba(168,139,74,0.045) 0,rgba(168,139,74,0.045) 1px,transparent 1px,transparent 9px);
}
.vr-track{
  display:flex;gap:clamp(18px,2vw,28px);
  overflow-x:auto;overscroll-behavior-x:contain;
  scroll-snap-type:x mandatory;scroll-behavior:smooth;
  padding:16px 0 22px max(var(--gutter),calc((100vw - var(--container-max)) / 2 + var(--gutter)));
  scrollbar-width:none;outline:none;
}
.vr-track::-webkit-scrollbar{display:none}
.vr-track:focus-visible{box-shadow:inset 0 0 0 2px rgba(255,122,51,0.6)}
.vr-track::after{content:"";flex:none;width:max(var(--gutter),calc((100vw - var(--container-max)) / 2))}

.vr-entry{
  --bc:var(--champ);
  position:relative;flex:none;scroll-snap-align:start;
  width:min(78vw,860px);
  display:grid;grid-template-columns:150px minmax(0,1fr);
  background:var(--box-fill);border:1px solid var(--box-border);border-radius:10px;
  padding:clamp(24px,2.6vw,36px) clamp(26px,3vw,44px) clamp(22px,2.2vw,30px) 0;
  opacity:.55;transition:opacity 280ms var(--ease-out),border-color 280ms var(--ease-out);
}
.vr-entry.is-active{opacity:1;border-color:rgba(168,139,74,0.55)}
@media(max-width:860px){.vr-entry{grid-template-columns:1fr;width:min(86vw,560px);padding-left:clamp(22px,4vw,30px)}}

.vr-margin{
  display:flex;flex-direction:column;gap:10px;align-items:flex-start;
  padding:4px 18px 0 clamp(22px,2.4vw,30px);border-right:1px solid var(--box-border);
  font-family:var(--font-mono);text-transform:uppercase;
}
@media(max-width:860px){.vr-margin{flex-direction:row;align-items:center;gap:14px;border-right:none;border-bottom:1px solid var(--box-border);padding:0 0 12px;margin-bottom:18px}}
.vr-index{font-size:9.5px;letter-spacing:0.18em;color:var(--on-surface-muted)}
.vr-theme{font-size:10.5px;font-weight:500;letter-spacing:0.16em;color:var(--champ-rim);line-height:1.4}
.vr-theme::before{content:"";display:inline-block;width:5px;height:5px;background:var(--champ);transform:rotate(45deg);margin-right:8px;vertical-align:1px}

.vr-body{position:relative;padding-left:clamp(26px,3vw,44px);display:flex;flex-direction:column;gap:clamp(22px,2.6vh,34px);min-width:0}
@media(max-width:860px){.vr-body{padding-left:0}}
.vr-hang{
  position:absolute;left:clamp(4px,0.8vw,14px);top:-22px;pointer-events:none;
  font-family:var(--font-display);font-size:clamp(96px,9vw,130px);line-height:1;
  color:var(--champ);opacity:.22;
}
@media(max-width:860px){.vr-hang{left:-10px;top:-14px;font-size:84px}}
.vr-quote{margin:0;position:relative;z-index:1}
.vr-quote p{
  margin:0;max-width:30ch;
  font-family:var(--font-display);font-weight:400;
  font-size:clamp(21px,2.05vw,29px);line-height:1.32;letter-spacing:-0.008em;color:var(--aubergine);
}
.vr-quote em{font-style:italic;color:var(--champ-rim)}

.vr-attr{
  display:grid;grid-template-columns:auto 1fr auto;align-items:center;column-gap:14px;
  border-top:1px solid var(--box-border);padding-top:16px;
}
.vr-face{width:48px;height:48px;border-radius:50%;object-fit:cover;display:block;
  box-shadow:0 0 0 2px var(--box-fill),0 0 0 3px rgba(168,139,74,0.55)}
.vr-face.mono{display:grid;place-items:center;background:var(--aubergine);color:var(--champ-light);
  font-family:var(--font-mono);font-size:12px;letter-spacing:0.08em}
.vr-who{display:flex;flex-direction:column;gap:2px;min-width:0}
.vr-who b{font-family:var(--font-body);font-weight:600;font-size:14.5px;color:var(--aubergine);line-height:1.15}
.vr-who span{font-family:var(--font-body);font-size:12.5px;color:var(--on-surface-muted)}
.vr-sig{display:flex;align-items:center;justify-content:flex-end;min-width:0}
.vr-logo{height:20px;width:auto;display:block;filter:grayscale(1);opacity:.62;transition:filter 280ms var(--ease-out),opacity 280ms var(--ease-out)}
.vr-logo.seal{height:34px}
.vr-logo.wide{height:18px}
.vr-logo.bis{height:22px}
.vr-logo.bn{height:22px}
.vr-entry.is-active .vr-logo{filter:none;opacity:.9}
.vr-logo-text{font-family:var(--font-body);font-weight:800;font-size:16px;letter-spacing:0.04em;color:var(--aubergine);opacity:.7}
.vr-seal{position:absolute;right:14px;bottom:14px;width:7px;height:7px;background:var(--champ);transform:rotate(45deg);opacity:.7}

/* navigation: prev arrow, counter, the record thread with seals, next arrow.
   The arrow buttons mirror the design of .ix-fbtn on
   /solutions/institutions "What an asset can do once it lives on
   T-REX": 48x48 circular, bone fill, aubergine stroke chevron, subtle
   champagne hover ring. Positioned on either side of the counter +
   thread so the whole strip sits centered under the plates. */
.vr-nav{
  max-width:var(--container-max);margin:6px auto 0;padding:0 var(--gutter);
  display:grid;grid-template-columns:auto auto 1fr auto;align-items:center;gap:clamp(14px,2.4vw,28px);
}
.vr-arrow{
  width:48px;height:48px;border-radius:50%;
  display:inline-flex;align-items:center;justify-content:center;
  border:1px solid var(--box-border,#D8D0C2);
  background:var(--box-fill,#FEFCF8);color:var(--aubergine);
  cursor:pointer;flex:none;
  transition:border-color .3s,background .3s,color .3s,opacity .3s,box-shadow .3s;
  box-shadow:0 6px 18px -12px rgba(21,16,42,0.4);
}
.vr-arrow svg{width:20px;height:20px}
.vr-arrow:hover:not(:disabled){border-color:rgba(168,139,74,0.7);background:#fff;box-shadow:0 10px 24px -12px rgba(168,139,74,0.5)}
.vr-arrow:disabled{opacity:0.3;cursor:not-allowed}
.vr-arrow:focus-visible{outline:2px solid rgba(168,139,74,0.6);outline-offset:2px}
.vr-counter{font-family:var(--font-mono);font-size:12px;letter-spacing:0.14em;color:var(--on-surface-muted);font-variant-numeric:tabular-nums;white-space:nowrap;display:inline-flex;align-items:baseline;gap:0.35em}
.vr-counter b{font-weight:500;color:var(--aubergine);display:inline-block;min-width:1.8em;text-align:center}
.vr-counter b.is-flip{animation:vr-num-flip 260ms var(--ease-out)}
@keyframes vr-num-flip{
  0%{opacity:0;transform:translateY(-4px)}
  60%{opacity:1}
  100%{opacity:1;transform:translateY(0)}
}
@media(prefers-reduced-motion:reduce){
  .vr-counter b.is-flip{animation:none}
}
.vr-thread{position:relative;height:24px;display:flex;justify-content:space-between;align-items:center}
.vr-thread::before{content:"";position:absolute;left:0;right:0;top:50%;border-top:1.5px dashed rgba(168,139,74,0.5)}
.vr-fill{position:absolute;left:0;top:50%;height:1.5px;margin-top:-0.75px;width:0;background:var(--champ);transition:width 320ms var(--ease-out)}
.vr-node{
  position:relative;z-index:1;width:22px;height:22px;padding:0;border:none;background:none;cursor:pointer;
  display:grid;place-items:center;
}
.vr-node::before{content:"";width:8px;height:8px;transform:rotate(45deg);background:var(--bone);border:1.5px solid var(--champ);
  transition:background 220ms var(--ease-out),transform 220ms var(--ease-out)}
.vr-node:hover::before{background:#F4E5C2}
.vr-node.is-active::before{background:var(--champ);transform:rotate(45deg) scale(1.35)}
.vr-node:focus-visible{outline:2px solid var(--lava);outline-offset:2px;border-radius:3px}
/* Legacy .vr-arrow selectors from the earlier chevron design have been
   removed — the arrow controls added inside .vr-nav now use the
   circular pill defined earlier (mirrors .ix-fbtn). Only the small
   responsive collapse of .vr-nav is preserved. */
@media(max-width:700px){
  .vr-nav{grid-template-columns:auto auto;gap:14px}
  .vr-thread{grid-column:1 / -1;grid-row:2}
  .vr-arrow{grid-row:1}
}

.vr-note{
  max-width:var(--container-max);margin:22px auto 0;padding:0 var(--gutter);
  font-family:var(--font-mono);font-size:9.5px;letter-spacing:0.08em;color:var(--on-surface-muted);text-align:left;
}
/* On wide screens the disclaimer's natural width (~1453px) exceeds the
   container's inner width, so we let the note escape the container-max
   and force a single right-aligned line. Below the breakpoint the note
   wraps normally and stays left-aligned so orphaned words read naturally
   instead of leaving a lone tail flush to the right edge. */
@media(min-width:1560px){
  .vr-note{
    max-width:none;
    padding:0 clamp(24px,2vw,44px);
    white-space:nowrap;
    text-align:right;
  }
}
@media(prefers-reduced-motion:reduce){
  .vr-track{scroll-behavior:auto}
  .vr-entry,.vr-logo,.vr-fill,.vr-node::before{transition:none}
}



/* snap respects the page gutter; attribution sits at the plate foot */
.vr-track{scroll-padding-inline-start:max(var(--gutter),calc((100vw - var(--container-max)) / 2 + var(--gutter)))}
.vr-attr{margin-top:auto}



/* ============================================================
   TIDY PASS: link underline system, chromeless doodles,
   register plates v2 (portrait plate, numeral), apex mark
   ============================================================ */
/* lava links: 1px bar draws left→right under the TEXT only; arrow excluded and 10% larger */
.sx-cta,.sx-doclink,.apex-cta,.hiw .step-cta{position:relative;padding-bottom:3px;gap:8px}
.sx-cta:hover,.sx-doclink:hover,.apex-cta:hover,.hiw .step-cta:hover{text-decoration:none}
.sx-cta .chev,.sx-doclink .chev,.hiw .step-cta .chev{display:inline-block;width:1.2em;text-align:center;font-size:1.1em;line-height:1}
.sx-cta::after,.sx-doclink::after,.apex-cta::after,.hiw .step-cta::after{
  content:"";position:absolute;left:0;right:calc(1.32em + 8px);bottom:0;height:1px;
  background:currentColor;transform:scaleX(0);transform-origin:left;
  transition:transform var(--dur-base) var(--ease-out);
}
.apex-cta::after{right:0}
.sx-cta:hover::after,.sx-doclink:hover::after,.apex-cta:hover::after,.hiw .step-cta:hover::after,.step.active .step-cta::after{transform:scaleX(1)}
.step .step-cta::after{right:calc(1.32em + 8px);width:auto;background:currentColor}

/* app doodles: no containing cards */
.ac-apps.ddl-row .ac-app{background:none;border:none;padding:0 2px;box-shadow:none}
.ac-apps.ddl-row .ac-app:hover{border:none}

/* hover state holds: the card keeps the last hovered step (no unfold on leave) */

/* register plates v2 */
.vr-entry{grid-template-columns:120px minmax(0,1fr);overflow:hidden}
.vr-margin{gap:0;padding-top:6px}
.vr-theme{display:none}
.vr-num{
  position:absolute;right:18px;top:-26px;pointer-events:none;
  font-family:var(--font-display);font-weight:400;font-size:clamp(120px,12vw,180px);line-height:1;
  color:var(--champ);opacity:.08;letter-spacing:-0.04em;
}
.vr-hang{opacity:.26}
.vr-entry:not(.is-active){cursor:pointer}
.vr-attr{grid-template-columns:auto 1fr auto;column-gap:18px;align-items:end;border-top:none;padding-top:0;margin-top:auto}
.vr-face{
  width:112px;height:112px;border-radius:6px;object-fit:cover;object-position:50% 18%;display:block;
  box-shadow:none;
  -webkit-mask-image:linear-gradient(180deg,#000 72%,rgba(0,0,0,0.55) 100%);
  mask-image:linear-gradient(180deg,#000 72%,rgba(0,0,0,0.55) 100%);
  filter:saturate(0.85);
}
.vr-face.mono{width:112px;height:112px;font-size:22px;border-radius:6px;background:var(--aubergine);color:var(--champ-light)}
.vr-who{padding-bottom:8px;border-top:1px solid var(--box-border);padding-top:14px;align-self:stretch;justify-content:flex-end}
.vr-who b{font-family:var(--font-display);font-weight:600;font-size:19px;letter-spacing:-0.01em}
.vr-who span{font-family:var(--font-body);font-size:12.5px;color:var(--on-surface-muted);line-height:1.35}
.vr-who span + span{font-family:var(--font-mono);font-size:10px;letter-spacing:0.12em;text-transform:uppercase;color:var(--champ-rim);margin-top:4px}
.vr-sig{align-self:end;padding-bottom:10px}
.vr-arrows{display:none}
.vr-nav{grid-template-columns:auto auto 1fr auto}
@media(max-width:860px){.vr-entry{grid-template-columns:1fr}.vr-num{font-size:110px;right:10px}.vr-face,.vr-face.mono{width:84px;height:84px}}

/* apex: the institution's own mark makes the story immediate */
.apex-logo{display:block;height:60px;width:auto;margin:0 auto 16px;opacity:.92}



/* plates size to their own content; short quotes do not inherit the tallest height */
.vr-track{align-items:stretch}
.vr-entry{min-height:380px}



/* ============================================================
   ROUND: scroll-reveal cues, copy box, dark register plates
   ============================================================ */
/* problem card: wider text box */
.missing-layer .ml-card{max-width:min(1040px,92%);margin-left:auto;margin-right:auto;align-self:center}
.ml-headline{max-width:none}

/* stack: once-only cue that the label chips are controls */
@keyframes sx-cue{0%{fill:var(--box-fill)}50%{fill:var(--lc-wash)}100%{fill:var(--box-fill)}}
.stackx:not(.sx-pre) .sx-slab:not([aria-selected="true"]) .sx-labelbox{animation:sx-cue 1100ms var(--ease-out) 1 both}
.stackx:not(.sx-pre) .sx-slab[data-l="2"] .sx-labelbox{animation-delay:500ms}
.stackx:not(.sx-pre) .sx-slab[data-l="3"] .sx-labelbox{animation-delay:800ms}
.stackx:not(.sx-pre) .sx-slab[data-l="4"] .sx-labelbox{animation-delay:1100ms}

/* register plates: deep aubergine, contents pushed left, no margin column or numeral */
.vr-margin,.vr-num{display:none}
.vr-entry{
  grid-template-columns:1fr;
  background:var(--aubergine);border-color:rgba(232,217,184,0.22);
  padding:clamp(18px,2vw,26px) clamp(20px,2.4vw,32px);
  opacity:.62;
}
.vr-entry.is-active{opacity:1;border-color:rgba(232,217,184,0.55)}
.vr-body{padding-left:clamp(22px,2.4vw,34px)}
.vr-hang{left:-6px;top:-20px;color:var(--champ-light);opacity:.32}
.vr-quote p{color:var(--bone);max-width:34ch}
.vr-quote em{color:var(--champ-light)}
.vr-who{border-top:1px solid rgba(232,217,184,0.2)}
.vr-who b{color:var(--bone)}
.vr-who span{color:rgba(250,248,244,0.62)}
.vr-who span + span{color:var(--champ-light)}
.vr-face{filter:saturate(0.9);
  -webkit-mask-image:linear-gradient(180deg,#000 70%,rgba(0,0,0,0.45) 100%);
  mask-image:linear-gradient(180deg,#000 70%,rgba(0,0,0,0.45) 100%)}
.vr-face.mono{background:#241B47;color:var(--champ-light);border:1px solid rgba(232,217,184,0.25)}
.vr-seal{background:var(--champ-light);opacity:.8}
/* logos: larger, rendered as clean white marks on the dark plate */
.vr-logo{filter:brightness(0) invert(1);opacity:.62;height:30px}
.vr-logo.seal{height:48px}
.vr-logo.wide{height:26px}
.vr-logo.bis{height:30px}
.vr-logo.bn{height:30px}
.vr-entry.is-active .vr-logo{filter:brightness(0) invert(1);opacity:.95}
.vr-logo-text{color:var(--champ-light);opacity:.95;font-size:22px}

/* slide arrival: the quote settles in, then the attribution, once per activation */
@keyframes vr-in{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}
.vr-entry.is-active .vr-quote{animation:vr-in 520ms var(--ease-out) both}
.vr-entry.is-active .vr-attr{animation:vr-in 520ms var(--ease-out) 140ms both}
.vr-entry.is-active .vr-hang{animation:vr-in 640ms var(--ease-out) both}

/* thread: smoother travel */
.vr-fill{transition:width 640ms cubic-bezier(0.22,1,0.36,1)}
.vr-node::before{transition:background 320ms var(--ease-out),transform 420ms cubic-bezier(0.22,1,0.36,1)}

@media(prefers-reduced-motion:reduce){
  .vr-entry.is-active .vr-quote,.vr-entry.is-active .vr-attr,.vr-entry.is-active .vr-hang{animation:none}
  .stackx .sx-labelbox{animation:none}
}



/* seals keep their native colour on the dark plate; wordmarks stay white silhouettes */
.vr-logo.seal,.vr-entry.is-active .vr-logo.seal{filter:none;opacity:.92}
.vr-logo.seal{opacity:.7}

/* problem card: headline and sub fill the card */
.missing-layer .ml-card .ml-headline{max-width:none}
.missing-layer .ml-card .ml-sub{max-width:72ch}



/* ---- voices: larger quote, larger marks, glyph behind, butter-smooth arrival ---- */
.vr-quote p{font-size:clamp(24px,2.6vw,37px);line-height:1.26;max-width:none;letter-spacing:-0.012em}
.vr-body{padding-left:clamp(18px,2vw,30px);padding-right:clamp(8px,1vw,16px);padding-top:clamp(60px,6.5vw,90px)}
.vr-hang{z-index:0;left:-4px;top:-12px;font-size:clamp(140px,13vw,190px);opacity:.5;color:var(--champ-light)}
.vr-quote{z-index:1;flex:1 1 auto;display:flex;flex-direction:column;justify-content:center}
.vr-logo{height:36px}
.vr-logo.seal{height:58px}
.vr-logo.wide{height:34px}
.vr-logo.jp{height:30px}
.vr-logo.bis{height:36px}
.vr-logo.bn{height:36px}
.vr-logo-text{font-size:26px}
/* no keyframes, no opacity flashes: a single eased settle via transitions */
.vr-entry.is-active .vr-quote,.vr-entry.is-active .vr-attr,.vr-entry.is-active .vr-hang{animation:none}
.vr-quote,.vr-attr{transform:translateY(6px);transition:transform 720ms cubic-bezier(0.22,1,0.36,1)}
.vr-entry.is-active .vr-quote,.vr-entry.is-active .vr-attr{transform:none}
.vr-entry.is-active .vr-attr{transition-delay:90ms}
.vr-entry{transition:opacity 600ms cubic-bezier(0.22,1,0.36,1),border-color 600ms cubic-bezier(0.22,1,0.36,1)}
@media(prefers-reduced-motion:reduce){.vr-quote,.vr-attr{transform:none;transition:none}}



/* voices: text nudged further down under the glyph so the giant quote
   mark sits clearly above the text and the paragraph reads a touch
   more centered on the plate. */
.vr-quote{padding-top:42px}
.vr-entry{min-height:460px}
.voices.vr{padding-bottom:clamp(88px,11vh,140px)}



/* voices: larger portrait, no attribution rule, equal generous padding above and below */
.vr-who{border-top:none;padding-top:0}
.vr-face,.vr-face.mono{width:156px;height:156px;border-radius:8px;object-position:50% 20%;
  -webkit-mask-image:linear-gradient(180deg,#000 78%,rgba(0,0,0,0.55) 100%);
  mask-image:linear-gradient(180deg,#000 78%,rgba(0,0,0,0.55) 100%)}
.vr-entry{min-height:500px}
.voices.vr{padding-top:clamp(110px,13vh,170px);padding-bottom:clamp(110px,13vh,170px)}
@media(max-width:860px){.vr-face,.vr-face.mono{width:110px;height:110px}}



/* slab cue flashes removed */
.stackx .sx-labelbox,.stackx:not(.sx-pre) .sx-slab:not([aria-selected="true"]) .sx-labelbox{animation:none}



/* seals: larger */
.vr-logo.seal{height:76px}



/* ============================================================
   THE NEXT ENTRY , closing section as register rows on the thread
   ============================================================ */
.whofx.wxr .whofx-head{max-width:820px;margin-bottom:clamp(40px,5.5vh,64px)}
.wx-kicker{
  display:inline-flex;align-items:center;gap:10px;margin-bottom:16px;
  font-family:var(--font-mono);font-size:11px;font-weight:500;
  letter-spacing:var(--track-mono-caps);text-transform:uppercase;color:var(--champ-light);
}
.wx-kicker::before{content:"";width:6px;height:6px;background:var(--champ);transform:rotate(45deg)}
.whofx.wxr .whofx-head h2{font-size:clamp(34px,4.4vw,56px)}
.whofx.wxr .whofx-sub{margin-top:14px}

.wx-register{position:relative;display:block;border:none;gap:0;padding-left:0}
.wx-thread{position:absolute;left:13px;top:-8px;bottom:18px;border-left:1.5px dashed rgba(232,217,184,0.45);pointer-events:none}

.wx-row{
  position:relative;display:grid;align-items:center;
  grid-template-columns:28px 200px 230px minmax(0,1fr) auto;gap:clamp(18px,2.4vw,36px);
  padding:clamp(22px,3vh,34px) 0 clamp(22px,3vh,34px) 0;
  border-top:1px solid rgba(232,217,184,0.14);
  transition:background var(--dur-base) var(--ease-out),opacity 340ms var(--ease-out),transform 340ms var(--ease-out);
}
.wx-row:last-of-type{border-bottom:1px solid rgba(232,217,184,0.14)}
.wx-row:hover{background:linear-gradient(90deg,rgba(232,217,184,0.05),rgba(232,217,184,0) 70%)}
.wx-seal{
  width:10px;height:10px;transform:rotate(45deg);justify-self:center;
  background:var(--aubergine);border:1.5px solid var(--champ);
  transition:background var(--dur-base) var(--ease-out),transform var(--dur-base) var(--ease-out),box-shadow var(--dur-base) var(--ease-out);
}
.wx-row:hover .wx-seal,.wx-row:focus-within .wx-seal{background:var(--champ);transform:rotate(45deg) scale(1.3);box-shadow:0 0 0 6px rgba(168,139,74,0.18)}
.wx-seal.empty{border-style:dashed;border-color:rgba(232,217,184,0.55)}

.wx-rowscene{width:200px}
.wx-rowscene svg{width:100%;height:auto;display:block}
.wx-rowscene g{opacity:.7;transition:opacity var(--dur-base) var(--ease-out)}
.wx-row:hover .wx-rowscene g{opacity:1}
.wx-row:hover .sc-draw{animation:wx-draw 700ms var(--ease-out) both}
.wx-row:hover .sc-draw.d2{animation-delay:250ms}
.wx-row:hover .sc-draw.d3{animation-delay:450ms}
.wx-row:hover .sc-tok{animation:wx-rise 900ms var(--ease-out) both}
.wx-row:hover .sc-tok.t2{animation-delay:120ms}
.wx-row:hover .sc-tok.t3{animation-delay:240ms}

.wx-rowlabel{display:flex;flex-direction:column;gap:6px}
.wx-rowlabel .wx-eyebrow{margin:0}
.wx-rowlabel .wx-aud{margin:0;line-height:1.5}
.wx-statement{
  margin:0;max-width:26ch;
  font-family:var(--font-display);font-weight:400;font-size:clamp(20px,1.9vw,26px);
  line-height:1.22;letter-spacing:var(--track-display);color:var(--bone);
}
.wx-actions{display:flex;flex-direction:column;align-items:flex-end;gap:10px;white-space:nowrap}
.wx-primary{
  display:inline-flex;align-items:center;gap:8px;
  font-family:var(--font-mono);font-size:11.5px;font-weight:500;
  letter-spacing:var(--track-mono);text-transform:uppercase;
  color:#15102A;background:var(--champ);text-decoration:none;
  padding:11px 18px;border-radius:4px;
  transition:background var(--dur-base) var(--ease-out),transform var(--dur-fast) var(--ease-out);
}
.wx-primary:hover{background:var(--champ-light);transform:translateY(-1px)}
.wx-primary .chev{transition:transform var(--dur-fast) var(--ease-out)}
.wx-primary:hover .chev{transform:translateX(3px)}
.wx-primary:focus-visible{outline:2px solid var(--champ-light);outline-offset:3px}
.wx-secondary{
  font-family:var(--font-mono);font-size:10.5px;letter-spacing:0.1em;text-transform:uppercase;
  color:rgba(250,248,244,0.62);text-decoration:none;position:relative;padding-bottom:2px;
}
.wx-secondary::after{content:"";position:absolute;left:0;right:0;bottom:0;height:1px;background:currentColor;transform:scaleX(0);transform-origin:left;transition:transform var(--dur-base) var(--ease-out)}
.wx-secondary:hover{color:var(--champ-light)}
.wx-secondary:hover::after{transform:scaleX(1)}

.wx-fallback{grid-template-columns:28px 1fr;padding:20px 0;border-bottom:none}
.wx-fallback:hover{background:none}
.wx-fallback-text{margin:0;font-family:var(--font-body);font-size:14px;color:rgba(250,248,244,0.6)}
.wx-fallback-text a{color:var(--lava);text-decoration:none;font-family:var(--font-mono);font-size:12px;letter-spacing:0.08em;text-transform:uppercase;margin-left:8px;position:relative;padding-bottom:2px}
.wx-fallback-text a::after{content:"";position:absolute;left:0;right:calc(1.32em + 8px);bottom:0;height:1px;background:currentColor;transform:scaleX(0);transform-origin:left;transition:transform var(--dur-base) var(--ease-out)}
.wx-fallback-text a:hover::after{transform:scaleX(1)}
.wx-fallback-text a .chev{display:inline-block;width:1.2em;text-align:center;font-size:1.1em;margin-left:4px}

.whofx.wx-pre .wx-row{opacity:0;transform:translateY(10px)}
.whofx.wx-pre .wx-row:nth-of-type(2){transition-delay:70ms}
.whofx.wx-pre .wx-row:nth-of-type(3){transition-delay:140ms}
.whofx.wx-pre .wx-row:nth-of-type(4){transition-delay:210ms}

@media(max-width:1100px){
  .wx-row{grid-template-columns:28px 180px minmax(0,1fr);grid-template-rows:auto auto;row-gap:14px}
  .wx-rowscene{grid-row:1 / span 2}
  .wx-statement{grid-column:3}
  .wx-actions{grid-column:3;flex-direction:row;align-items:center;gap:18px}
}
@media(max-width:700px){
  .wx-row{grid-template-columns:22px minmax(0,1fr);row-gap:12px}
  .wx-rowscene{display:none}
  .wx-rowlabel,.wx-statement,.wx-actions{grid-column:2}
  .wx-actions{flex-wrap:wrap;white-space:normal}
  .wx-thread{left:10px}
}
@media(prefers-reduced-motion:reduce){.wx-row{opacity:1;transform:none;transition:none}}



/* ============================================================
   THE NEXT ENTRY v2 , the record thread routes through three
   free stations (illustration one side, address the other)
   ============================================================ */
.whofx.wxt .whofx-head{max-width:820px;margin-bottom:clamp(48px,7vh,88px)}
.whofx.wxt .whofx-head h2{font-size:clamp(34px,4.4vw,56px)}
.wx-route{position:relative;display:block;border:none;padding:0}
.wx-path{position:absolute;inset:0;width:100%;height:100%;pointer-events:none;overflow:visible}
.wx-path-dash{fill:none;stroke:rgba(232,217,184,0.38);stroke-width:1.5;stroke-dasharray:3 6;stroke-linecap:round}
.wx-path-ink{fill:none;stroke:var(--champ);stroke-width:1.6;stroke-linecap:round}

.wx-station{
  position:relative;display:grid;align-items:center;
  grid-template-columns:repeat(12,1fr);column-gap:clamp(12px,1.6vw,24px);
  min-height:clamp(260px,34vh,360px);
  padding:clamp(18px,3vh,34px) 0;
  transition:opacity 420ms var(--ease-out),transform 420ms var(--ease-out);
}
.wx-station .wx-scene{grid-column:1 / span 5;width:min(100%,400px)}
.wx-station .wx-text{grid-column:7 / span 6}
.wx-station.scene-right .wx-scene{grid-column:8 / span 5;justify-self:end}
.wx-station.scene-right .wx-text{grid-column:1 / span 6;grid-row:1}
.wx-station.inset .wx-scene{grid-column:2 / span 5}
.wx-station.inset .wx-text{grid-column:8 / span 5}
.wx-scene svg{width:100%;height:auto;display:block}
.wx-scene g{opacity:.82;transition:opacity var(--dur-base) var(--ease-out)}
.wx-station:hover .wx-scene g{opacity:1}
.wx-station:hover .sc-draw{animation:wx-draw 700ms var(--ease-out) both}
.wx-station:hover .sc-draw.d2{animation-delay:250ms}
.wx-station:hover .sc-draw.d3{animation-delay:450ms}
.wx-station:hover .sc-tok{animation:wx-rise 900ms var(--ease-out) both}
.wx-station:hover .sc-tok.t2{animation-delay:120ms}
.wx-station:hover .sc-tok.t3{animation-delay:240ms}

/* the seal sits on the thread between picture and words */
.wx-station .wx-seal{
  position:absolute;top:50%;left:calc(50% - 6px);margin-top:-6px;
  width:12px;height:12px;transform:rotate(45deg);
  background:var(--aubergine);border:1.5px solid var(--champ);
  transition:background 360ms var(--ease-out),box-shadow 360ms var(--ease-out),transform 360ms var(--ease-out);
}
.wx-station.scene-right .wx-seal{left:calc(54% - 6px)}
.wx-station.inset .wx-seal{left:calc(56% - 6px)}
.wx-station.is-struck .wx-seal{background:var(--champ);box-shadow:0 0 0 7px rgba(168,139,74,0.16);transform:rotate(45deg) scale(1.15)}

.wx-text{display:flex;flex-direction:column;align-items:flex-start;gap:10px;max-width:440px}
.wx-head{
  font-family:var(--font-mono);font-size:11px;font-weight:500;
  letter-spacing:var(--track-mono-caps);text-transform:uppercase;color:var(--champ-light);
}
.wx-head b{font-weight:500;color:var(--champ)}
.wx-text .wx-aud{margin:0 0 6px;font-family:var(--font-mono);font-size:10px;letter-spacing:0.08em;color:rgba(250,248,244,0.5)}
.wx-text .wx-statement{
  margin:0 0 8px;max-width:24ch;
  font-family:var(--font-display);font-weight:400;font-size:clamp(24px,2.3vw,32px);
  line-height:1.18;letter-spacing:var(--track-display);color:var(--bone);
}
.wx-cta{
  display:inline-flex;align-items:center;gap:9px;
  font-family:var(--font-mono);font-size:11.5px;font-weight:500;
  letter-spacing:var(--track-mono);text-transform:uppercase;
  color:var(--bone);text-decoration:none;
  border:1px solid rgba(250,248,244,0.34);border-radius:4px;padding:11px 18px;
  transition:border-color var(--dur-base) var(--ease-out),color var(--dur-base) var(--ease-out),background var(--dur-base) var(--ease-out);
}
.wx-cta .chev{display:inline-block;width:1.2em;text-align:center;font-size:1.1em;transition:transform var(--dur-fast) var(--ease-out)}
.wx-cta:hover{border-color:var(--champ-light);color:var(--champ-light);background:rgba(232,217,184,0.06)}
.wx-cta:hover .chev{transform:translateX(3px)}
.wx-cta:focus-visible{outline:2px solid var(--champ-light);outline-offset:3px}

.wx-exit{position:relative;display:flex;align-items:center;gap:16px;justify-content:center;padding:clamp(28px,4vh,44px) 0 8px}
.wx-exit .wx-seal{position:static;margin:0;transform:rotate(45deg);width:12px;height:12px;background:var(--aubergine);border:1.5px dashed rgba(232,217,184,0.6)}
.wx-exit p{margin:0;font-family:var(--font-body);font-size:14px;color:rgba(250,248,244,0.6)}
.wx-exit a{color:var(--lava);text-decoration:none;font-family:var(--font-mono);font-size:12px;letter-spacing:0.08em;text-transform:uppercase;margin-left:8px;position:relative;padding-bottom:2px}
.wx-exit a::after{content:"";position:absolute;left:0;right:calc(1.32em + 8px);bottom:0;height:1px;background:currentColor;transform:scaleX(0);transform-origin:left;transition:transform var(--dur-base) var(--ease-out)}
.wx-exit a:hover::after{transform:scaleX(1)}
.wx-exit a .chev{display:inline-block;width:1.2em;text-align:center;font-size:1.1em;margin-left:4px}

.whofx.wx-pre .wx-station{opacity:0;transform:translateY(12px)}
.whofx.wx-pre .wx-station[data-i="2"]{transition-delay:80ms}
.whofx.wx-pre .wx-station[data-i="3"]{transition-delay:160ms}

@media(max-width:860px){
  .wx-station{grid-template-columns:1fr;min-height:0;row-gap:14px;padding-left:28px}
  .wx-station .wx-scene,.wx-station.scene-right .wx-scene,.wx-station.inset .wx-scene{grid-column:1;width:min(100%,320px);justify-self:start}
  .wx-station .wx-text,.wx-station.scene-right .wx-text,.wx-station.inset .wx-text{grid-column:1;grid-row:auto}
  .wx-station .wx-seal,.wx-station.scene-right .wx-seal,.wx-station.inset .wx-seal{left:0;top:28px;margin-top:0}
  .wx-exit{justify-content:flex-start;padding-left:28px}
}
@media(prefers-reduced-motion:reduce){
  .wx-station{opacity:1;transform:none;transition:none}
  .wx-path-ink{stroke-dashoffset:0 !important}
}



/* seals sit in the gap between picture and words; illustrations a touch larger */
.wx-station .wx-seal{left:calc(45% - 6px)}
.wx-station.scene-right .wx-seal{left:calc(53% - 6px)}
.wx-station.inset .wx-seal{left:calc(51% - 6px)}
.wx-station .wx-scene{width:min(100%,460px)}



/* ---- formal schematic: straight spine, right-angle branches, numbered figures ---- */
.wx-route{padding-top:8px}
.wx-station{border-top:1px solid rgba(232,217,184,0.1);min-height:clamp(240px,30vh,320px)}
.wx-station:first-of-type{border-top:none}
.wx-station .wx-seal,.wx-station.scene-right .wx-seal,.wx-station.inset .wx-seal{left:calc(50% - 6px)}
.wx-station .wx-scene{grid-column:1 / span 5;width:min(100%,380px);justify-self:start}
.wx-station .wx-text{grid-column:8 / span 5}
.wx-station.scene-right .wx-scene{grid-column:8 / span 5;justify-self:end}
.wx-station.scene-right .wx-text{grid-column:1 / span 5}
.wx-station.inset .wx-scene{grid-column:1 / span 5}
.wx-station.inset .wx-text{grid-column:8 / span 5}
.wx-fig{
  display:block;margin-top:12px;
  font-family:var(--font-mono);font-size:9.5px;letter-spacing:0.16em;text-transform:uppercase;color:rgba(250,248,244,0.45);
}
.wx-station.scene-right .wx-fig{text-align:right}
.wx-scene g{opacity:.75}
.wx-text .wx-statement{font-size:clamp(21px,2vw,27px);max-width:22ch}
.wx-branch{stroke:rgba(232,217,184,0.35);stroke-width:1;stroke-dasharray:3 6;transition:stroke 360ms var(--ease-out)}
.wx-branch.is-struck{stroke:var(--champ);stroke-dasharray:none}
.wx-exit{border-top:1px solid rgba(232,217,184,0.1);padding-top:clamp(26px,3.6vh,40px)}



/* exit seal sits on the spine; the note hangs beneath it */
.wx-exit{flex-direction:column;align-items:center;gap:16px;justify-content:center;padding-left:0}



/* ============================================================
   THE NEXT ENTRY v6 , three plates, expert-grade discipline
   ============================================================ */
.whofx.wxp .whofx-head{max-width:820px;margin-bottom:clamp(44px,6vh,72px)}
.whofx.wxp .whofx-head h2{font-size:clamp(34px,4.4vw,56px)}
.whofx.wxp .whofx-sub{margin-top:14px}

.wx-plates{
  display:grid;grid-template-columns:repeat(3,1fr);gap:clamp(16px,1.8vw,24px);
  border:none;padding:0;
}
@media(max-width:960px){.wx-plates{grid-template-columns:1fr;max-width:560px}}

.wx-plate{
  position:relative;
  display:grid;grid-template-rows:auto 1fr auto;row-gap:0;
  background:linear-gradient(180deg,rgba(250,248,244,0.045),rgba(250,248,244,0.025));
  border:1px solid rgba(232,217,184,0.16);border-radius:12px;
  padding:0 0 clamp(22px,2.4vw,30px);
  box-shadow:inset 0 1px 0 rgba(250,248,244,0.06);
  transition:border-color var(--dur-base) var(--ease-out),background var(--dur-base) var(--ease-out),opacity 340ms var(--ease-out),transform 340ms var(--ease-out);
}
.wx-plate:hover{border-color:rgba(232,217,184,0.38);background:linear-gradient(180deg,rgba(250,248,244,0.06),rgba(250,248,244,0.03))}

/* figure area: captioned technical plate, fixed height so all three align */
.wx-figure{
  margin:0;height:clamp(200px,17vw,236px);
  padding:18px clamp(22px,2.4vw,30px) 0;
  border-bottom:1px solid rgba(232,217,184,0.14);
  display:flex;flex-direction:column;
}
.wx-figure figcaption{
  display:flex;justify-content:space-between;
  font-family:var(--font-mono);font-size:9.5px;letter-spacing:0.16em;text-transform:uppercase;
  color:rgba(250,248,244,0.42);margin-bottom:6px;
}
.wx-figure svg{width:100%;height:auto;max-height:150px;margin:auto 0;display:block}
.wx-figure g{opacity:.82;transition:opacity var(--dur-base) var(--ease-out)}
.wx-plate:hover .wx-figure g{opacity:1}
.wx-plate:hover .sc-draw{animation:wx-draw 700ms var(--ease-out) both}
.wx-plate:hover .sc-draw.d2{animation-delay:250ms}
.wx-plate:hover .sc-draw.d3{animation-delay:450ms}
.wx-plate:hover .sc-tok{animation:wx-rise 900ms var(--ease-out) both}
.wx-plate:hover .sc-tok.t2{animation-delay:120ms}
.wx-plate:hover .sc-tok.t3{animation-delay:240ms}

/* copy: fixed rhythm so headings and lines align across plates */
.wx-copy{padding:clamp(22px,2.4vw,30px) clamp(22px,2.4vw,30px) 18px;display:flex;flex-direction:column}
.wx-copy .wx-eyebrow{margin-bottom:6px}
.wx-copy .wx-aud{margin:0 0 18px;min-height:2.6em;line-height:1.45}
.wx-copy h3{
  font-family:var(--font-display);font-weight:400;font-size:clamp(22px,1.9vw,26px);
  line-height:1.15;letter-spacing:var(--track-display);color:var(--bone);margin:0 0 10px;
}
.wx-copy p{margin:0;font-family:var(--font-body);font-size:14.5px;line-height:1.55;color:rgba(250,248,244,0.64);max-width:34ch}

.wx-plate .wx-cta{margin:0 clamp(22px,2.4vw,30px);justify-self:start;align-self:end}

.wx-neutral{
  margin:clamp(26px,3.4vh,40px) 0 0;text-align:center;
  font-family:var(--font-body);font-size:14px;color:rgba(250,248,244,0.58);
}
.wx-neutral a{color:var(--lava);text-decoration:none;font-family:var(--font-mono);font-size:12px;letter-spacing:0.08em;text-transform:uppercase;margin-left:8px;position:relative;padding-bottom:2px}
.wx-neutral a::after{content:"";position:absolute;left:0;right:calc(1.32em + 8px);bottom:0;height:1px;background:currentColor;transform:scaleX(0);transform-origin:left;transition:transform var(--dur-base) var(--ease-out)}
.wx-neutral a:hover::after{transform:scaleX(1)}
.wx-neutral a .chev{display:inline-block;width:1.2em;text-align:center;font-size:1.1em;margin-left:4px}

.whofx.wx-pre .wx-plate{opacity:0;transform:translateY(10px)}
.whofx.wx-pre .wx-plate[data-i="2"]{transition-delay:70ms}
.whofx.wx-pre .wx-plate[data-i="3"]{transition-delay:140ms}
@media(prefers-reduced-motion:reduce){.wx-plate{opacity:1;transform:none;transition:none}}



/* headings sit on one baseline across plates regardless of audience-line wrap */
.wx-copy .wx-aud{min-height:3em}



/* plates: who is the headline, one sentence, one action */
.wx-figure{padding-top:22px}
.wx-copy h3{font-size:clamp(24px,2.1vw,30px);margin-bottom:12px;display:flex;align-items:center;gap:12px}
/* diamond bullet removed on request — headings sit unadorned */
.wx-copy h3::before{display:none}
.wx-copy p{font-size:15px;line-height:1.6;color:rgba(250,248,244,0.7);max-width:36ch}



/* plates v7: address at the top, figure, promise, action; no divider */
.wx-plate{grid-template-rows:auto auto 1fr auto}
.wx-who{padding:clamp(22px,2.4vw,30px) clamp(22px,2.4vw,30px) 0;display:flex;flex-direction:column;gap:6px}
.wx-who h3{
  margin:0;display:flex;align-items:center;gap:12px;
  font-family:var(--font-display);font-weight:400;font-size:clamp(24px,2.1vw,30px);
  line-height:1.15;letter-spacing:var(--track-display);color:var(--bone);
}
.wx-who h3::before{display:none}
.wx-who .wx-aud{margin:0;font-family:var(--font-mono);font-size:10px;letter-spacing:0.08em;color:rgba(250,248,244,0.5);line-height:1.5;min-height:3em}
.wx-figure{border-bottom:none;height:clamp(170px,14vw,200px);padding-top:8px}
.wx-copy{padding-top:6px}
.wx-copy h4{
  margin:0 0 8px;
  font-family:var(--font-display);font-weight:400;font-size:clamp(19px,1.6vw,22px);
  line-height:1.2;letter-spacing:var(--track-display);color:var(--champ-light);
}
.wx-copy p{font-size:14.5px;line-height:1.55;color:rgba(250,248,244,0.66);max-width:34ch}

/* voices attribution: on narrow screens the 3-column face | who | logo row
   is too tight, so the institution mark drops to its own row below */
@media(max-width:640px){
  .vr-attr{grid-template-columns:auto 1fr;column-gap:14px;row-gap:18px;align-items:center}
  .vr-face,.vr-face.mono{width:84px;height:84px}
  .vr-who{justify-content:center;padding-bottom:0}
  .vr-who b{font-size:17px}
  .vr-sig{grid-column:1 / -1;justify-content:flex-start;padding-bottom:0}
  .vr-logo{height:24px}
  .vr-logo.seal{height:52px}
  .vr-logo.wide{height:22px}
  .vr-logo.jp{height:22px}
  .vr-logo.bis,.vr-logo.bn{height:24px}
  .vr-logo-text{font-size:18px}
  .vr-entry{min-height:420px}
}

/* closer merged with the section above: both sit on solid #15102A and a
   single lava glow spans the seam, rising through the bottom of .whofx and
   falling away through the top of .closer, so there is no visible cut. The
   spread is intentionally wide on both sides so the orange bleed reads as
   an atmospheric wash rather than a hairline seam. */
.closer{
  background-color:#15102A;
  background-image:linear-gradient(180deg,rgba(255,122,51,0.20) 0%,rgba(255,122,51,0.09) 40%,rgba(255,122,51,0) 78%);
}
.whofx{
  background-image:linear-gradient(0deg,rgba(255,122,51,0.20) 0,rgba(255,122,51,0.09) 320px,rgba(255,122,51,0) 720px);
}

`;
